import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Duration: any;
  JSON: any;
  Login: any;
  Map: any;
  MapString: any;
  /**
   * String value, a floating point number and a quantity suffix.
   * This is a modified version of the kubernetes memory resource: https://kubernetes.io/docs/concepts/configuration/manage-resources-containers/#meaning-of-memory
   * The numeric part is parsed as a 64-bit floating point number, with unbounded precision.
   * NOTE: Please be aware of the possible imprecision when converting from string representations of decimals to their floating point representation.
   */
  Memory: any;
  Object: any;
  PermissibleMutation: any;
  Time: Date;
  URL: string;
  UUID: string;
  Upload: any;
  VariableValueInput: any;
  YAML: any;
};

export type ApiKey = {
  __typename?: 'APIKey';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export type AwsAccount = {
  __typename?: 'AWSAccount';
  configuration: AwsAccountConfiguration;
  configurationRevisions: AwsAccountConfigurationConnection;
  id: Scalars['UUID'];
};


export type AwsAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type AwsAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type AwsAccountConfiguration = RevisableEntity & {
  __typename?: 'AWSAccountConfiguration';
  accountId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  principal?: Maybe<Scalars['String']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
  roleArn?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
};

export type AwsAccountConfigurationConnection = {
  __typename?: 'AWSAccountConfigurationConnection';
  nodes: Array<AwsAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ActionTriggerConfiguration = {
  __typename?: 'ActionTriggerConfiguration';
  workflowId?: Maybe<Scalars['UUID']>;
};

export type ActionTriggerConfigurationInput = {
  workflowId?: InputMaybe<Scalars['UUID']>;
};

export type AdapterStatusCriterion = {
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddClusterInput = {
  awsAccountId?: InputMaybe<Scalars['UUID']>;
  gcpAccountId?: InputMaybe<Scalars['UUID']>;
  kubeconfig?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type AddContainerRegistryInput = {
  name: Scalars['String'];
  password: Scalars['String'];
  registry: Scalars['String'];
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type AddTeamMemberInput = {
  /** The team id */
  id: Scalars['UUID'];
  role: TeamMemberRole;
  userId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum AnchorGraphQlApiVersion {
  V0 = 'v0',
  V1 = 'v1'
}

export type AutoscalingData = {
  __typename?: 'AutoscalingData';
  coolDownPeriod: Scalars['Int'];
  kedaScaledObjectSpec?: Maybe<Scalars['JSON']>;
  maxReplicas: Scalars['Int'];
  minReplicas: Scalars['Int'];
  spec: Scalars['String'];
  triggers?: Maybe<Array<Maybe<AutoscalingTrigger>>>;
};

export type AutoscalingDataInput = {
  coolDownPeriod: Scalars['Int'];
  kedaScaledObjectSpec?: InputMaybe<Scalars['JSON']>;
  maxReplicas: Scalars['Int'];
  minReplicas: Scalars['Int'];
  spec: Scalars['String'];
  triggers?: InputMaybe<Array<InputMaybe<AutoscalingTriggerInput>>>;
};

export type AutoscalingTrigger = {
  __typename?: 'AutoscalingTrigger';
  spec: Scalars['String'];
  type: Scalars['String'];
};

export type AutoscalingTriggerInput = {
  spec: Scalars['String'];
  type: Scalars['String'];
};

export type AwsSamGeneratorConfiguration = {
  __typename?: 'AwsSamGeneratorConfiguration';
  buildImage?: Maybe<Scalars['String']>;
  customDomainCertificateArn?: Maybe<Scalars['String']>;
  customDomainHost?: Maybe<Scalars['String']>;
  envVars?: Maybe<Array<EnvVar>>;
  httpPort?: Maybe<Scalars['String']>;
  runCommand?: Maybe<Scalars['String']>;
  serverlessArch?: Maybe<Scalars['String']>;
  serverlessMemory?: Maybe<Scalars['Int']>;
};

export type AwsSamGeneratorConfigurationInput = {
  buildImage?: InputMaybe<Scalars['String']>;
  customDomainCertificateArn?: InputMaybe<Scalars['String']>;
  customDomainHost?: InputMaybe<Scalars['String']>;
  envVars?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  httpPort?: InputMaybe<Scalars['String']>;
  runCommand?: InputMaybe<Scalars['String']>;
  serverlessArch?: InputMaybe<Scalars['String']>;
  serverlessMemory?: InputMaybe<Scalars['Int']>;
};

export type AwsSamTargetConfiguration = {
  __typename?: 'AwsSamTargetConfiguration';
  awsAccountId?: Maybe<Scalars['UUID']>;
  awsRegion?: Maybe<Scalars['String']>;
  stackName?: Maybe<Scalars['String']>;
};

export type AwsSamTargetConfigurationInput = {
  awsAccountId?: InputMaybe<Scalars['UUID']>;
  awsRegion?: InputMaybe<Scalars['String']>;
  stackName?: InputMaybe<Scalars['String']>;
};

export type AzureAccount = {
  __typename?: 'AzureAccount';
  configuration: AzureAccountConfiguration;
  configurationRevisions: AzureAccountConfigurationConnection;
  id: Scalars['UUID'];
};


export type AzureAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type AzureAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type AzureAccountConfiguration = RevisableEntity & {
  __typename?: 'AzureAccountConfiguration';
  name: Scalars['String'];
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type AzureAccountConfigurationConnection = {
  __typename?: 'AzureAccountConfigurationConnection';
  nodes: Array<AzureAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Blueprint = {
  __typename?: 'Blueprint';
  allowedCloudProviders: Array<CloudProvider>;
  /** Query the revision history of this blueprint. */
  configuration: BlueprintConfiguration;
  configurationRevisions: BlueprintConfigurationConnection;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  /** URL for Zeet Blueprint Documentation */
  docsUrl?: Maybe<Scalars['String']>;
  /** Whether this blueprint is enabled for your team. Does not affect existing projects. */
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  /** Whether this blueprint is officially supported. */
  isOfficial?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['String']>;
  owner?: Maybe<BlueprintOwner>;
  /** The number of projects using this blueprint. */
  projectCount: Scalars['Int'];
  published: Scalars['Boolean'];
  richInputSchema?: Maybe<Scalars['JSON']>;
  tags: Array<Scalars['String']>;
  type: BlueprintType;
  variables: Array<BlueprintVariableSpec>;
};


export type BlueprintConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type BlueprintConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type BlueprintAwsSamConfiguration = {
  __typename?: 'BlueprintAwsSamConfiguration';
  placeholder?: Maybe<Scalars['Boolean']>;
};

export type BlueprintAwsSamConfigurationInput = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintAwsSamConfigurationUpdate = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintConfiguration = RevisableEntity & {
  __typename?: 'BlueprintConfiguration';
  /** A description of the purpose and behavior of this blueprint. */
  description?: Maybe<Scalars['String']>;
  /** A display name for this blueprint. */
  displayName: Scalars['String'];
  /** Optional 'pre-built' Driver configuration for this blueprint, which can be overridden or extended by projects. */
  driverConfiguration?: Maybe<BlueprintDriverConfiguration>;
  /** A url for a logo image. */
  logoUrl?: Maybe<Scalars['String']>;
  /** Whether this blueprint is currently available to be used by projects. Does not affect existing projects. */
  published: Scalars['Boolean'];
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
  /** A schema for rich input widgets. Used to generate forms which capture the necessary configuration for instantiating a project from this blueprint. */
  richInputSchema?: Maybe<Scalars['JSON']>;
  /** An identifier for this blueprint, unique within the owner's namespace. */
  slug: Scalars['String'];
  /** Relevant classifications for this blueprint. */
  tags: Array<Scalars['String']>;
  /** Variables are key-value inputs that are rendered into a blueprint project by a Driver. */
  variables: Array<BlueprintVariableSpec>;
};

export type BlueprintConfigurationConnection = {
  __typename?: 'BlueprintConfigurationConnection';
  nodes: Array<BlueprintConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BlueprintConnection = {
  __typename?: 'BlueprintConnection';
  nodes: Array<Blueprint>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum BlueprintDriver {
  Helm = 'HELM',
  KubernetesManifest = 'KUBERNETES_MANIFEST',
  Terraform = 'TERRAFORM'
}

export enum BlueprintDriverAction {
  Apply = 'APPLY',
  Approve = 'APPROVE',
  Plan = 'PLAN',
  PlanDestroy = 'PLAN_DESTROY'
}

export type BlueprintDriverConfiguration = BlueprintHelmConfiguration | BlueprintManifestConfiguration | BlueprintTerraformConfiguration;

export type BlueprintDriverConfigurationInput = {
  helm?: InputMaybe<BlueprintHelmConfigurationInput>;
  manifest?: InputMaybe<BlueprintManifestConfigurationInput>;
  terraform?: InputMaybe<BlueprintTerraformConfigurationInput>;
};

export enum BlueprintDriverWorkflowStepAction {
  DriverApply = 'DRIVER_APPLY',
  DriverApprove = 'DRIVER_APPROVE',
  DriverPlan = 'DRIVER_PLAN',
  DriverPlanDestroy = 'DRIVER_PLAN_DESTROY',
  ProjectDelete = 'PROJECT_DELETE'
}

export enum BlueprintDriverWorkflowStepStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type BlueprintGcpCloudRunConfiguration = {
  __typename?: 'BlueprintGcpCloudRunConfiguration';
  placeholder?: Maybe<Scalars['Boolean']>;
};

export type BlueprintGcpCloudRunConfigurationInput = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintGcpCloudRunConfigurationUpdate = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintHelmConfiguration = {
  __typename?: 'BlueprintHelmConfiguration';
  source?: Maybe<Source>;
};

export type BlueprintHelmConfigurationInput = {
  source?: InputMaybe<SourceInput>;
};

export type BlueprintManifestConfiguration = {
  __typename?: 'BlueprintManifestConfiguration';
  source?: Maybe<Source>;
  useKustomize?: Maybe<Scalars['Boolean']>;
};

export type BlueprintManifestConfigurationInput = {
  source?: InputMaybe<SourceInput>;
  useKustomize?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintMetadata = {
  __typename?: 'BlueprintMetadata';
  applicationVersion?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Time']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  latestVersion?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  metatags?: Maybe<Array<Maybe<BlueprintMetadataMetaTag>>>;
  name: Scalars['String'];
  organizationDisplayName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  type: BlueprintType;
  updatedAt?: Maybe<Scalars['Time']>;
  version?: Maybe<Scalars['String']>;
  versions: Array<Scalars['String']>;
};

export type BlueprintMetadataConnection = {
  __typename?: 'BlueprintMetadataConnection';
  nodes: Array<BlueprintMetadata>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BlueprintMetadataFilter = {
  name?: InputMaybe<StringCriterion>;
};

export type BlueprintMetadataMetaTag = {
  __typename?: 'BlueprintMetadataMetaTag';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum BlueprintOutputDataSource {
  Input = 'INPUT',
  Output = 'OUTPUT',
  Resource = 'RESOURCE'
}

export type BlueprintOutputSchema = {
  __typename?: 'BlueprintOutputSchema';
  entries?: Maybe<Array<BlueprintOutputSchemaEntry>>;
};

export type BlueprintOutputSchemaEntry = {
  __typename?: 'BlueprintOutputSchemaEntry';
  dataPath?: Maybe<Scalars['String']>;
  dataSource?: Maybe<BlueprintOutputDataSource>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  transformationContext?: Maybe<BlueprintOutputTransformationContext>;
  transformations?: Maybe<Array<BlueprintOutputTransformationType>>;
  type?: Maybe<VariableType>;
};

export type BlueprintOutputTransformationContext = {
  __typename?: 'BlueprintOutputTransformationContext';
  yaml?: Maybe<BlueprintOutputTransformationYamlContext>;
};

export enum BlueprintOutputTransformationType {
  ClusterIp = 'CLUSTER_IP',
  DecodeBase64 = 'DECODE_BASE64',
  Yaml = 'YAML'
}

export type BlueprintOutputTransformationYamlContext = {
  __typename?: 'BlueprintOutputTransformationYamlContext';
  path: Scalars['String'];
};

export type BlueprintOwner = ProfileOwner & {
  __typename?: 'BlueprintOwner';
  avatar?: Maybe<Scalars['URL']>;
  login: Scalars['Login'];
  name: Scalars['String'];
};

export type BlueprintTerraformConfiguration = {
  __typename?: 'BlueprintTerraformConfiguration';
  outputConfiguration?: Maybe<TerraformOutputConfiguration>;
  source?: Maybe<Source>;
  terraformVersion?: Maybe<Scalars['String']>;
};

export type BlueprintTerraformConfigurationInput = {
  outputConfiguration?: InputMaybe<TerraformOutputConfigurationInput>;
  source?: InputMaybe<SourceInput>;
  terraformVersion?: InputMaybe<Scalars['String']>;
};

export enum BlueprintType {
  AwsSam = 'AWS_SAM',
  GcpCloudRun = 'GCP_CLOUD_RUN',
  Helm = 'HELM',
  KubernetesManifest = 'KUBERNETES_MANIFEST',
  Terraform = 'TERRAFORM',
  ZeetAwsLambda = 'ZEET_AWS_LAMBDA',
  ZeetGcpCloudRun = 'ZEET_GCP_CLOUD_RUN',
  ZeetKubernetes = 'ZEET_KUBERNETES'
}

export type BlueprintVariableInput = {
  /**
   * Name of the corresponding variable spec, or name to use when declaring a variable without referencing a variable spec.
   * Must be present if specId is not specified.
   */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the corresponding variable spec. Must be present if name is not specified. */
  specId?: InputMaybe<Scalars['UUID']>;
  /** Type specification is required when variable is being declared without referencing a variable spec. */
  type?: InputMaybe<BlueprintVariableType>;
  /**
   * The variable value. Always a string value, which will be parsed according to the variableType, determined either
   * by the referenced variableSpec, or the provided variableType
   */
  value: Scalars['VariableValueInput'];
};

export type BlueprintVariableSpec = {
  __typename?: 'BlueprintVariableSpec';
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: BlueprintVariableType;
};

export type BlueprintVariableSpecInput = {
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: BlueprintVariableType;
};

export enum BlueprintVariableType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  Json = 'JSON',
  String = 'STRING'
}

export type BlueprintsMarketplace = {
  __typename?: 'BlueprintsMarketplace';
  blueprint?: Maybe<Blueprint>;
  blueprintMetadata?: Maybe<BlueprintMetadata>;
  blueprintMetadataList?: Maybe<BlueprintMetadataConnection>;
  blueprints?: Maybe<BlueprintConnection>;
};


export type BlueprintsMarketplaceBlueprintArgs = {
  owner: Scalars['Login'];
  slug: Scalars['String'];
};


export type BlueprintsMarketplaceBlueprintMetadataArgs = {
  owner?: InputMaybe<Scalars['Login']>;
  slug: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};


export type BlueprintsMarketplaceBlueprintMetadataListArgs = {
  filter: FilterInput;
};


export type BlueprintsMarketplaceBlueprintsArgs = {
  input?: InputMaybe<BlueprintsMarketplaceInput>;
};

export type BlueprintsMarketplaceInput = {
  page?: InputMaybe<PageInput>;
  /** Sorting is applied before pagination. */
  sort?: InputMaybe<SortInput>;
};

export type BranchConfigInput = {
  containerImage?: InputMaybe<Scalars['String']>;
  environmentSlug?: InputMaybe<Scalars['String']>;
  githubSha?: InputMaybe<Scalars['String']>;
  kAppId?: InputMaybe<Scalars['String']>;
  serverlessStage?: InputMaybe<Scalars['String']>;
};

export type Build = {
  __typename?: 'Build';
  artifact?: Maybe<BuildArtifact>;
  artifacts: BuildArtifactConnection;
  definition: BuildDefinition;
  definitionRevision: BuildDefinition;
  definitionRevisions: BuildDefinitionConnection;
  id: Scalars['UUID'];
  manifests?: Maybe<Array<Maybe<BuildManifest>>>;
  run?: Maybe<BuildRun>;
  runs: BuildRunConnection;
};


export type BuildArtifactArgs = {
  id: Scalars['UUID'];
};


export type BuildArtifactsArgs = {
  input?: InputMaybe<FilterInput>;
};


export type BuildDefinitionRevisionArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type BuildDefinitionRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};


export type BuildRunArgs = {
  id: Scalars['UUID'];
};


export type BuildRunsArgs = {
  input?: InputMaybe<FilterInput>;
};

export type BuildArtifact = {
  __typename?: 'BuildArtifact';
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  image: Scalars['String'];
};

export type BuildArtifactConnection = {
  __typename?: 'BuildArtifactConnection';
  nodes: Array<BuildArtifact>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BuildConnection = {
  __typename?: 'BuildConnection';
  nodes: Array<Build>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BuildDefinition = {
  __typename?: 'BuildDefinition';
  autoRetry?: Maybe<Scalars['Boolean']>;
  buildClusterId?: Maybe<Scalars['UUID']>;
  buildCommand?: Maybe<Scalars['String']>;
  dockerfilePath?: Maybe<Scalars['String']>;
  dockerfileText?: Maybe<Scalars['String']>;
  engine?: Maybe<BuildEngine>;
  golangVersion?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  kanikoFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
  noBuildCache?: Maybe<Scalars['Boolean']>;
  nodeJsVersion?: Maybe<Scalars['String']>;
  pythonVersion?: Maybe<Scalars['String']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
  runCommand?: Maybe<Scalars['String']>;
  staticPath?: Maybe<Scalars['String']>;
  target?: Maybe<BuildTarget>;
  testCommand?: Maybe<Scalars['String']>;
  type?: Maybe<BuildType>;
  workingDirectory?: Maybe<Scalars['String']>;
};

export type BuildDefinitionConnection = {
  __typename?: 'BuildDefinitionConnection';
  nodes: Array<BuildDefinition>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BuildDefinitionInput = {
  autoRetry?: InputMaybe<Scalars['Boolean']>;
  buildAppId?: InputMaybe<Scalars['String']>;
  buildAppName?: InputMaybe<Scalars['String']>;
  buildClusterId?: InputMaybe<Scalars['UUID']>;
  buildCommand?: InputMaybe<Scalars['String']>;
  dockerfilePath?: InputMaybe<Scalars['String']>;
  dockerfileText?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<BuildEngine>;
  gitSource?: InputMaybe<GitSourceInput>;
  golangVersion?: InputMaybe<Scalars['String']>;
  kanikoFlags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  noBuildCache?: InputMaybe<Scalars['Boolean']>;
  nodeJsVersion?: InputMaybe<Scalars['String']>;
  pythonVersion?: InputMaybe<Scalars['String']>;
  runCommand?: InputMaybe<Scalars['String']>;
  staticPath?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<BuildTargetInput>;
  testCommand?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<BuildType>;
  workingDirectory?: InputMaybe<Scalars['String']>;
};

export enum BuildEngine {
  CodeBuild = 'CODE_BUILD',
  External = 'EXTERNAL',
  Kaniko = 'KANIKO'
}

export type BuildManifest = {
  __typename?: 'BuildManifest';
  kind: BuildManifestKind;
  output?: Maybe<Scalars['String']>;
};

export enum BuildManifestKind {
  Dockerfile = 'DOCKERFILE'
}

export enum BuildMethod {
  Buildpacks = 'BUILDPACKS',
  Docker = 'DOCKER',
  ElixirPhoenix = 'ELIXIR_PHOENIX',
  GolangModules = 'GOLANG_MODULES',
  Herokuish = 'HEROKUISH',
  Node = 'NODE',
  NodeNextjs = 'NODE_NEXTJS',
  NodeStatic = 'NODE_STATIC',
  Python = 'PYTHON',
  PythonDjango = 'PYTHON_DJANGO',
  Ubuntu = 'UBUNTU'
}

export type BuildRun = {
  __typename?: 'BuildRun';
  artifacts?: Maybe<Array<BuildArtifact>>;
  definition?: Maybe<BuildDefinition>;
  id: Scalars['UUID'];
  jobRun?: Maybe<JobRun>;
  manifests?: Maybe<Array<Maybe<BuildManifest>>>;
  sequence: Scalars['Int'];
  triggeredBy?: Maybe<WorkflowRun>;
};

export type BuildRunConnection = {
  __typename?: 'BuildRunConnection';
  nodes: Array<BuildRun>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BuildRunFilter = {
  ids?: InputMaybe<MultiEntityCriterion>;
};

export type BuildRunStep = WorkflowRunStep & {
  __typename?: 'BuildRunStep';
  action: GenericWorkflowStepActionType;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  logs?: Maybe<Logs>;
  outputs?: Maybe<Array<Maybe<BuildArtifact>>>;
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
};

export type BuildTarget = {
  __typename?: 'BuildTarget';
  alternativeImageTagTemplates?: Maybe<Array<Scalars['String']>>;
  integration?: Maybe<BuildTargetIntegration>;
  repository?: Maybe<Scalars['String']>;
  type: BuildTargetType;
};

export type BuildTargetInput = {
  alternativeImageTagTemplates?: InputMaybe<Array<Scalars['String']>>;
  integration?: InputMaybe<BuildTargetIntegrationInput>;
  repository?: InputMaybe<Scalars['String']>;
  type: BuildTargetType;
};

export type BuildTargetIntegration = {
  __typename?: 'BuildTargetIntegration';
  awsAccountId?: Maybe<Scalars['UUID']>;
  awsRegion?: Maybe<Scalars['String']>;
  gcpAccountId?: Maybe<Scalars['UUID']>;
  gcpRegion?: Maybe<Scalars['String']>;
  registryClusterId?: Maybe<Scalars['UUID']>;
  registryId?: Maybe<Scalars['UUID']>;
};

export type BuildTargetIntegrationInput = {
  awsAccountId?: InputMaybe<Scalars['UUID']>;
  awsRegion?: InputMaybe<Scalars['String']>;
  gcpAccountId?: InputMaybe<Scalars['UUID']>;
  gcpRegion?: InputMaybe<Scalars['String']>;
  registryClusterId?: InputMaybe<Scalars['UUID']>;
  registryId?: InputMaybe<Scalars['UUID']>;
};

export enum BuildTargetType {
  AwsSamContainerRegistry = 'AWS_SAM_CONTAINER_REGISTRY',
  ClusterRegistry = 'CLUSTER_REGISTRY',
  ContainerRegistry = 'CONTAINER_REGISTRY',
  GcpContainerRegistry = 'GCP_CONTAINER_REGISTRY',
  NullRegistry = 'NULL_REGISTRY'
}

export enum BuildType {
  Buildpacks = 'BUILDPACKS',
  Docker = 'DOCKER',
  ElixirPhoenix = 'ELIXIR_PHOENIX',
  GolangModules = 'GOLANG_MODULES',
  Herokuish = 'HEROKUISH',
  Node = 'NODE',
  NodeNextjs = 'NODE_NEXTJS',
  NodeStatic = 'NODE_STATIC',
  Python = 'PYTHON',
  PythonDjango = 'PYTHON_DJANGO',
  Ubuntu = 'UBUNTU'
}

export type BuildVariable = {
  __typename?: 'BuildVariable';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CiSource = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner: Scalars['String'];
  url: Scalars['URL'];
};

export type CertificateResource = Resource & {
  __typename?: 'CertificateResource';
  alternativeNames?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  domainName: Scalars['String'];
  externalId: Scalars['String'];
  externalLink?: Maybe<Scalars['URL']>;
  externalType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instructions?: Maybe<Array<DnsRecord>>;
  status?: Maybe<Scalars['String']>;
};

export type CheckGroupNameInput = {
  name: Scalars['String'];
};

export type CloudAccount = AwsAccount | AzureAccount | CoreWeaveAccount | DoAccount | GcpAccount | LinodeAccount | VultrAccount;

export type CloudAccountFilter = {
  __typename?: 'CloudAccountFilter';
  cloud?: Maybe<CloudProvider>;
};

export enum CloudAccountState {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
}

export type CloudInsights = {
  __typename?: 'CloudInsights';
  alerts?: Maybe<Scalars['Int']>;
  unhealthyClouds?: Maybe<Scalars['Int']>;
  unreachableClusters?: Maybe<Scalars['Int']>;
};


export type CloudInsightsAlertsArgs = {
  duration?: InputMaybe<Scalars['Duration']>;
  userId: Scalars['UUID'];
};


export type CloudInsightsUnhealthyCloudsArgs = {
  userId: Scalars['UUID'];
};


export type CloudInsightsUnreachableClustersArgs = {
  userId: Scalars['UUID'];
};

export enum CloudProvider {
  Alibaba = 'ALIBABA',
  Aws = 'AWS',
  Azure = 'AZURE',
  Coreweave = 'COREWEAVE',
  Digitalocean = 'DIGITALOCEAN',
  Gcp = 'GCP',
  Ibm = 'IBM',
  Linode = 'LINODE',
  Oci = 'OCI',
  Ovh = 'OVH',
  Scaleway = 'SCALEWAY',
  Tencent = 'TENCENT',
  Unknown = 'UNKNOWN',
  Vultr = 'VULTR',
  Zeet = 'ZEET'
}

export type CloudResource = {
  __typename?: 'CloudResource';
  createdAt?: Maybe<Scalars['Time']>;
  events?: Maybe<Array<ResourceEvent>>;
  log?: Maybe<Array<Log>>;
  metric?: Maybe<Array<MetricStream>>;
  name: Scalars['String'];
  owners?: Maybe<Array<ResourceOwner>>;
  resources?: Maybe<Array<CloudResource>>;
  status: ResourceStatus;
  type: ResourceType;
};


export type CloudResourceLogArgs = {
  clusterId: Scalars['UUID'];
  projectId: Scalars['UUID'];
};


export type CloudResourceMetricArgs = {
  clusterId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  types: Array<MetricType>;
};

export type Cluster = {
  __typename?: 'Cluster';
  cloudProvider?: Maybe<CloudProvider>;
  components?: Maybe<Array<Maybe<ClusterComponent>>>;
  configuration: ClusterConfiguration;
  configurationRevisions: ClusterConfigurationConnection;
  connected?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  deployJob?: Maybe<JobRun>;
  destroyJob?: Maybe<JobRun>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  provider?: Maybe<ClusterProvider>;
  state: ClusterState;
  status?: Maybe<ClusterStatus>;
  updatedAt: Scalars['Time'];
};


export type ClusterConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type ClusterConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type ClusterCertManager = {
  __typename?: 'ClusterCertManager';
  clusterIssuers?: Maybe<Array<Scalars['String']>>;
};

export type ClusterComponent = {
  __typename?: 'ClusterComponent';
  exists: Scalars['Boolean'];
  helmMetadata?: Maybe<HelmClusterComponentMetadata>;
  isInstalledByZeet: Scalars['Boolean'];
  name: Scalars['String'];
  project?: Maybe<Project>;
  status: ClusterComponentEjectedStatus;
  terraformMetadata?: Maybe<TerraformClusterComponentMetadata>;
  type: ClusterComponentType;
};

export enum ClusterComponentEjectedStatus {
  Detected = 'DETECTED',
  NotFound = 'NOT_FOUND'
}

export enum ClusterComponentType {
  Helm = 'HELM',
  Terraform = 'TERRAFORM'
}

export type ClusterConfiguration = RevisableEntity & {
  __typename?: 'ClusterConfiguration';
  cloudWatchRegion?: Maybe<Scalars['String']>;
  containerCacheRepository?: Maybe<Scalars['String']>;
  containerRegistry?: Maybe<ContainerRegistry>;
  containerRepository?: Maybe<Scalars['String']>;
  disableHttpIngress?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  enableGpu?: Maybe<Scalars['Boolean']>;
  enableIngressClassAnnotation?: Maybe<Scalars['Boolean']>;
  enableNatGateway?: Maybe<Scalars['Boolean']>;
  enforceSharedDedication?: Maybe<Scalars['Boolean']>;
  ingressServiceName?: Maybe<Scalars['String']>;
  ingressServiceNamespace?: Maybe<Scalars['String']>;
  /** True if the cluster is managed by Zeet, false if the cluster is external. */
  isZeetManaged?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
  serviceDomain?: Maybe<Scalars['String']>;
  stateBackend?: Maybe<TerraformStateBackend>;
  useExternalRegistry?: Maybe<Scalars['Boolean']>;
};

export type ClusterConfigurationConnection = {
  __typename?: 'ClusterConfigurationConnection';
  nodes: Array<ClusterConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ClusterPrecheckStep = WorkflowRunStep & {
  __typename?: 'ClusterPrecheckStep';
  action: GenericWorkflowStepActionType;
  cluster?: Maybe<Cluster>;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
};

export enum ClusterProvider {
  Coreweave = 'COREWEAVE',
  Doks = 'DOKS',
  Eks = 'EKS',
  Generic = 'GENERIC',
  Gke = 'GKE',
  Lke = 'LKE'
}

export enum ClusterState {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  ErrorDeleting = 'ERROR_DELETING',
  Healthy = 'HEALTHY',
  Pending = 'PENDING',
  PendingSetup = 'PENDING_SETUP'
}

export enum ClusterStatus {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  ErrorDeleting = 'ERROR_DELETING',
  Healthy = 'HEALTHY',
  Pending = 'PENDING',
  PendingSetup = 'PENDING_SETUP',
  Unreachable = 'UNREACHABLE'
}

export type ConfigureMarketplaceBlueprintInput = {
  blueprintId: Scalars['UUID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ContainerRegistry = {
  __typename?: 'ContainerRegistry';
  credentialProvider?: Maybe<ContainerRegistryCredentialProvider>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  registry: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export enum ContainerRegistryCredentialProvider {
  Docker = 'DOCKER',
  Docr = 'DOCR',
  Ecr = 'ECR',
  Gcr = 'GCR'
}

export type ContainerRegistrySource = {
  __typename?: 'ContainerRegistrySource';
  digest?: Maybe<Scalars['String']>;
  registryId?: Maybe<Scalars['UUID']>;
  registryUrl?: Maybe<Scalars['URL']>;
  repository: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type ContainerRegistrySourceInput = {
  registryId?: InputMaybe<Scalars['UUID']>;
  registryUrl?: InputMaybe<Scalars['URL']>;
  repository: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};

export type ContainerResource = Resource & {
  __typename?: 'ContainerResource';
  displayName: Scalars['String'];
  endpoints?: Maybe<Array<Scalars['String']>>;
  externalId: Scalars['String'];
  externalLink?: Maybe<Scalars['URL']>;
  externalType?: Maybe<Scalars['String']>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
  providerType: ContainerResourceProviderType;
  status?: Maybe<Scalars['String']>;
};


export type ContainerResourceMetricsArgs = {
  name: Scalars['String'];
};

export enum ContainerResourceProviderType {
  AwsSam = 'AWS_SAM',
  GcpCloudRun = 'GCP_CLOUD_RUN'
}

export type CoreWeaveAccount = {
  __typename?: 'CoreWeaveAccount';
  configuration: CoreWeaveAccountConfiguration;
  configurationRevisions: CoreWeaveAccountConfigurationConnection;
  id: Scalars['UUID'];
};


export type CoreWeaveAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type CoreWeaveAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type CoreWeaveAccountConfiguration = RevisableEntity & {
  __typename?: 'CoreWeaveAccountConfiguration';
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type CoreWeaveAccountConfigurationConnection = {
  __typename?: 'CoreWeaveAccountConfigurationConnection';
  nodes: Array<CoreWeaveAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CreateApiKeyInput = {
  name: Scalars['String'];
  userId: Scalars['UUID'];
};

export type CreateBlueprintInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  driverConfiguration?: InputMaybe<BlueprintDriverConfigurationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  richInputSchema?: InputMaybe<Scalars['JSON']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  /** The owner for this blueprint. */
  teamId: Scalars['UUID'];
  type: BlueprintType;
  variables: Array<BlueprintVariableSpecInput>;
};

export type CreateBuildInput = {
  definition?: InputMaybe<BuildDefinitionInput>;
  projectId: Scalars['UUID'];
};

export type CreateBuildRunInput = {
  buildId: Scalars['UUID'];
};

export type CreateClusterInput = {
  awsAccountId?: InputMaybe<Scalars['UUID']>;
  doAccountId?: InputMaybe<Scalars['UUID']>;
  gcpAccountId?: InputMaybe<Scalars['UUID']>;
  linodeAccountId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  region: Scalars['String'];
  userId: Scalars['UUID'];
  vultrAccountId?: InputMaybe<Scalars['UUID']>;
};

export type CreateDatadogIntegrationInput = {
  apiKey: Scalars['String'];
  userId: Scalars['UUID'];
};

export type CreateDeployInput = {
  branchName?: InputMaybe<Scalars['String']>;
  configuration?: InputMaybe<DeploymentConfigurationInput>;
  projectId: Scalars['UUID'];
};

export type CreateDeployRunInput = {
  deployId: Scalars['UUID'];
  intentId?: InputMaybe<Scalars['UUID']>;
};

export type CreateDeploymentConfigurationInput = {
  autoRetry: Scalars['Boolean'];
  autoRollback: Scalars['Boolean'];
  blueprintDriverWorkflowStepActions: Array<BlueprintDriverWorkflowStepAction>;
  branch: BranchConfigInput;
  clusterId: Scalars['UUID'];
  clusterNamespace?: InputMaybe<Scalars['String']>;
  driver: BlueprintDriver;
  instanceId: Scalars['UUID'];
  replications?: InputMaybe<Array<InputMaybe<ReplicationInput>>>;
  source: SourceInput;
};

export type CreateGitlabIntegrationInput = {
  accessToken: Scalars['String'];
  apiUrl?: InputMaybe<Scalars['URL']>;
  name?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type CreateGroupInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  name: Scalars['String'];
  teamId: Scalars['UUID'];
};

export type CreateJobInput = {
  createJobRun?: InputMaybe<Scalars['Boolean']>;
  definition?: InputMaybe<JobDefinitionInput>;
  projectId: Scalars['UUID'];
};

export type CreateJobRunInput = {
  jobId: Scalars['UUID'];
  revisionId?: InputMaybe<Scalars['UUID']>;
};

export type CreatePersonalAccessTokenInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateProjectInput = {
  blueprintId?: InputMaybe<Scalars['UUID']>;
  build?: InputMaybe<BuildDefinitionInput>;
  deploys?: InputMaybe<Array<DeploymentConfigurationInput>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  groupId?: InputMaybe<Scalars['UUID']>;
  groupName?: InputMaybe<Scalars['String']>;
  jobs?: InputMaybe<Array<JobDefinitionInput>>;
  name: Scalars['String'];
  subGroupId?: InputMaybe<Scalars['UUID']>;
  subGroupName?: InputMaybe<Scalars['String']>;
  teamId: Scalars['UUID'];
  workflow?: InputMaybe<WorkflowDefinitionInput>;
};

export type CreateSubGroupInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  groupId: Scalars['UUID'];
  name: Scalars['String'];
};

export type CreateTeamInput = {
  avatar?: InputMaybe<Scalars['String']>;
  billingEmail: Scalars['String'];
  login?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTriggerInput = {
  definition: TriggerDefinitionInput;
  parentId: Scalars['UUID'];
};

export type CreateWeb3ChallengeInput = {
  address: Scalars['String'];
};

export type CreateWebhookIntegrationInput = {
  url: Scalars['String'];
  userId: Scalars['UUID'];
};

export type CreateWorkflowInput = {
  definition?: InputMaybe<WorkflowDefinitionInput>;
  name: Scalars['String'];
  parentId: Scalars['UUID'];
  type: WorkflowType;
};

export type CronJobEventTriggerConfiguration = {
  __typename?: 'CronJobEventTriggerConfiguration';
  expression?: Maybe<Scalars['String']>;
};

export type CronJobEventTriggerConfigurationInput = {
  expression?: InputMaybe<Scalars['String']>;
};

export type DnsRecord = {
  __typename?: 'DNSRecord';
  domain: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: DnsRecordType;
  value?: Maybe<Scalars['String']>;
};

export enum DnsRecordType {
  A = 'A',
  Cname = 'CNAME',
  Txt = 'TXT'
}

export type DoAccount = {
  __typename?: 'DOAccount';
  configuration: DoAccountConfiguration;
  configurationRevisions: DoAccountConfigurationConnection;
  id: Scalars['UUID'];
};


export type DoAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type DoAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type DoAccountConfiguration = RevisableEntity & {
  __typename?: 'DOAccountConfiguration';
  name: Scalars['String'];
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type DoAccountConfigurationConnection = {
  __typename?: 'DOAccountConfigurationConnection';
  nodes: Array<DoAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DatadogIntegration = Integration & {
  __typename?: 'DatadogIntegration';
  apiKey?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

/** Queries useful for testing server behaviors. */
export type Debug = {
  __typename?: 'Debug';
  clientError: Scalars['Boolean'];
  fatalError: Scalars['Boolean'];
  serverError: Scalars['Boolean'];
};


/** Queries useful for testing server behaviors. */
export type DebugClientErrorArgs = {
  errorCode?: InputMaybe<Scalars['Boolean']>;
  userMessage?: InputMaybe<Scalars['String']>;
};


/** Queries useful for testing server behaviors. */
export type DebugServerErrorArgs = {
  errorCode?: InputMaybe<Scalars['Boolean']>;
  userMessage?: InputMaybe<Scalars['String']>;
};

export type Deploy = {
  __typename?: 'Deploy';
  branchName?: Maybe<Scalars['String']>;
  /**
   * When querying history by revisionId or sequenceId, only the revisionMetadata and revisionData will be available,
   * when querying the current configuration (neither revisionId nor sequenceId is specified), all fields _except_ revisionMetadata and revisionData will be available.
   */
  configuration?: Maybe<DeploymentConfiguration>;
  /** Only the revisionMetadata and revisionData will be available. */
  configurationRevisions?: Maybe<DeploymentConfigurationConnection>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  runs?: Maybe<DeployRunConnection>;
};


export type DeployConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type DeployConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};


export type DeployRunsArgs = {
  input?: InputMaybe<PageInput>;
};

export type DeployConnection = {
  __typename?: 'DeployConnection';
  nodes: Array<Deploy>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeployRun = {
  __typename?: 'DeployRun';
  id: Scalars['UUID'];
  intent: DeploymentIntent;
  result?: Maybe<DeploymentResult>;
  sequence: Scalars['Int'];
};

export type DeployRunConnection = {
  __typename?: 'DeployRunConnection';
  nodes: Array<DeployRun>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeployRunStep = WorkflowRunStep & {
  __typename?: 'DeployRunStep';
  action: GenericWorkflowStepActionType;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  inputs?: Maybe<Array<Maybe<BuildArtifact>>>;
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
  workflowRun?: Maybe<WorkflowRun>;
};

export enum DeployStrategy {
  Restart = 'RESTART',
  Rolling = 'ROLLING'
}

export type DeployVariable = {
  __typename?: 'DeployVariable';
  id: Scalars['UUID'];
  name: Scalars['String'];
  specId?: Maybe<Scalars['UUID']>;
  type: BlueprintVariableType;
  value: Scalars['String'];
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueFloat?: Maybe<Scalars['Float']>;
  valueInt?: Maybe<Scalars['Int']>;
  valueJson?: Maybe<Scalars['JSON']>;
  valueString?: Maybe<Scalars['String']>;
};

export type DeployableDriverActionExecutionFilter = {
  actionTypes?: InputMaybe<DriverActionTypeCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  resourceIds?: InputMaybe<MultiEntityCriterion>;
};

export type DeploymentConfiguration = RevisableEntity & {
  __typename?: 'DeploymentConfiguration';
  awsSam?: Maybe<DeploymentConfigurationAwsSam>;
  defaultWorkflowSteps: Array<BlueprintDriverWorkflowStepAction>;
  gcpCloudRun?: Maybe<DeploymentConfigurationGcpCloudRun>;
  helm?: Maybe<DeploymentConfigurationKubernetesHelm>;
  id: Scalars['UUID'];
  kubernetes?: Maybe<DeploymentConfigurationKubernetes>;
  requirePlanApproval?: Maybe<Scalars['Boolean']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
  terraform?: Maybe<DeploymentConfigurationTerraform>;
  variables: Array<DeployVariable>;
};

export type DeploymentConfigurationAwsSam = {
  __typename?: 'DeploymentConfigurationAwsSam';
  generator?: Maybe<AwsSamGeneratorConfiguration>;
  target?: Maybe<AwsSamTargetConfiguration>;
};

export type DeploymentConfigurationAwsSamInput = {
  generator?: InputMaybe<AwsSamGeneratorConfigurationInput>;
  target?: InputMaybe<AwsSamTargetConfigurationInput>;
};

export type DeploymentConfigurationConnection = {
  __typename?: 'DeploymentConfigurationConnection';
  nodes: Array<DeploymentConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeploymentConfigurationGcpCloudRun = {
  __typename?: 'DeploymentConfigurationGcpCloudRun';
  generator?: Maybe<GcpCloudRunGeneratorConfiguration>;
  target?: Maybe<GcpCloudRunTargetConfiguration>;
};

export type DeploymentConfigurationGcpCloudRunInput = {
  generator?: InputMaybe<GcpCloudRunGeneratorConfigurationInput>;
  target?: InputMaybe<GcpCloudRunTargetConfigurationInput>;
};

export type DeploymentConfigurationInput = {
  awsSam?: InputMaybe<DeploymentConfigurationAwsSamInput>;
  defaultWorkflowSteps?: InputMaybe<Array<BlueprintDriverWorkflowStepAction>>;
  gcpCloudRun?: InputMaybe<DeploymentConfigurationGcpCloudRunInput>;
  helm?: InputMaybe<DeploymentConfigurationKubernetesHelmInput>;
  kubernetes?: InputMaybe<DeploymentConfigurationKubernetesInput>;
  requirePlanApproval?: InputMaybe<Scalars['Boolean']>;
  terraform?: InputMaybe<DeploymentConfigurationTerraformInput>;
  variables?: InputMaybe<Array<BlueprintVariableInput>>;
};

export type DeploymentConfigurationKubernetes = {
  __typename?: 'DeploymentConfigurationKubernetes';
  blueprint?: Maybe<BlueprintManifestConfiguration>;
  generator?: Maybe<KubernetesGeneratorConfiguration>;
  target?: Maybe<ManifestTargetConfiguration>;
};

export type DeploymentConfigurationKubernetesHelm = {
  __typename?: 'DeploymentConfigurationKubernetesHelm';
  blueprint?: Maybe<BlueprintHelmConfiguration>;
  target?: Maybe<HelmTargetConfiguration>;
  values?: Maybe<Scalars['YAML']>;
};

export type DeploymentConfigurationKubernetesHelmInput = {
  blueprint?: InputMaybe<BlueprintHelmConfigurationInput>;
  target?: InputMaybe<HelmTargetConfigurationInput>;
  values?: InputMaybe<Scalars['YAML']>;
};

export type DeploymentConfigurationKubernetesInput = {
  blueprint?: InputMaybe<BlueprintManifestConfigurationInput>;
  generator?: InputMaybe<KubernetesGeneratorConfigurationInput>;
  target?: InputMaybe<ManifestTargetConfigurationInput>;
};

export type DeploymentConfigurationTerraform = {
  __typename?: 'DeploymentConfigurationTerraform';
  blueprint?: Maybe<BlueprintTerraformConfiguration>;
  target?: Maybe<TerraformTargetConfiguration>;
};

export type DeploymentConfigurationTerraformInput = {
  blueprint?: InputMaybe<BlueprintTerraformConfigurationInput>;
  target?: InputMaybe<TerraformTargetConfigurationInput>;
};

export type DeploymentIntent = {
  __typename?: 'DeploymentIntent';
  configuration: DeploymentConfiguration;
  id: Scalars['UUID'];
};

export type DeploymentResult = {
  __typename?: 'DeploymentResult';
  resources: ResourceConnection;
};


export type DeploymentResultResourcesArgs = {
  input?: InputMaybe<PageInput>;
};

export enum DeploymentStatus {
  Deprovisioning = 'DEPROVISIONING',
  Healthy = 'HEALTHY',
  Inactive = 'INACTIVE',
  Provisioning = 'PROVISIONING',
  Unhealthy = 'UNHEALTHY',
  Unknown = 'UNKNOWN'
}

export type DeploymentTimestamps = {
  __typename?: 'DeploymentTimestamps';
  lastDeployedAt?: Maybe<Scalars['Time']>;
  lastUpdatedAt?: Maybe<Scalars['Time']>;
};

export type DestroyRunStep = WorkflowRunStep & {
  __typename?: 'DestroyRunStep';
  action: GenericWorkflowStepActionType;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  inputs?: Maybe<Array<Maybe<BuildArtifact>>>;
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
  workflowRun?: Maybe<WorkflowRun>;
};

export type DiscordIntegration = Integration & {
  __typename?: 'DiscordIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type DiscordWebhookIntegration = Integration & {
  __typename?: 'DiscordWebhookIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  url?: Maybe<Scalars['String']>;
};

export type DockerImage = {
  __typename?: 'DockerImage';
  digest: Scalars['String'];
  id: Scalars['ID'];
  repository: DockerRepository;
  tag: Scalars['String'];
};

export type DockerRepository = CiSource & {
  __typename?: 'DockerRepository';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<DockerImage>;
  images?: Maybe<Array<DockerImage>>;
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  ports?: Maybe<Array<Port>>;
  url: Scalars['URL'];
  volumes?: Maybe<Array<VolumeSpec>>;
};


export type DockerRepositoryImageArgs = {
  tag: Scalars['String'];
};

export type DriverActionTypeCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Array<InputMaybe<BlueprintDriverAction>>>;
};

export enum DriverWorkflowStepActionType {
  DriverApply = 'DRIVER_APPLY',
  DriverApprove = 'DRIVER_APPROVE',
  DriverPlan = 'DRIVER_PLAN',
  DriverPlanDestroy = 'DRIVER_PLAN_DESTROY',
  ProjectDelete = 'PROJECT_DELETE'
}

export type DuplicateProjectInput = {
  groupId?: InputMaybe<Scalars['UUID']>;
  groupName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  subGroupId?: InputMaybe<Scalars['UUID']>;
  subGroupName?: InputMaybe<Scalars['String']>;
};

export type EjectClusterComponentInput = {
  groupName: Scalars['String'];
  name: Scalars['String'];
  projectName: Scalars['String'];
  subGroupName: Scalars['String'];
  type: ClusterComponentType;
};

export type EndpointResource = Resource & {
  __typename?: 'EndpointResource';
  displayName: Scalars['String'];
  endpoints?: Maybe<Array<Scalars['String']>>;
  externalId: Scalars['String'];
  externalLink?: Maybe<Scalars['URL']>;
  externalType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
};

export type EnvVar = {
  __typename?: 'EnvVar';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sealed: Scalars['Boolean'];
  source?: Maybe<EnvVarSource>;
  updatedAt: Scalars['Time'];
  value: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type EnvVarInput = {
  name: Scalars['String'];
  sealed?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type EnvVarSource = {
  __typename?: 'EnvVarSource';
  type: EnvVarSourceType;
};

export enum EnvVarSourceType {
  Cluster = 'CLUSTER',
  Group = 'GROUP',
  Project = 'PROJECT',
  ProjectLink = 'PROJECT_LINK',
  Subgroup = 'SUBGROUP',
  Zeet = 'ZEET'
}

export type EventTriggerConfiguration = {
  __typename?: 'EventTriggerConfiguration';
  cronJob?: Maybe<CronJobEventTriggerConfiguration>;
  git?: Maybe<GitEventTriggerConfiguration>;
};

export type EventTriggerConfigurationInput = {
  cronJob?: InputMaybe<CronJobEventTriggerConfigurationInput>;
  git?: InputMaybe<GitEventTriggerConfigurationInput>;
};

export type FilterCriterion = {
  blueprintMetadataFilter?: InputMaybe<BlueprintMetadataFilter>;
  buildRunFilter?: InputMaybe<BuildRunFilter>;
  deployableDriverActionExecutionFilter?: InputMaybe<DeployableDriverActionExecutionFilter>;
  projectFilter?: InputMaybe<ProjectFilterCriterion>;
  repoFilter?: InputMaybe<RepoFilter>;
  resourceAdapterFilter?: InputMaybe<ResourceAdapterFilter>;
  resourceFilter?: InputMaybe<ResourceFilter>;
  userFilter?: InputMaybe<UserFilter>;
  workflowRunFilter?: InputMaybe<WorkflowRunFilter>;
};

export enum FilterCriterionOperatorType {
  Contains = 'CONTAINS',
  Ends = 'ENDS',
  Equals = 'EQUALS',
  Excludes = 'EXCLUDES',
  Includes = 'INCLUDES',
  NotEquals = 'NOT_EQUALS',
  Starts = 'STARTS'
}

export type FilterInput = {
  filter: FilterNode;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<SortInput>;
};

export type FilterNode = {
  criterion?: InputMaybe<FilterCriterion>;
};

export type GcpAccount = {
  __typename?: 'GCPAccount';
  configuration: GcpAccountConfiguration;
  configurationRevisions: GcpAccountConfigurationConnection;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  updatedAt: Scalars['Time'];
};


export type GcpAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type GcpAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type GcpAccountConfiguration = RevisableEntity & {
  __typename?: 'GCPAccountConfiguration';
  name: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type GcpAccountConfigurationConnection = {
  __typename?: 'GCPAccountConfigurationConnection';
  nodes: Array<GcpAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type GcsBucketBackendInput = {
  bucketName: Scalars['String'];
  gcpAccountId: Scalars['UUID'];
  location?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

export type GcsBucketConfiguration = {
  __typename?: 'GCSBucketConfiguration';
  bucketName: Scalars['String'];
  gcpAccountId: Scalars['UUID'];
  location: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
};

export type GcpCloudRunGeneratorConfiguration = {
  __typename?: 'GcpCloudRunGeneratorConfiguration';
  containerCpu?: Maybe<Scalars['Float']>;
  containerMemory?: Maybe<Scalars['Float']>;
  envVars?: Maybe<Array<EnvVar>>;
  httpPort?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  runCommand?: Maybe<Scalars['String']>;
};

export type GcpCloudRunGeneratorConfigurationInput = {
  containerCpu?: InputMaybe<Scalars['Float']>;
  containerMemory?: InputMaybe<Scalars['Float']>;
  envVars?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  httpPort?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  runCommand?: InputMaybe<Scalars['String']>;
};

export type GcpCloudRunTargetConfiguration = {
  __typename?: 'GcpCloudRunTargetConfiguration';
  gcpAccountId?: Maybe<Scalars['UUID']>;
  gcpRegion?: Maybe<Scalars['String']>;
};

export type GcpCloudRunTargetConfigurationInput = {
  gcpAccountId?: InputMaybe<Scalars['UUID']>;
  gcpRegion?: InputMaybe<Scalars['String']>;
};

export enum GenericWorkflowStepActionType {
  DriverApply = 'DRIVER_APPLY',
  DriverApprove = 'DRIVER_APPROVE',
  DriverPlan = 'DRIVER_PLAN',
  DriverPlanDestroy = 'DRIVER_PLAN_DESTROY',
  OrchestrationBuild = 'ORCHESTRATION_BUILD',
  OrchestrationClusterPrecheck = 'ORCHESTRATION_CLUSTER_PRECHECK',
  OrchestrationDeploy = 'ORCHESTRATION_DEPLOY',
  OrchestrationDestroy = 'ORCHESTRATION_DESTROY',
  OrchestrationRelease = 'ORCHESTRATION_RELEASE',
  ProjectDelete = 'PROJECT_DELETE'
}

export type GitBranch = {
  __typename?: 'GitBranch';
  commit: GitCommit;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GitCommit = {
  __typename?: 'GitCommit';
  abbreviatedOid: Scalars['String'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  message: Scalars['String'];
  oid: Scalars['String'];
};

export type GitEventTriggerConfiguration = {
  __typename?: 'GitEventTriggerConfiguration';
  githubConnectionId?: Maybe<Scalars['Int']>;
  repoBranchName?: Maybe<Scalars['String']>;
  repoId?: Maybe<Scalars['String']>;
  repoName?: Maybe<Scalars['String']>;
  repoOwner?: Maybe<Scalars['String']>;
};

export type GitEventTriggerConfigurationInput = {
  githubConnectionId?: InputMaybe<Scalars['Int']>;
  repoBranchName?: InputMaybe<Scalars['String']>;
  repoId?: InputMaybe<Scalars['String']>;
  repoName?: InputMaybe<Scalars['String']>;
  repoOwner?: InputMaybe<Scalars['String']>;
};

export type GitHubInstallation = {
  __typename?: 'GitHubInstallation';
  account: GitHubUser;
  appId: Scalars['Int'];
  id: Scalars['ID'];
  repositories?: Maybe<Array<GitHubRepository>>;
  repositorySelection: Scalars['String'];
};

export type GitHubRepository = CiSource & GitRepository & {
  __typename?: 'GitHubRepository';
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  ports?: Maybe<Array<Port>>;
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerId: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
  volumes?: Maybe<Array<VolumeSpec>>;
};

export type GitHubUser = {
  __typename?: 'GitHubUser';
  avatar?: Maybe<Scalars['URL']>;
  id: Scalars['ID'];
  login: Scalars['String'];
  type: GithubUserType;
};

export enum GitProvider {
  Bitbucket = 'BITBUCKET',
  Github = 'GITHUB',
  Gitlab = 'GITLAB'
}

export type GitRepository = {
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerId: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
};

export type GitSource = {
  __typename?: 'GitSource';
  integration?: Maybe<GitSourceIntegration>;
  path?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  repository: Scalars['String'];
};

export type GitSourceInput = {
  integration?: InputMaybe<GitSourceIntegrationInput>;
  path?: InputMaybe<Scalars['String']>;
  ref?: InputMaybe<Scalars['String']>;
  repository: Scalars['String'];
};

export type GitSourceIntegration = {
  __typename?: 'GitSourceIntegration';
  bitbucketIntegrationId?: Maybe<Scalars['UUID']>;
  githubInstallationId?: Maybe<Scalars['Int']>;
  githubIntegrationId?: Maybe<Scalars['UUID']>;
  gitlabIntegrationId?: Maybe<Scalars['UUID']>;
};

export type GitSourceIntegrationInput = {
  bitbucketIntegrationId?: InputMaybe<Scalars['UUID']>;
  githubInstallationId?: InputMaybe<Scalars['Int']>;
  githubIntegrationId?: InputMaybe<Scalars['UUID']>;
  gitlabIntegrationId?: InputMaybe<Scalars['UUID']>;
};

export type GithubConnectionInput = {
  apiUrl?: InputMaybe<Scalars['URL']>;
  installation: Scalars['String'];
  owner: Scalars['String'];
  repo: Scalars['String'];
};

export enum GithubUserType {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type GitlabIntegration = Integration & {
  __typename?: 'GitlabIntegration';
  accessTokenPrefix?: Maybe<Scalars['String']>;
  apiUrl: Scalars['URL'];
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  webhookToken: Scalars['String'];
  webhookUrl: Scalars['URL'];
};

export type GitlabRepository = CiSource & GitRepository & {
  __typename?: 'GitlabRepository';
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerId: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
};

export type Grafana = {
  __typename?: 'Grafana';
  password?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  user?: Maybe<Scalars['String']>;
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['Time'];
  deploymentTimestamps?: Maybe<DeploymentTimestamps>;
  envs?: Maybe<Array<EnvVar>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  owner: Team;
  subGroup: SubGroup;
  subGroups: Array<SubGroup>;
  updatedAt: Scalars['Time'];
};


export type GroupSubGroupArgs = {
  id: Scalars['UUID'];
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  edges: Array<GroupEdge>;
  nodes: Array<Group>;
  pageInfo: PageInfo;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String'];
  node: Group;
};

export type GroupFilter = {
  id?: InputMaybe<MultiEntityCriterion>;
  name?: InputMaybe<StringCriterion>;
};

export type GroupOwner = {
  groups: GroupConnection;
};


export type GroupOwnerGroupsArgs = {
  input?: InputMaybe<GroupsInput>;
};

export type GroupsInput = {
  filter?: InputMaybe<GroupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<SortInput>;
};

export type HttpProbe = {
  __typename?: 'HTTPProbe';
  host: Scalars['String'];
  path: Scalars['String'];
  port: Scalars['String'];
};

export type HttpProbeInput = {
  host: Scalars['String'];
  path: Scalars['String'];
  port: Scalars['String'];
};

export type HelmChart = {
  __typename?: 'HelmChart';
  appVersion?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoImage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['String']>;
  repository: HelmRepository;
  stars?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type HelmChartConnection = {
  __typename?: 'HelmChartConnection';
  nodes: Array<HelmChart>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HelmClusterComponentMetadata = {
  __typename?: 'HelmClusterComponentMetadata';
  chartName: Scalars['String'];
  chartRepoGuess?: Maybe<Scalars['String']>;
  chartVersion: Scalars['String'];
  namespace: Scalars['String'];
  releaseName: Scalars['String'];
  values: Scalars['String'];
};

export type HelmRelease = {
  __typename?: 'HelmRelease';
  chart: HelmChart;
  id: Scalars['String'];
  version: Scalars['String'];
};

export type HelmRepository = {
  __typename?: 'HelmRepository';
  chart: HelmChart;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type HelmRepositoryChartArgs = {
  name: Scalars['String'];
};

export type HelmRepositorySource = {
  __typename?: 'HelmRepositorySource';
  chart: Scalars['String'];
  repositoryUrl: Scalars['URL'];
  version?: Maybe<Scalars['String']>;
};

export type HelmRepositorySourceInput = {
  chart: Scalars['String'];
  repositoryUrl: Scalars['URL'];
  version?: InputMaybe<Scalars['String']>;
};

export type HelmTargetConfiguration = {
  __typename?: 'HelmTargetConfiguration';
  clusterId: Scalars['UUID'];
  namespace?: Maybe<Scalars['String']>;
  releaseName?: Maybe<Scalars['String']>;
};

export type HelmTargetConfigurationInput = {
  clusterId: Scalars['UUID'];
  namespace?: InputMaybe<Scalars['String']>;
  releaseName?: InputMaybe<Scalars['String']>;
};

export type Insights = {
  __typename?: 'Insights';
  cloud?: Maybe<CloudInsights>;
};

export type Integration = {
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export enum IntegrationType {
  Bitbucket = 'BITBUCKET',
  Datadog = 'DATADOG',
  Discord = 'DISCORD',
  DiscordWebhook = 'DISCORD_WEBHOOK',
  Email = 'EMAIL',
  Gitlab = 'GITLAB',
  Slack = 'SLACK',
  SlackWebhook = 'SLACK_WEBHOOK'
}

export type InviteTeamMemberInput = {
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Time']>;
  id: Scalars['UUID'];
  role: TeamMemberRole;
};

export type Job = {
  __typename?: 'Job';
  definition: JobDefinition;
  id: Scalars['UUID'];
  run?: Maybe<JobRun>;
  runs: JobRunConnection;
};


export type JobRunArgs = {
  id: Scalars['UUID'];
};


export type JobRunsArgs = {
  input?: InputMaybe<FilterInput>;
};

export type JobConnection = {
  __typename?: 'JobConnection';
  nodes: Array<Job>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type JobDefinition = {
  __typename?: 'JobDefinition';
  annotations?: Maybe<Scalars['MapString']>;
  appGeneratorVersion?: Maybe<Scalars['String']>;
  awsIamRole?: Maybe<Scalars['String']>;
  betterstackToken?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  clusterId?: Maybe<Scalars['String']>;
  containerRegistry?: Maybe<ContainerRegistrySource>;
  cpuRequest?: Maybe<Scalars['String']>;
  datadogApmEnabled?: Maybe<Scalars['Boolean']>;
  datadogHost?: Maybe<Scalars['String']>;
  datadogKey?: Maybe<Scalars['String']>;
  dedicated?: Maybe<Scalars['Boolean']>;
  dockerCommand?: Maybe<Array<Maybe<Scalars['String']>>>;
  dockerEntrypoint?: Maybe<Array<Maybe<Scalars['String']>>>;
  envVars?: Maybe<Array<Maybe<EnvVar>>>;
  ephemeralStorage?: Maybe<Scalars['String']>;
  gcpServiceAccount?: Maybe<Scalars['String']>;
  gpuRequest?: Maybe<Scalars['String']>;
  gpuType?: Maybe<Scalars['String']>;
  hostNetwork?: Maybe<Scalars['Boolean']>;
  jobName?: Maybe<Scalars['String']>;
  jobNamespace?: Maybe<Scalars['String']>;
  legacyRepo?: Maybe<LegacyRepo>;
  logDnaKey?: Maybe<Scalars['String']>;
  logShipperType?: Maybe<LogShipperType>;
  logzToken?: Maybe<Scalars['String']>;
  logzUrl?: Maybe<Scalars['String']>;
  memoryRequest?: Maybe<Scalars['String']>;
  nodeSelector?: Maybe<Scalars['MapString']>;
  parallelism?: Maybe<Scalars['Int']>;
  podSpecPatch?: Maybe<Scalars['String']>;
  productionBranchName?: Maybe<Scalars['String']>;
  secretMounts?: Maybe<Array<Maybe<SecretMountData>>>;
  serviceAccountName?: Maybe<Scalars['String']>;
  staticIp?: Maybe<Scalars['Boolean']>;
  syslogConfig?: Maybe<Scalars['String']>;
  timeoutSeconds?: Maybe<Scalars['Int']>;
  tpuCores?: Maybe<Scalars['Int']>;
  tpuTfVersion?: Maybe<Scalars['String']>;
  tpuType?: Maybe<Scalars['String']>;
  volumes?: Maybe<Array<Maybe<VolumeSpec>>>;
};

export type JobDefinitionInput = {
  annotations?: InputMaybe<Scalars['MapString']>;
  appGeneratorVersion?: InputMaybe<Scalars['String']>;
  awsIamRole?: InputMaybe<Scalars['String']>;
  betterstackToken?: InputMaybe<Scalars['String']>;
  branchName?: InputMaybe<Scalars['String']>;
  clusterId?: InputMaybe<Scalars['String']>;
  containerRegistry?: InputMaybe<ContainerRegistrySourceInput>;
  cpuRequest?: InputMaybe<Scalars['String']>;
  datadogApmEnabled?: InputMaybe<Scalars['Boolean']>;
  datadogHost?: InputMaybe<Scalars['String']>;
  datadogKey?: InputMaybe<Scalars['String']>;
  dedicated?: InputMaybe<Scalars['Boolean']>;
  dockerCommand?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dockerEntrypoint?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  envVars?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  ephemeralStorage?: InputMaybe<Scalars['String']>;
  gcpServiceAccount?: InputMaybe<Scalars['String']>;
  gpuRequest?: InputMaybe<Scalars['String']>;
  gpuType?: InputMaybe<Scalars['String']>;
  hostNetwork?: InputMaybe<Scalars['Boolean']>;
  jobName?: InputMaybe<Scalars['String']>;
  jobNamespace?: InputMaybe<Scalars['String']>;
  logDnaKey?: InputMaybe<Scalars['String']>;
  logShipperType?: InputMaybe<LogShipperType>;
  logzToken?: InputMaybe<Scalars['String']>;
  logzUrl?: InputMaybe<Scalars['String']>;
  memoryRequest?: InputMaybe<Scalars['String']>;
  nodeSelector?: InputMaybe<Scalars['MapString']>;
  parallelism?: InputMaybe<Scalars['Int']>;
  podSpecPatch?: InputMaybe<Scalars['String']>;
  productionBranchName?: InputMaybe<Scalars['String']>;
  secretMounts?: InputMaybe<Array<InputMaybe<SecretMountDataInput>>>;
  serviceAccountName?: InputMaybe<Scalars['String']>;
  staticIp?: InputMaybe<Scalars['Boolean']>;
  syslogConfig?: InputMaybe<Scalars['String']>;
  timeoutSeconds?: InputMaybe<Scalars['Int']>;
  tpuCores?: InputMaybe<Scalars['Int']>;
  tpuTfVersion?: InputMaybe<Scalars['String']>;
  tpuType?: InputMaybe<Scalars['String']>;
  volumes?: InputMaybe<Array<InputMaybe<VolumeSpecInput>>>;
};

export type JobRun = {
  __typename?: 'JobRun';
  command: Scalars['String'];
  createdAt: Scalars['Time'];
  definition: JobDefinition;
  errorMessage?: Maybe<Scalars['String']>;
  exitCode?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  job?: Maybe<Job>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
  sequence?: Maybe<Scalars['Int']>;
  state: JobRunState;
  updatedAt: Scalars['Time'];
};


export type JobRunMetricsArgs = {
  name: Scalars['String'];
};

export type JobRunConnection = {
  __typename?: 'JobRunConnection';
  nodes: Array<JobRun>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum JobRunState {
  JobRunFailed = 'JOB_RUN_FAILED',
  JobRunPendingApproval = 'JOB_RUN_PENDING_APPROVAL',
  JobRunPendingBuild = 'JOB_RUN_PENDING_BUILD',
  JobRunRunning = 'JOB_RUN_RUNNING',
  JobRunStarting = 'JOB_RUN_STARTING',
  JobRunSucceeded = 'JOB_RUN_SUCCEEDED'
}

export type JobRunStep = WorkflowRunStep & {
  __typename?: 'JobRunStep';
  action: GenericWorkflowStepActionType;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  logs?: Maybe<Logs>;
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
};

export type KubernetesGeneratorConfiguration = {
  __typename?: 'KubernetesGeneratorConfiguration';
  annotations?: Maybe<Scalars['MapString']>;
  appGeneratorVersion: Scalars['String'];
  appId: Scalars['String'];
  autoscaling?: Maybe<AutoscalingData>;
  awsIamRole?: Maybe<Scalars['String']>;
  betterstackToken?: Maybe<Scalars['String']>;
  branchName: Scalars['String'];
  containerRegistrySource?: Maybe<ContainerRegistrySource>;
  cpuRequest?: Maybe<Scalars['String']>;
  datadogApmEnabled?: Maybe<Scalars['Boolean']>;
  datadogHost?: Maybe<Scalars['String']>;
  datadogKey?: Maybe<Scalars['String']>;
  dedicated?: Maybe<Scalars['Boolean']>;
  defaultIngressDomain?: Maybe<Scalars['String']>;
  deployStrategy?: Maybe<DeployStrategy>;
  dockerCommand?: Maybe<Array<Maybe<Scalars['String']>>>;
  dockerEntrypoint?: Maybe<Array<Maybe<Scalars['String']>>>;
  endpoint?: Maybe<Scalars['String']>;
  envs?: Maybe<Array<Maybe<EnvVar>>>;
  ephemeralStorage?: Maybe<Scalars['String']>;
  gcpServiceAccount?: Maybe<Scalars['String']>;
  gpuRequest?: Maybe<Scalars['String']>;
  gpuType?: Maybe<Scalars['String']>;
  hostNetwork?: Maybe<Scalars['Boolean']>;
  legacyRepo?: Maybe<LegacyRepo>;
  livenessProbe?: Maybe<ProbeData>;
  logDnaKey?: Maybe<Scalars['String']>;
  logShipperType?: Maybe<LogShipperType>;
  logzToken?: Maybe<Scalars['String']>;
  logzUrl?: Maybe<Scalars['String']>;
  memoryRequest?: Maybe<Scalars['String']>;
  nodeSelector?: Maybe<Scalars['MapString']>;
  podSpecPatch?: Maybe<Scalars['String']>;
  ports?: Maybe<Array<Maybe<PortData>>>;
  preStopSleep?: Maybe<Scalars['Int']>;
  productionBranchName: Scalars['String'];
  readinessProbe?: Maybe<ProbeData>;
  replicas?: Maybe<Scalars['Int']>;
  secretMounts?: Maybe<Array<Maybe<SecretMountData>>>;
  serviceAccountName?: Maybe<Scalars['String']>;
  serviceAnnotations?: Maybe<Scalars['MapString']>;
  startupProbe?: Maybe<ProbeData>;
  staticIp?: Maybe<Scalars['Boolean']>;
  syslogConfig?: Maybe<Scalars['String']>;
  terminationGracePeriodSeconds?: Maybe<Scalars['Int']>;
  tpuCores?: Maybe<Scalars['Int']>;
  tpuTfVersion?: Maybe<Scalars['String']>;
  tpuType?: Maybe<Scalars['String']>;
  volumes?: Maybe<Array<Maybe<VolumeSpec>>>;
};

export type KubernetesGeneratorConfigurationInput = {
  annotations?: InputMaybe<Scalars['MapString']>;
  appGeneratorVersion: Scalars['String'];
  appId: Scalars['String'];
  autoscaling?: InputMaybe<AutoscalingDataInput>;
  awsIamRole?: InputMaybe<Scalars['String']>;
  betterstackToken?: InputMaybe<Scalars['String']>;
  branchName: Scalars['String'];
  containerRegistrySource?: InputMaybe<ContainerRegistrySourceInput>;
  cpuRequest?: InputMaybe<Scalars['String']>;
  datadogApmEnabled?: InputMaybe<Scalars['Boolean']>;
  datadogHost?: InputMaybe<Scalars['String']>;
  datadogKey?: InputMaybe<Scalars['String']>;
  dedicated?: InputMaybe<Scalars['Boolean']>;
  defaultIngressDomain?: InputMaybe<Scalars['String']>;
  deployStrategy?: InputMaybe<DeployStrategy>;
  dockerCommand?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dockerEntrypoint?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endpoint?: InputMaybe<Scalars['String']>;
  envs?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  ephemeralStorage?: InputMaybe<Scalars['String']>;
  gcpServiceAccount?: InputMaybe<Scalars['String']>;
  gpuRequest?: InputMaybe<Scalars['String']>;
  gpuType?: InputMaybe<Scalars['String']>;
  hostNetwork?: InputMaybe<Scalars['Boolean']>;
  livenessProbe?: InputMaybe<ProbeDataInput>;
  logDnaKey?: InputMaybe<Scalars['String']>;
  logShipperType?: InputMaybe<LogShipperType>;
  logzToken?: InputMaybe<Scalars['String']>;
  logzUrl?: InputMaybe<Scalars['String']>;
  memoryRequest?: InputMaybe<Scalars['String']>;
  nodeSelector?: InputMaybe<Scalars['MapString']>;
  podSpecPatch?: InputMaybe<Scalars['String']>;
  ports?: InputMaybe<Array<InputMaybe<PortDataInput>>>;
  preStopSleep?: InputMaybe<Scalars['Int']>;
  productionBranchName: Scalars['String'];
  readinessProbe?: InputMaybe<ProbeDataInput>;
  replicas?: InputMaybe<Scalars['Int']>;
  secretMounts?: InputMaybe<Array<InputMaybe<SecretMountDataInput>>>;
  serviceAccountName?: InputMaybe<Scalars['String']>;
  serviceAnnotations?: InputMaybe<Scalars['MapString']>;
  startupProbe?: InputMaybe<ProbeDataInput>;
  staticIp?: InputMaybe<Scalars['Boolean']>;
  syslogConfig?: InputMaybe<Scalars['String']>;
  terminationGracePeriodSeconds?: InputMaybe<Scalars['Int']>;
  tpuCores?: InputMaybe<Scalars['Int']>;
  tpuTfVersion?: InputMaybe<Scalars['String']>;
  tpuType?: InputMaybe<Scalars['String']>;
  volumes?: InputMaybe<Array<InputMaybe<VolumeSpecInput>>>;
};

export enum LabelSelectorOperator {
  DoesNotExist = 'DoesNotExist',
  Exists = 'Exists',
  In = 'In',
  NotIn = 'NotIn'
}

export type LabelSelectorRequirement = {
  __typename?: 'LabelSelectorRequirement';
  key: Scalars['String'];
  operator: LabelSelectorOperator;
  values?: Maybe<Array<Scalars['String']>>;
};

export type LabelSelectorRequirementInput = {
  key: Scalars['String'];
  operator: LabelSelectorOperator;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type LabelSelectors = {
  __typename?: 'LabelSelectors';
  matchExpressions?: Maybe<Array<LabelSelectorRequirement>>;
  matchLabels?: Maybe<Scalars['MapString']>;
};

export type LabelSelectorsInput = {
  matchExpressions?: InputMaybe<Array<LabelSelectorRequirementInput>>;
  matchLabels?: InputMaybe<Scalars['MapString']>;
};

export type LegacyRepo = {
  __typename?: 'LegacyRepo';
  appId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LinkCloudToClusterInput = {
  cloudAz?: InputMaybe<Scalars['String']>;
  cloudId: Scalars['UUID'];
  cloudRegion?: InputMaybe<Scalars['String']>;
  cloudType: CloudProvider;
  clusterId: Scalars['UUID'];
};

export type LinodeAccount = {
  __typename?: 'LinodeAccount';
  configuration: LinodeAccountConfiguration;
  configurationRevisions: LinodeAccountConfigurationConnection;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  updatedAt: Scalars['Time'];
};


export type LinodeAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type LinodeAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type LinodeAccountConfiguration = RevisableEntity & {
  __typename?: 'LinodeAccountConfiguration';
  name: Scalars['String'];
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type LinodeAccountConfigurationConnection = {
  __typename?: 'LinodeAccountConfigurationConnection';
  nodes: Array<LinodeAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LinodeBucketBackendInput = {
  accessKey: Scalars['String'];
  bucketName: Scalars['String'];
  key: Scalars['String'];
  linodeAccountId: Scalars['UUID'];
  region: Scalars['String'];
  secretAccessKey: Scalars['String'];
};

export type LinodeBucketConfiguration = {
  __typename?: 'LinodeBucketConfiguration';
  accessKey: Scalars['String'];
  bucketName: Scalars['String'];
  key: Scalars['String'];
  linodeAccountId: Scalars['UUID'];
  region: Scalars['String'];
  secretAccessKey: Scalars['String'];
};

export type Log = {
  __typename?: 'Log';
  entries?: Maybe<Array<LogEntry>>;
  name: Scalars['String'];
};

export type LogEntry = {
  __typename?: 'LogEntry';
  text: Scalars['String'];
  timestamp?: Maybe<Scalars['Time']>;
};

export enum LogShipperType {
  Betterstack = 'BETTERSTACK',
  Datadog = 'DATADOG',
  Logdna = 'LOGDNA',
  Logzio = 'LOGZIO',
  Syslog = 'SYSLOG'
}

export enum LogSourceType {
  PodLive = 'POD_LIVE'
}

export type Logs = {
  __typename?: 'Logs';
  completed: Scalars['Boolean'];
  cursor?: Maybe<Scalars['String']>;
  entries?: Maybe<Array<LogEntry>>;
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type ManifestTargetConfiguration = {
  __typename?: 'ManifestTargetConfiguration';
  clusterId: Scalars['UUID'];
  namespace?: Maybe<Scalars['String']>;
};

export type ManifestTargetConfigurationInput = {
  clusterId: Scalars['UUID'];
  namespace?: InputMaybe<Scalars['String']>;
};

export type Metric = {
  __typename?: 'Metric';
  timestamp: Scalars['Time'];
  value?: Maybe<Scalars['Float']>;
};

export type MetricAnnotation = {
  __typename?: 'MetricAnnotation';
  direction: MetricAnnotationDirection;
  function?: Maybe<MetricAnnotationFunction>;
  label?: Maybe<Scalars['String']>;
  type: MetricAnnotationType;
  value?: Maybe<Scalars['Float']>;
};

export enum MetricAnnotationDirection {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export enum MetricAnnotationFunction {
  Average = 'AVERAGE',
  Max = 'MAX',
  Min = 'MIN'
}

export enum MetricAnnotationType {
  Line = 'LINE',
  Point = 'POINT'
}

export type MetricEntry = {
  __typename?: 'MetricEntry';
  timestamp: Scalars['Time'];
  value?: Maybe<Scalars['Float']>;
};

export enum MetricLabelType {
  Container = 'CONTAINER',
  Pod = 'POD'
}

export enum MetricSourceType {
  Prometheus = 'PROMETHEUS'
}

export type MetricStream = {
  __typename?: 'MetricStream';
  annotations?: Maybe<Array<MetricAnnotation>>;
  entries?: Maybe<Array<MetricEntry>>;
  labels?: Maybe<Array<MetricStreamLabel>>;
  query: Scalars['String'];
  type?: Maybe<MetricType>;
};

export type MetricStreamLabel = {
  __typename?: 'MetricStreamLabel';
  label: MetricLabelType;
  value: Scalars['String'];
};

export enum MetricType {
  Cpu = 'CPU',
  CpuUtilization = 'CPU_UTILIZATION',
  FunctionConcurrent = 'FUNCTION_CONCURRENT',
  FunctionDuration = 'FUNCTION_DURATION',
  FunctionError = 'FUNCTION_ERROR',
  FunctionInvocation = 'FUNCTION_INVOCATION',
  InstanceCount = 'INSTANCE_COUNT',
  Memory = 'MEMORY',
  MemoryUtilization = 'MEMORY_UTILIZATION',
  Network = 'NETWORK',
  Query = 'QUERY',
  RequestCount = 'REQUEST_COUNT',
  Storage = 'STORAGE'
}

export type MultiEntityCriterion = {
  value?: InputMaybe<Array<Scalars['UUID']>>;
};

/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type Mutation = {
  __typename?: 'Mutation';
  abortBuildRun: BuildRun;
  abortDeployRun: DeployRun;
  abortJobRun: JobRun;
  abortWorkflowRun: Scalars['Boolean'];
  /** Add an existing cluster to your Zeet Account */
  addCluster: Cluster;
  addContainerRegistry: ContainerRegistry;
  approveWorkflowRunStep: Scalars['Boolean'];
  /** Configure the team-specific settings for a blueprint available on the marketplace. */
  configureMarketplaceBlueprintForTeam: Blueprint;
  createApiKey: ApiKey;
  createBlueprint: Blueprint;
  createBuild: Build;
  createBuildRun: BuildRun;
  createCluster: Cluster;
  createDatadogIntegration: DatadogIntegration;
  createDeploy: Deploy;
  createDeployRun: DeployRun;
  createDiscordWebhookIntegration: DiscordWebhookIntegration;
  createGitlabIntegration: GitlabIntegration;
  createGroup: Group;
  createJob: Job;
  createJobRun: JobRun;
  createPersonalAccessTokenForUser: PersonalAccessToken;
  createProject: Project;
  createSlackWebhookIntegration: SlackWebhookIntegration;
  createSubGroup: SubGroup;
  createTrigger: Trigger;
  createWeb3Challenge: Web3Challenge;
  createWorkflow: Workflow;
  deleteApiKey: Scalars['Boolean'];
  deleteBlueprint: Scalars['Boolean'];
  deleteBuild: Scalars['Boolean'];
  deleteCluster: Scalars['Boolean'];
  deleteDeploy: Scalars['Boolean'];
  deleteDeployRun: Scalars['Boolean'];
  deleteGroup: Scalars['Boolean'];
  deleteJob: Scalars['Boolean'];
  deleteJobRun: Scalars['Boolean'];
  deletePersonalAccessToken: Scalars['Boolean'];
  deleteProject: Scalars['Boolean'];
  deleteProjectAndResources?: Maybe<Scalars['UUID']>;
  deleteProjectResources?: Maybe<Scalars['UUID']>;
  deleteSubGroup: Scalars['Boolean'];
  deleteTrigger: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteWorkflow: Scalars['Boolean'];
  deleteWorkflowRun: Scalars['Boolean'];
  duplicateProject: Project;
  /** duplicate a repo to deployv2 project, the input must be a repo id */
  duplicateRepoToDeployV2: Project;
  ejectClusterComponent: ClusterComponent;
  generateDownloadableLogLinkForWorkflowRunStep: Scalars['String'];
  getOrCreateBlueprintFromMetadata: Blueprint;
  linkCloudToCluster: Cluster;
  linkProject: ProjectLink;
  /** upgrade a projectv3 project to deployv2 project, the input must be a project adapter id */
  migrateProjectToDeployV2: Project;
  removeContainerRegistry: Scalars['Boolean'];
  removeUserIntegration: Scalars['Boolean'];
  signInWithWeb3: UserAuth;
  submitWorkflow: WorkflowRun;
  unlinkProject: Scalars['Boolean'];
  updateBlueprint: Blueprint;
  updateBuild: Build;
  updateCluster: Cluster;
  updateDeploy: Deploy;
  updateDiscordWebhookIntegration: DiscordWebhookIntegration;
  updateGitlabIntegration: GitlabIntegration;
  updateGroup: Group;
  updateJob: Job;
  updateProject: Project;
  updateProjectLink: ProjectLink;
  updateSlackWebhookIntegration: SlackWebhookIntegration;
  updateSubGroup: SubGroup;
  updateTrigger: Trigger;
  updateUser: User;
  updateWorkflow: Workflow;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAbortBuildRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAbortDeployRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAbortJobRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAbortWorkflowRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAddClusterArgs = {
  input: AddClusterInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationAddContainerRegistryArgs = {
  input: AddContainerRegistryInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationApproveWorkflowRunStepArgs = {
  projectId: Scalars['UUID'];
  stepId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationConfigureMarketplaceBlueprintForTeamArgs = {
  input: ConfigureMarketplaceBlueprintInput;
  teamId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateApiKeyArgs = {
  input?: InputMaybe<CreateApiKeyInput>;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateBlueprintArgs = {
  input: CreateBlueprintInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateBuildArgs = {
  input: CreateBuildInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateBuildRunArgs = {
  input: CreateBuildRunInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateClusterArgs = {
  input: CreateClusterInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateDatadogIntegrationArgs = {
  input: CreateDatadogIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateDeployArgs = {
  input: CreateDeployInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateDeployRunArgs = {
  input: CreateDeployRunInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateDiscordWebhookIntegrationArgs = {
  input: CreateWebhookIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateGitlabIntegrationArgs = {
  input: CreateGitlabIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateJobRunArgs = {
  input: CreateJobRunInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreatePersonalAccessTokenForUserArgs = {
  input: CreatePersonalAccessTokenInput;
  userId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateSlackWebhookIntegrationArgs = {
  input: CreateWebhookIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateSubGroupArgs = {
  input: CreateSubGroupInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateWeb3ChallengeArgs = {
  input: CreateWeb3ChallengeInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteApiKeyArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteBlueprintArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteBuildArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteClusterArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteDeployArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteDeployRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteGroupArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteJobArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteJobRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeletePersonalAccessTokenArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteProjectArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteProjectAndResourcesArgs = {
  deleteOnFailure?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteProjectResourcesArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteSubGroupArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteTriggerArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteWorkflowArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDeleteWorkflowRunArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDuplicateProjectArgs = {
  id: Scalars['UUID'];
  input: DuplicateProjectInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationDuplicateRepoToDeployV2Args = {
  repoId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationEjectClusterComponentArgs = {
  clusterId: Scalars['UUID'];
  input: EjectClusterComponentInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationGenerateDownloadableLogLinkForWorkflowRunStepArgs = {
  actionStepId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationGetOrCreateBlueprintFromMetadataArgs = {
  slug: Scalars['String'];
  version: Scalars['String'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationLinkCloudToClusterArgs = {
  input: LinkCloudToClusterInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationLinkProjectArgs = {
  input: ProjectLinkInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationMigrateProjectToDeployV2Args = {
  projectId: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationRemoveContainerRegistryArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationRemoveUserIntegrationArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationSignInWithWeb3Args = {
  input: SignInWithWeb3Input;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationSubmitWorkflowArgs = {
  input: SubmitWorkflowInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUnlinkProjectArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateBlueprintArgs = {
  id: Scalars['UUID'];
  input: UpdateBlueprintInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateBuildArgs = {
  id: Scalars['UUID'];
  input: UpdateBuildInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateClusterArgs = {
  id: Scalars['UUID'];
  input: UpdateClusterInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateDeployArgs = {
  id: Scalars['UUID'];
  input: UpdateDeployInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateDiscordWebhookIntegrationArgs = {
  id: Scalars['UUID'];
  input: UpdateWebhookIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateGitlabIntegrationArgs = {
  id: Scalars['UUID'];
  input: UpdateGitlabIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateGroupArgs = {
  id: Scalars['UUID'];
  input: UpdateGroupInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateJobArgs = {
  id: Scalars['UUID'];
  input: UpdateJobInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateProjectArgs = {
  id: Scalars['UUID'];
  input: UpdateProjectInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateProjectLinkArgs = {
  id: Scalars['UUID'];
  input: UpdateProjectLinkInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateSlackWebhookIntegrationArgs = {
  id: Scalars['UUID'];
  input: UpdateWebhookIntegrationInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateSubGroupArgs = {
  id: Scalars['UUID'];
  input: UpdateSubGroupInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateTriggerArgs = {
  id: Scalars['UUID'];
  input: UpdateTriggerInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateUserArgs = {
  id: Scalars['UUID'];
  input: UpdateUserInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type MutationUpdateWorkflowArgs = {
  id: Scalars['UUID'];
  input: UpdateWorkflowInput;
};

export type ObservabilityConfig = {
  __typename?: 'ObservabilityConfig';
  selector?: Maybe<ObservabilityResourceSelector>;
};

export type ObservabilityConfigInput = {
  selector?: InputMaybe<ObservabilityResourceSelectorInput>;
};

export type ObservabilityResourceSelector = {
  __typename?: 'ObservabilityResourceSelector';
  containerName?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<ObservabilityResourceSelectorLabel>>;
  namespace?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  type: ResourceType;
};

export type ObservabilityResourceSelectorInput = {
  containerName?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<ObservabilityResourceSelectorLabelInput>>;
  namespace?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
  type: ResourceType;
};

export type ObservabilityResourceSelectorLabel = {
  __typename?: 'ObservabilityResourceSelectorLabel';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ObservabilityResourceSelectorLabelInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
};

export type PageInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PersonalAccessToken = {
  __typename?: 'PersonalAccessToken';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export type Port = {
  __typename?: 'Port';
  grpc: Scalars['Boolean'];
  https: Scalars['Boolean'];
  loadBalancer: Scalars['Boolean'];
  port: Scalars['String'];
  protocol: Scalars['String'];
  public: Scalars['Boolean'];
};

export type PortData = {
  __typename?: 'PortData';
  grpc?: Maybe<Scalars['Boolean']>;
  https?: Maybe<Scalars['Boolean']>;
  loadBalancer?: Maybe<Scalars['Boolean']>;
  port: Scalars['String'];
  protocol?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
};

export type PortDataInput = {
  grpc?: InputMaybe<Scalars['Boolean']>;
  https?: InputMaybe<Scalars['Boolean']>;
  loadBalancer?: InputMaybe<Scalars['Boolean']>;
  port: Scalars['String'];
  protocol?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
};

export type ProbeData = {
  __typename?: 'ProbeData';
  command?: Maybe<Scalars['String']>;
  failureThreshold?: Maybe<Scalars['Int']>;
  http?: Maybe<HttpProbe>;
  initialDelaySeconds?: Maybe<Scalars['Int']>;
  periodSeconds?: Maybe<Scalars['Int']>;
  successThreshold?: Maybe<Scalars['Int']>;
  tcp?: Maybe<TcpProbe>;
  timeoutSeconds?: Maybe<Scalars['Int']>;
};

export type ProbeDataInput = {
  command?: InputMaybe<Scalars['String']>;
  failureThreshold?: InputMaybe<Scalars['Int']>;
  http?: InputMaybe<HttpProbeInput>;
  initialDelaySeconds?: InputMaybe<Scalars['Int']>;
  periodSeconds?: InputMaybe<Scalars['Int']>;
  successThreshold?: InputMaybe<Scalars['Int']>;
  tcp?: InputMaybe<TcpProbeInput>;
  timeoutSeconds?: InputMaybe<Scalars['Int']>;
};

export type ProfileOwner = {
  avatar?: Maybe<Scalars['URL']>;
  login: Scalars['Login'];
  name: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  availableProviders: Array<Project>;
  billable?: Maybe<Scalars['Boolean']>;
  blueprint?: Maybe<Blueprint>;
  build?: Maybe<Build>;
  clusters: Array<Cluster>;
  connector?: Maybe<ProjectConnector>;
  createdAt: Scalars['Time'];
  deploymentTimestamps?: Maybe<DeploymentTimestamps>;
  deploys: DeployConnection;
  envs?: Maybe<Array<EnvVar>>;
  group?: Maybe<Group>;
  id: Scalars['UUID'];
  isDeployV1?: Maybe<Scalars['Boolean']>;
  jobs?: Maybe<Array<Job>>;
  link?: Maybe<ProjectLink>;
  linkedProjects: ProjectLinkConnection;
  linkedProviders: ProjectLinkConnection;
  name: Scalars['String'];
  observabilityConfig?: Maybe<ObservabilityConfig>;
  output?: Maybe<ProjectOutput>;
  owner?: Maybe<Team>;
  resources?: Maybe<Array<CloudResource>>;
  status: ProjectStatus;
  subGroup?: Maybe<SubGroup>;
  updatedAt: Scalars['Time'];
  workflow?: Maybe<Workflow>;
};


export type ProjectAvailableProvidersArgs = {
  type: ProjectLinkType;
};


export type ProjectConnectorArgs = {
  type: ProjectConnectorType;
};


export type ProjectDeploysArgs = {
  input?: InputMaybe<FilterInput>;
};


export type ProjectLinkArgs = {
  id: Scalars['UUID'];
};


export type ProjectLinkedProjectsArgs = {
  type: ProjectLinkType;
};


export type ProjectLinkedProvidersArgs = {
  type: ProjectLinkType;
};


export type ProjectResourcesArgs = {
  clusterId: Scalars['UUID'];
  selector?: InputMaybe<ObservabilityResourceSelectorInput>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  nodes: Array<Project>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectConnector = {
  __typename?: 'ProjectConnector';
  fields?: Maybe<Array<ProjectConnectorField>>;
  type?: Maybe<ProjectConnectorType>;
};

export type ProjectConnectorField = {
  __typename?: 'ProjectConnectorField';
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VariableType>;
  value?: Maybe<Scalars['String']>;
};

export type ProjectConnectorSchema = {
  __typename?: 'ProjectConnectorSchema';
  entries?: Maybe<Array<ProjectConnectorSchemaEntry>>;
};

export type ProjectConnectorSchemaEntry = {
  __typename?: 'ProjectConnectorSchemaEntry';
  fields?: Maybe<Array<ProjectConnectorSchemaField>>;
  type?: Maybe<ProjectConnectorType>;
};

export type ProjectConnectorSchemaField = {
  __typename?: 'ProjectConnectorSchemaField';
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ProjectConnectorSchemaFieldType>;
};

export enum ProjectConnectorSchemaFieldType {
  Output = 'OUTPUT'
}

export enum ProjectConnectorType {
  DatabaseConnection = 'DATABASE_CONNECTION'
}

/** Available filters for querying Projects. The result set is the intersection of all specified filters. */
export type ProjectFilter = {
  groupName?: InputMaybe<StringCriterion>;
  /** Selects only the Projects having one of these ids. */
  ids?: InputMaybe<Array<Scalars['UUID']>>;
  name?: InputMaybe<StringCriterion>;
  /** Filter Projects by name, status, groupName and subGroupName */
  status?: InputMaybe<ProjectStatusCriterion>;
  subGroupName?: InputMaybe<StringCriterion>;
};

export type ProjectFilterCriterion = {
  groupName?: InputMaybe<StringCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  name?: InputMaybe<StringCriterion>;
  status?: InputMaybe<ProjectStatusCriterion>;
  subGroupName?: InputMaybe<StringCriterion>;
};

export type ProjectLink = {
  __typename?: 'ProjectLink';
  envPrefix?: Maybe<Scalars['String']>;
  envs?: Maybe<Array<ProjectLinkEnvVar>>;
  id: Scalars['UUID'];
  linkType: ProjectLinkType;
  project: Project;
  provider: Project;
};

export type ProjectLinkConnection = {
  __typename?: 'ProjectLinkConnection';
  nodes: Array<ProjectLink>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectLinkEnvVar = {
  __typename?: 'ProjectLinkEnvVar';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProjectLinkInput = {
  envPrefix?: InputMaybe<Scalars['String']>;
  linkType: ProjectLinkType;
  projectId: Scalars['UUID'];
  providerId: Scalars['UUID'];
};

export enum ProjectLinkType {
  Database = 'DATABASE',
  Unknown = 'UNKNOWN'
}

export type ProjectOutput = {
  __typename?: 'ProjectOutput';
  entries?: Maybe<Array<ProjectOutputEntry>>;
};

export type ProjectOutputEntry = {
  __typename?: 'ProjectOutputEntry';
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<VariableType>;
  value?: Maybe<Scalars['String']>;
};

export enum ProjectStatus {
  BuildAborted = 'BUILD_ABORTED',
  BuildFailed = 'BUILD_FAILED',
  BuildInProgress = 'BUILD_IN_PROGRESS',
  BuildPending = 'BUILD_PENDING',
  BuildSucceeded = 'BUILD_SUCCEEDED',
  ContainerPulling = 'CONTAINER_PULLING',
  DeployCrashing = 'DEPLOY_CRASHING',
  DeployFailed = 'DEPLOY_FAILED',
  DeployHealthy = 'DEPLOY_HEALTHY',
  DeployInProgress = 'DEPLOY_IN_PROGRESS',
  DeployPending = 'DEPLOY_PENDING',
  DeployStopped = 'DEPLOY_STOPPED',
  DeploySucceeded = 'DEPLOY_SUCCEEDED',
  Destroying = 'DESTROYING',
  Draft = 'DRAFT',
  HealthChecking = 'HEALTH_CHECKING',
  Inactive = 'INACTIVE',
  JobRunCancelled = 'JOB_RUN_CANCELLED',
  JobRunFailed = 'JOB_RUN_FAILED',
  JobRunPendingApproval = 'JOB_RUN_PENDING_APPROVAL',
  JobRunRunning = 'JOB_RUN_RUNNING',
  JobRunStarting = 'JOB_RUN_STARTING',
  JobRunSucceeded = 'JOB_RUN_SUCCEEDED',
  NodeProvisioning = 'NODE_PROVISIONING',
  Paused = 'PAUSED',
  PendingHealthyCluster = 'PENDING_HEALTHY_CLUSTER',
  Unknown = 'UNKNOWN'
}

export type ProjectStatusCriterion = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** Filter a ProjectConnection result set. */
export type ProjectsInput = {
  filter?: InputMaybe<ProjectFilter>;
  page?: InputMaybe<PageInput>;
  /** Sorting is applied before pagination. */
  sort?: InputMaybe<SortInput>;
};

export type Prometheus = {
  __typename?: 'Prometheus';
  password?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  user?: Maybe<Scalars['String']>;
};

/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type Query = {
  __typename?: 'Query';
  blueprint?: Maybe<Blueprint>;
  blueprintsMarketplace?: Maybe<BlueprintsMarketplace>;
  currentUser: User;
  debug?: Maybe<Debug>;
  dockerRepository?: Maybe<DockerRepository>;
  helmRepository: HelmRepository;
  insights?: Maybe<Insights>;
  searchHelmCharts: HelmChartConnection;
  team?: Maybe<Team>;
  user: User;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QueryBlueprintArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QueryDockerRepositoryArgs = {
  image: Scalars['String'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QueryHelmRepositoryArgs = {
  url: Scalars['String'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QuerySearchHelmChartsArgs = {
  input: SearchHelmChartsInput;
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QueryTeamArgs = {
  id: Scalars['UUID'];
};


/**
 * Zeet API v1 is currently experimental. Breaking changes WILL occur. Many resolvers are not implemented.
 *
 * Please refer to the legacy API schema while we stabilize the v1 API.
 */
export type QueryUserArgs = {
  id: Scalars['UUID'];
};

export type RemoveTeamMemberInput = {
  id: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type Replication = {
  __typename?: 'Replication';
  cluster?: Maybe<Cluster>;
  region: Scalars['String'];
  replicas?: Maybe<Scalars['Int']>;
};

export type ReplicationInput = {
  clusterId?: InputMaybe<Scalars['UUID']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  region: Scalars['String'];
  replicas: Scalars['Int'];
};

export type RepoFilter = {
  status?: InputMaybe<RepoStatusCriterion>;
};

export type RepoStatusCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Scalars['String']>;
};

export type Resource = {
  displayName: Scalars['String'];
  externalId: Scalars['String'];
  externalLink?: Maybe<Scalars['URL']>;
  externalType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ResourceAdapterFilter = {
  deployableIds?: InputMaybe<MultiEntityCriterion>;
  groupName?: InputMaybe<StringCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  name?: InputMaybe<StringCriterion>;
  repoIds?: InputMaybe<MultiEntityCriterion>;
  resourceIds?: InputMaybe<MultiEntityCriterion>;
  status?: InputMaybe<AdapterStatusCriterion>;
  subGroupName?: InputMaybe<StringCriterion>;
};

export type ResourceConnection = {
  __typename?: 'ResourceConnection';
  nodes: Array<Resource>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ResourceEvent = {
  __typename?: 'ResourceEvent';
  action: Scalars['String'];
  count: Scalars['Int'];
  firstOccurrenceAt?: Maybe<Scalars['Time']>;
  lastOccurrenceAt?: Maybe<Scalars['Time']>;
  message: Scalars['String'];
  occurredAt?: Maybe<Scalars['Time']>;
  reason: Scalars['String'];
  type: ResourceEventType;
};

export enum ResourceEventType {
  Normal = 'NORMAL',
  Warning = 'WARNING'
}

export type ResourceFilter = {
  deployableIds?: InputMaybe<MultiEntityCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  userIds?: InputMaybe<MultiEntityCriterion>;
};

export type ResourceOwner = {
  __typename?: 'ResourceOwner';
  name: Scalars['String'];
  type: ResourceType;
};

export enum ResourceStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export enum ResourceType {
  Container = 'CONTAINER',
  Daemonset = 'DAEMONSET',
  Deployment = 'DEPLOYMENT',
  Job = 'JOB',
  Pod = 'POD',
  Replicaset = 'REPLICASET',
  Service = 'SERVICE',
  Statefulset = 'STATEFULSET'
}

export type RevisableEntity = {
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type RevisionAuthorInfo = {
  __typename?: 'RevisionAuthorInfo';
  /** When true, this indicates the original author's user has since been deleted. */
  creatorDeleted: Scalars['Boolean'];
  /** A short description of how the revision was initiated. */
  summary: Scalars['String'];
};

export type RevisionMetadata = {
  __typename?: 'RevisionMetadata';
  /** A revision may have additional information about how it was initiated. */
  authorInfo?: Maybe<RevisionAuthorInfo>;
  createdAt: Scalars['Time'];
  /**
   * The user that authored this revision.
   *
   * If the user has been deleted, this will contain a placeholder User, with the Name field changed to the deleted user's username.
   * When this field represents a deleted user, it SHOULD NOT be used for any API operations expecting a userId, and any attempts will likely fail.
   *
   * To confirm whether this field represents a deleted user, you may additionally consult the `authorInfo.creatorDeleted` flag (see `RevisionAuthorInfo`).
   */
  createdBy: User;
  description: Scalars['String'];
  id: Scalars['UUID'];
  sequenceId: Scalars['Int'];
};

export type S3BucketBackendInput = {
  awsAccountId: Scalars['UUID'];
  bucketName: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketConfiguration = {
  __typename?: 'S3BucketConfiguration';
  awsAccountId: Scalars['UUID'];
  bucketName: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  region: Scalars['String'];
};

export type SearchHelmChartsInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type SecretMountData = {
  __typename?: 'SecretMountData';
  mountPath: Scalars['String'];
  readOnly?: Maybe<Scalars['Boolean']>;
  secretName: Scalars['String'];
};

export type SecretMountDataInput = {
  mountPath: Scalars['String'];
  readOnly?: InputMaybe<Scalars['Boolean']>;
  secretName: Scalars['String'];
};

export type SignInWithWeb3Input = {
  challengeId: Scalars['UUID'];
  signature: Scalars['String'];
};

export type SlackIntegration = Integration & {
  __typename?: 'SlackIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type SlackWebhookIntegration = Integration & {
  __typename?: 'SlackWebhookIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  url?: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<Scalars['String']>;
};

export type Source = {
  __typename?: 'Source';
  containerRegistry?: Maybe<ContainerRegistrySource>;
  git?: Maybe<GitSource>;
  helmRepository?: Maybe<HelmRepositorySource>;
  terraformModule?: Maybe<TerraformModuleSource>;
};

export type SourceInput = {
  containerRegistry?: InputMaybe<ContainerRegistrySourceInput>;
  git?: InputMaybe<GitSourceInput>;
  helmRepository?: InputMaybe<HelmRepositorySourceInput>;
  terraformModule?: InputMaybe<TerraformModuleSourceInput>;
};

export type StringCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Scalars['String']>;
};

export type SubGroup = {
  __typename?: 'SubGroup';
  createdAt: Scalars['Time'];
  deploymentTimestamps?: Maybe<DeploymentTimestamps>;
  envs?: Maybe<Array<EnvVar>>;
  group?: Maybe<Group>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type SubmitWorkflowInput = {
  definition?: InputMaybe<WorkflowRunDefinitionInput>;
  workflowId: Scalars['UUID'];
};

export type SuggestGroupNameInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type TcpProbe = {
  __typename?: 'TCPProbe';
  host: Scalars['String'];
  port: Scalars['String'];
};

export type TcpProbeInput = {
  host: Scalars['String'];
  port: Scalars['String'];
};

/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type Team = GroupOwner & {
  __typename?: 'Team';
  avatar?: Maybe<Scalars['URL']>;
  blueprint?: Maybe<Blueprint>;
  blueprints?: Maybe<BlueprintConnection>;
  build?: Maybe<Build>;
  builds: BuildConnection;
  cloudAccount?: Maybe<CloudAccount>;
  cluster?: Maybe<Cluster>;
  deploy?: Maybe<Deploy>;
  deployRun: DeployRun;
  deploymentTimestamps?: Maybe<DeploymentTimestamps>;
  deploys: DeployConnection;
  groups: GroupConnection;
  id: Scalars['UUID'];
  job?: Maybe<Job>;
  jobRun?: Maybe<JobRun>;
  jobs: JobConnection;
  memberInvitations: Array<TeamMemberInvitation>;
  members: Array<UserTeamEdge>;
  name: Scalars['String'];
  project?: Maybe<Project>;
  projects?: Maybe<ProjectConnection>;
  resource: Resource;
  trigger?: Maybe<Trigger>;
  workflow?: Maybe<Workflow>;
  workflows: WorkflowConnection;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamBlueprintArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamBlueprintsArgs = {
  page?: InputMaybe<PageInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamBuildArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamBuildsArgs = {
  input?: InputMaybe<FilterInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamCloudAccountArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamClusterArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamDeployArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamDeployRunArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamDeploysArgs = {
  input?: InputMaybe<FilterInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamGroupsArgs = {
  input?: InputMaybe<GroupsInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamJobArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamJobRunArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamJobsArgs = {
  input?: InputMaybe<FilterInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamProjectArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamResourceArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamTriggerArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamWorkflowArgs = {
  id: Scalars['UUID'];
};


/**
 * A Zeet Team is used as a permission boundary, and as the owner of projects, clusters, and other resources.
 * Groups can grant access to multiple teams.
 *
 * Teams can also have sub-teams or a parent team.
 * A member of parent team will have equal access to all sub-teams.
 * Being a member of sub-team does not confer access to the parent team.
 */
export type TeamWorkflowsArgs = {
  input?: InputMaybe<FilterInput>;
};

export type TeamMemberInvitation = {
  __typename?: 'TeamMemberInvitation';
  createdAt: Scalars['Time'];
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Time']>;
  id: Scalars['UUID'];
  link: Scalars['String'];
  role: TeamMemberRole;
  team: Team;
};

export enum TeamMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type TerraformAutomaticOutputConfiguration = {
  __typename?: 'TerraformAutomaticOutputConfiguration';
  /** Disable the 'automatic output' handler, which produces a single map named 'outputs' containing all module outputs. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The keys of any module outputs that should be excluded from the automatic output value. Ignored when 'disabled' is true. */
  excluded?: Maybe<Array<Scalars['String']>>;
  /** Mark the automatic output as sensitive. This MUST be 'true' when any sensitive module output is not specified 'excluded' *and* 'disabled' is false. */
  sensitive?: Maybe<Scalars['Boolean']>;
};

/** See TerraformAutomaticOutputConfiguration. */
export type TerraformAutomaticOutputConfigurationInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  excluded?: InputMaybe<Array<Scalars['String']>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
};

export type TerraformClusterComponentMetadata = {
  __typename?: 'TerraformClusterComponentMetadata';
  jobRunState?: Maybe<JobRunState>;
};

export type TerraformModuleSource = {
  __typename?: 'TerraformModuleSource';
  /** Configuring an integration provides authentication to retrieve the module from private sources */
  integration?: Maybe<TerraformModuleSourceIntegration>;
  /** Any valid Terraform Module source: https://developer.hashicorp.com/terraform/language/modules/sources */
  source: Scalars['String'];
  /** The version field is only applicable to Terraform Registry sources */
  version?: Maybe<Scalars['String']>;
};

export type TerraformModuleSourceInput = {
  integration?: InputMaybe<TerraformModuleSourceIntegrationInput>;
  source: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export type TerraformModuleSourceIntegration = {
  __typename?: 'TerraformModuleSourceIntegration';
  git?: Maybe<GitSourceIntegration>;
};

export type TerraformModuleSourceIntegrationInput = {
  git?: InputMaybe<GitSourceIntegrationInput>;
};

export type TerraformOutputConfiguration = {
  __typename?: 'TerraformOutputConfiguration';
  /** Configuration for the automatic output handler. This configuration does not affect output defined via 'customization'. */
  automatic?: Maybe<TerraformAutomaticOutputConfiguration>;
  /**
   * A JSON object using Terraform configuration syntax (https://developer.hashicorp.com/terraform/language/syntax/json), constituting a valid "output" block.
   *
   * Example:
   * ```
   * {
   *   "output": {
   *     "example": {
   *       "value": "${aws_instance.example}"
   *     }
   *   }
   * }
   * ```
   *
   * This must include the "output" key at the top level.
   *
   * To reference module values, use the expression mapping syntax: https://developer.hashicorp.com/terraform/language/syntax/json#expression-mapping
   */
  customization?: Maybe<Scalars['JSON']>;
};

/** See TerraformOutputConfiguration. */
export type TerraformOutputConfigurationInput = {
  automatic?: InputMaybe<TerraformAutomaticOutputConfigurationInput>;
  customization?: InputMaybe<Scalars['JSON']>;
};

/** The Zeet-connected cloud account which will be mapped to a terraform provider */
export type TerraformProvider = {
  __typename?: 'TerraformProvider';
  awsAccount?: Maybe<AwsAccount>;
  doAccount?: Maybe<DoAccount>;
  gcpAccount?: Maybe<GcpAccount>;
  linodeAccount?: Maybe<LinodeAccount>;
  /** Region name, when applicable */
  region?: Maybe<Scalars['String']>;
};

export type TerraformProviderInput = {
  /** Zeet ID for a connected AWS Account */
  awsAccountId?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected DigitalOcean Account */
  doAccountId?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected GCP Account */
  gcpAccountId?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected Linode Account */
  linodeAccountId?: InputMaybe<Scalars['UUID']>;
  /** Region name, when applicable */
  region?: InputMaybe<Scalars['String']>;
};

export type TerraformStateBackend = {
  __typename?: 'TerraformStateBackend';
  gcsBucket?: Maybe<GcsBucketConfiguration>;
  linodeBucket?: Maybe<LinodeBucketConfiguration>;
  s3Bucket?: Maybe<S3BucketConfiguration>;
};

export type TerraformStateBackendInput = {
  gcsBucket?: InputMaybe<GcsBucketBackendInput>;
  linodeBucket?: InputMaybe<LinodeBucketBackendInput>;
  s3Bucket?: InputMaybe<S3BucketBackendInput>;
};

export type TerraformTargetConfiguration = {
  __typename?: 'TerraformTargetConfiguration';
  moduleName?: Maybe<Scalars['String']>;
  provider?: Maybe<TerraformProvider>;
  stateBackend?: Maybe<TerraformStateBackend>;
};

export type TerraformTargetConfigurationInput = {
  moduleName?: InputMaybe<Scalars['String']>;
  provider: TerraformProviderInput;
  stateBackend: TerraformStateBackendInput;
};

export type Trigger = {
  __typename?: 'Trigger';
  action: TriggerActionType;
  configuration?: Maybe<TriggerConfiguration>;
  events?: Maybe<Array<TriggerEventType>>;
  id: Scalars['UUID'];
};

export enum TriggerActionType {
  OrchestrationWorkflow = 'ORCHESTRATION_WORKFLOW'
}

export type TriggerConfiguration = {
  __typename?: 'TriggerConfiguration';
  action?: Maybe<ActionTriggerConfiguration>;
  event?: Maybe<EventTriggerConfiguration>;
};

export type TriggerConfigurationInput = {
  action?: InputMaybe<ActionTriggerConfigurationInput>;
  event?: InputMaybe<EventTriggerConfigurationInput>;
};

export type TriggerConnection = {
  __typename?: 'TriggerConnection';
  nodes?: Maybe<Array<Trigger>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TriggerDefinitionInput = {
  action: TriggerActionType;
  configuration: TriggerConfigurationInput;
  events?: InputMaybe<Array<TriggerEventType>>;
};

export enum TriggerEventType {
  Cronjob = 'CRONJOB',
  GitIssueOpened = 'GIT_ISSUE_OPENED',
  GitPrOpened = 'GIT_PR_OPENED',
  GitPrReviewComment = 'GIT_PR_REVIEW_COMMENT',
  GitPush = 'GIT_PUSH',
  GitReleaseCreated = 'GIT_RELEASE_CREATED',
  GitReleaseReleased = 'GIT_RELEASE_RELEASED',
  Manual = 'MANUAL'
}

export type UpdateBlueprintInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  driverConfiguration?: InputMaybe<BlueprintDriverConfigurationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  richInputSchema?: InputMaybe<Scalars['JSON']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  variables: Array<BlueprintVariableSpecInput>;
};

export type UpdateBuildInput = {
  definition?: InputMaybe<BuildDefinitionInput>;
};

export type UpdateClusterInput = {
  containerCacheRepository?: InputMaybe<Scalars['String']>;
  containerRegistryId?: InputMaybe<Scalars['UUID']>;
  containerRepository?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  kubeconfig?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDeployInput = {
  configuration?: InputMaybe<DeploymentConfigurationInput>;
};

export type UpdateDeploymentConfigurationInput = {
  autoRetry?: InputMaybe<Scalars['Boolean']>;
  autoRollback?: InputMaybe<Scalars['Boolean']>;
  blueprintDriverWorkflowStepActions?: InputMaybe<Array<BlueprintDriverWorkflowStepAction>>;
  branch?: InputMaybe<BranchConfigInput>;
  driver?: InputMaybe<BlueprintDriver>;
  instanceId?: InputMaybe<Scalars['UUID']>;
  replications?: InputMaybe<Array<InputMaybe<ReplicationInput>>>;
  source?: InputMaybe<SourceInput>;
};

export type UpdateGitlabIntegrationInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  apiUrl?: InputMaybe<Scalars['URL']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateJobInput = {
  definition?: InputMaybe<JobDefinitionInput>;
};

export type UpdateProjectInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  groupId?: InputMaybe<Scalars['UUID']>;
  groupName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  observabilityConfig?: InputMaybe<ObservabilityConfigInput>;
  subGroupId?: InputMaybe<Scalars['UUID']>;
  subGroupName?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectLinkInput = {
  envPrefix?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateSubGroupInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTeamMemberRoleInput = {
  id: Scalars['UUID'];
  role: TeamMemberRole;
};

export type UpdateTriggerInput = {
  definition?: InputMaybe<TriggerDefinitionInput>;
  triggerId: Scalars['UUID'];
};

export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['URL']>;
  login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWebhookIntegrationInput = {
  url: Scalars['String'];
  userId: Scalars['UUID'];
};

export type UpdateWorkflowInput = {
  definition?: InputMaybe<WorkflowDefinitionInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type User = ProfileOwner & {
  __typename?: 'User';
  avatar?: Maybe<Scalars['URL']>;
  id: Scalars['UUID'];
  isTeam?: Maybe<Scalars['Boolean']>;
  login: Scalars['Login'];
  name: Scalars['String'];
  permissions?: Maybe<UserPermissionsConnection>;
  personalAccessTokens: Array<PersonalAccessToken>;
};

export enum UserAction {
  EditBilling = 'EDIT_BILLING',
  ReadPrivate = 'READ_PRIVATE'
}

export type UserAuth = {
  __typename?: 'UserAuth';
  authToken: Scalars['String'];
};

export type UserFilter = {
  ids?: InputMaybe<MultiEntityCriterion>;
};

export type UserPermissionsConnection = {
  __typename?: 'UserPermissionsConnection';
  forTeam?: Maybe<UserPermissionsTeamConnection>;
  principal?: Maybe<User>;
};


export type UserPermissionsConnectionForTeamArgs = {
  teamId: Scalars['UUID'];
};

export type UserPermissionsTeamConnection = {
  __typename?: 'UserPermissionsTeamConnection';
  mutations: Array<Scalars['PermissibleMutation']>;
  team?: Maybe<Team>;
};

export type UserTeamEdge = {
  __typename?: 'UserTeamEdge';
  id: Scalars['UUID'];
  role: TeamMemberRole;
  team: Team;
  user: User;
};

export enum VariableType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type VolumeSpec = {
  __typename?: 'VolumeSpec';
  mountPath: Scalars['String'];
  size: Scalars['Int'];
};

export type VolumeSpecInput = {
  mountPath: Scalars['String'];
  size: Scalars['Int'];
};

export type VultrAccount = {
  __typename?: 'VultrAccount';
  configuration: VultrAccountConfiguration;
  configurationRevisions: VultrAccountConfigurationConnection;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  updatedAt: Scalars['Time'];
};


export type VultrAccountConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type VultrAccountConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type VultrAccountConfiguration = RevisableEntity & {
  __typename?: 'VultrAccountConfiguration';
  name: Scalars['String'];
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type VultrAccountConfigurationConnection = {
  __typename?: 'VultrAccountConfigurationConnection';
  nodes: Array<VultrAccountConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Web3Challenge = {
  __typename?: 'Web3Challenge';
  address: Scalars['String'];
  id: Scalars['UUID'];
  nonce: Scalars['String'];
};

export type Workflow = {
  __typename?: 'Workflow';
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  parentId: Scalars['UUID'];
  run: WorkflowRun;
  runs: WorkflowRunConnection;
  source?: Maybe<Source>;
  steps?: Maybe<Array<WorkflowStepDefinition>>;
  triggers: TriggerConnection;
  type?: Maybe<WorkflowType>;
};


export type WorkflowRunArgs = {
  id: Scalars['UUID'];
};


export type WorkflowRunsArgs = {
  input?: InputMaybe<FilterInput>;
};


export type WorkflowTriggersArgs = {
  input?: InputMaybe<FilterInput>;
};

export type WorkflowBranchDefinitionInput = {
  commitSha: Scalars['String'];
  name: Scalars['String'];
};

export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  nodes?: Maybe<Array<Workflow>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type WorkflowDefinitionInput = {
  branch?: InputMaybe<WorkflowBranchDefinitionInput>;
  source?: InputMaybe<SourceInput>;
  steps?: InputMaybe<Array<WorkflowStepDefinitionInput>>;
  workflowClusterId?: InputMaybe<Scalars['UUID']>;
};

export enum WorkflowExecutionType {
  BuildRun = 'BUILD_RUN',
  DeployRun = 'DEPLOY_RUN',
  DriverAction = 'DRIVER_ACTION'
}

export type WorkflowRun = {
  __typename?: 'WorkflowRun';
  createdAt: Scalars['Time'];
  current: Scalars['Boolean'];
  finishedAt?: Maybe<Scalars['Time']>;
  id: Scalars['UUID'];
  sequence: Scalars['Int'];
  status: WorkflowRunStatus;
  step: WorkflowRunStep;
  steps?: Maybe<Array<Maybe<WorkflowRunStep>>>;
  updatedAt: Scalars['Time'];
  workflowId: Scalars['UUID'];
};


export type WorkflowRunStepArgs = {
  id: Scalars['UUID'];
};

export type WorkflowRunConnection = {
  __typename?: 'WorkflowRunConnection';
  nodes: Array<WorkflowRun>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type WorkflowRunDefinitionInput = {
  branch?: InputMaybe<WorkflowBranchDefinitionInput>;
  source?: InputMaybe<SourceInput>;
  steps?: InputMaybe<Array<WorkflowRunStepDefinitionInput>>;
};

export type WorkflowRunFilter = {
  ids?: InputMaybe<MultiEntityCriterion>;
  type?: InputMaybe<WorkflowRunTypeCriterion>;
};

export enum WorkflowRunStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type WorkflowRunStep = {
  action: GenericWorkflowStepActionType;
  createdAt: Scalars['Time'];
  dependsOn?: Maybe<Array<WorkflowRunStep>>;
  executionError?: Maybe<Scalars['String']>;
  executionId?: Maybe<Scalars['UUID']>;
  executionType?: Maybe<WorkflowExecutionType>;
  id: Scalars['UUID'];
  sequenceNumber: Scalars['Int'];
  status: WorkflowRunStepStatus;
  updatedAt: Scalars['Time'];
};

export type WorkflowRunStepDefinitionInput = {
  action: WorkflowStepActionType;
  dependsOn?: InputMaybe<Array<Scalars['Int']>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  matchingRule?: InputMaybe<WorkflowStepDefinitionMatchingRuleInput>;
  metadata?: InputMaybe<WorkflowRunStepDefinitionMetadataInput>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
};

export type WorkflowRunStepDefinitionMetadataInput = {
  deploySteps?: InputMaybe<Array<DriverWorkflowStepActionType>>;
};

export enum WorkflowRunStepStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum WorkflowRunType {
  CreateResource = 'CREATE_RESOURCE',
  DeleteResource = 'DELETE_RESOURCE'
}

export type WorkflowRunTypeCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Array<InputMaybe<WorkflowRunType>>>;
};

export enum WorkflowStepActionType {
  OrchestrationBuild = 'ORCHESTRATION_BUILD',
  OrchestrationClusterPrecheck = 'ORCHESTRATION_CLUSTER_PRECHECK',
  OrchestrationDeploy = 'ORCHESTRATION_DEPLOY',
  OrchestrationDestroy = 'ORCHESTRATION_DESTROY',
  OrchestrationRelease = 'ORCHESTRATION_RELEASE'
}

export type WorkflowStepDefinition = {
  __typename?: 'WorkflowStepDefinition';
  action: WorkflowStepActionType;
  dependsOn?: Maybe<Array<Scalars['Int']>>;
  disabled?: Maybe<Scalars['Boolean']>;
  matchingRule?: Maybe<WorkflowStepDefinitionMatchingRule>;
  sequenceNumber?: Maybe<Scalars['Int']>;
};

export type WorkflowStepDefinitionInput = {
  action: WorkflowStepActionType;
  dependsOn?: InputMaybe<Array<Scalars['Int']>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  matchingRule?: InputMaybe<WorkflowStepDefinitionMatchingRuleInput>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
};

export type WorkflowStepDefinitionMatchingRule = {
  __typename?: 'WorkflowStepDefinitionMatchingRule';
  branchName?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['UUID']>;
  label?: Maybe<Scalars['String']>;
};

export type WorkflowStepDefinitionMatchingRuleInput = {
  branchName?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['UUID']>;
  label?: InputMaybe<Scalars['String']>;
};

export enum WorkflowType {
  Driver = 'DRIVER',
  Orchestration = 'ORCHESTRATION'
}

export type CreateBuildRunMutationVariables = Exact<{
  buildId: Scalars['UUID'];
}>;


export type CreateBuildRunMutation = { __typename?: 'Mutation', createBuildRun: { __typename?: 'BuildRun', id: string } };

export type EjectClusterComponentMutationVariables = Exact<{
  clusterId: Scalars['UUID'];
  input: EjectClusterComponentInput;
}>;


export type EjectClusterComponentMutation = { __typename?: 'Mutation', ejectClusterComponent: { __typename?: 'ClusterComponent', name: string, status: ClusterComponentEjectedStatus } };

export type UpdateDeployMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateDeployInput;
}>;


export type UpdateDeployMutation = { __typename?: 'Mutation', updateDeploy: { __typename?: 'Deploy', id: string } };

export type CreateDeployRunMutationVariables = Exact<{
  input: CreateDeployRunInput;
}>;


export type CreateDeployRunMutation = { __typename?: 'Mutation', createDeployRun: { __typename?: 'DeployRun', id: string } };

export type GenerateDownloadableLogLinkForWorkflowRunStepMutationVariables = Exact<{
  actionStepId: Scalars['UUID'];
}>;


export type GenerateDownloadableLogLinkForWorkflowRunStepMutation = { __typename?: 'Mutation', generateDownloadableLogLinkForWorkflowRunStep: string };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup: boolean };

export type DeleteSubGroupMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteSubGroupMutation = { __typename?: 'Mutation', deleteSubGroup: boolean };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, name: string } };

export type CreateSubGroupMutationVariables = Exact<{
  input: CreateSubGroupInput;
}>;


export type CreateSubGroupMutation = { __typename?: 'Mutation', createSubGroup: { __typename?: 'SubGroup', id: string, name: string } };

export type CreateUserPersonalAccessTokenMutationVariables = Exact<{
  userId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type CreateUserPersonalAccessTokenMutation = { __typename?: 'Mutation', createPersonalAccessTokenForUser: { __typename?: 'PersonalAccessToken', id: string, name: string, token: string, createdAt: Date } };

export type DeleteUserPersonalAccessTokenMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteUserPersonalAccessTokenMutation = { __typename?: 'Mutation', deletePersonalAccessToken: boolean };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, workflow?: { __typename?: 'Workflow', id: string } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string } };

export type DuplicateProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: DuplicateProjectInput;
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject: { __typename?: 'Project', id: string, name: string, group?: { __typename?: 'Group', id: string, name: string } | null, subGroup?: { __typename?: 'SubGroup', id: string, name: string } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type DeleteProjectResourcesMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteProjectResourcesMutation = { __typename?: 'Mutation', deleteProjectResources?: string | null };

export type DeleteProjectAndResourcesMutationVariables = Exact<{
  id: Scalars['UUID'];
  deleteOnFailure?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteProjectAndResourcesMutation = { __typename?: 'Mutation', deleteProjectAndResources?: string | null };

export type LinkProjectMutationVariables = Exact<{
  input: ProjectLinkInput;
}>;


export type LinkProjectMutation = { __typename?: 'Mutation', linkProject: { __typename?: 'ProjectLink', id: string } };

export type UnlinkProjectMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnlinkProjectMutation = { __typename?: 'Mutation', unlinkProject: boolean };

export type AbortWorkflowRunMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AbortWorkflowRunMutation = { __typename?: 'Mutation', abortWorkflowRun: boolean };

export type SubmitWorkflowRunMutationVariables = Exact<{
  workflowId: Scalars['UUID'];
  definition?: InputMaybe<WorkflowRunDefinitionInput>;
}>;


export type SubmitWorkflowRunMutation = { __typename?: 'Mutation', submitWorkflow: { __typename?: 'WorkflowRun', id: string } };

export type UpdateWorkflowMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename?: 'Workflow', id: string } };

export type CreateWorkflowTriggerMutationVariables = Exact<{
  input: CreateTriggerInput;
}>;


export type CreateWorkflowTriggerMutation = { __typename?: 'Mutation', createTrigger: { __typename?: 'Trigger', id: string } };

export type UpdateWorkflowTriggerMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateTriggerInput;
}>;


export type UpdateWorkflowTriggerMutation = { __typename?: 'Mutation', updateTrigger: { __typename?: 'Trigger', id: string } };

export type DeleteWorkflowTriggerMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteWorkflowTriggerMutation = { __typename?: 'Mutation', deleteTrigger: boolean };

export type ApproveWorkflowRunStepMutationVariables = Exact<{
  stepId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ApproveWorkflowRunStepMutation = { __typename?: 'Mutation', approveWorkflowRunStep: boolean };

export type BlueprintConfigurationRevisionFragment = { __typename?: 'BlueprintConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

export type BlueprintConfigurationDetailFragment = { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null };

export type BlueprintDetailFragment = { __typename?: 'Blueprint', id: string, type: BlueprintType, isOfficial?: boolean | null, enabled?: boolean | null, configuration: { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null } };

export type BlueprintQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  blueprintId: Scalars['UUID'];
}>;


export type BlueprintQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType, isOfficial?: boolean | null, enabled?: boolean | null, configuration: { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null } } | null } | null };

export type BlueprintRevisionsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  blueprintId: Scalars['UUID'];
}>;


export type BlueprintRevisionsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, blueprint?: { __typename?: 'Blueprint', id: string, configurationRevisions: { __typename?: 'BlueprintConfigurationConnection', nodes: Array<{ __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null, revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | null } | null };

export type BuildArtifactsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  page: PageInput;
}>;


export type BuildArtifactsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, build?: { __typename?: 'Build', id: string, runs: { __typename?: 'BuildRunConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'BuildRun', id: string, sequence: number, artifacts?: Array<{ __typename?: 'BuildArtifact', id: string, image: string, createdAt: Date }> | null }> } } | null } | null } | null };

export type BuildRunListItemFragment = { __typename?: 'BuildRun', id: string, sequence: number, jobRun?: { __typename?: 'JobRun', id: string, createdAt: Date, state: JobRunState } | null, triggeredBy?: { __typename?: 'WorkflowRun', id: string, sequence: number } | null };

export type BuildRunDetailFragment = { __typename?: 'BuildRun', id: string, sequence: number, jobRun?: { __typename?: 'JobRun', id: string } | null, triggeredBy?: { __typename?: 'WorkflowRun', id: string, sequence: number } | null, definition?: { __typename?: 'BuildDefinition', id: string } | null, artifacts?: Array<{ __typename?: 'BuildArtifact', id: string, image: string, createdAt: Date }> | null };

export type BuildRunsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  page: PageInput;
}>;


export type BuildRunsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, build?: { __typename?: 'Build', id: string, runs: { __typename?: 'BuildRunConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'BuildRun', id: string, sequence: number, jobRun?: { __typename?: 'JobRun', id: string, createdAt: Date, state: JobRunState } | null, triggeredBy?: { __typename?: 'WorkflowRun', id: string, sequence: number } | null }> } } | null } | null } | null };

export type BuildRunDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  runId: Scalars['UUID'];
}>;


export type BuildRunDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, build?: { __typename?: 'Build', id: string, run?: { __typename?: 'BuildRun', id: string, sequence: number, jobRun?: { __typename?: 'JobRun', id: string } | null, triggeredBy?: { __typename?: 'WorkflowRun', id: string, sequence: number } | null, definition?: { __typename?: 'BuildDefinition', id: string } | null, artifacts?: Array<{ __typename?: 'BuildArtifact', id: string, image: string, createdAt: Date }> | null } | null } | null } | null } | null };

export type CloudRevisionsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  cloudId: Scalars['UUID'];
}>;


export type CloudRevisionsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, cloudAccount?: { __typename?: 'AWSAccount', id: string, configurationRevisions: { __typename?: 'AWSAccountConfigurationConnection', nodes: Array<{ __typename?: 'AWSAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'AzureAccount', id: string, configurationRevisions: { __typename?: 'AzureAccountConfigurationConnection', nodes: Array<{ __typename?: 'AzureAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'CoreWeaveAccount', id: string, configurationRevisions: { __typename?: 'CoreWeaveAccountConfigurationConnection', nodes: Array<{ __typename?: 'CoreWeaveAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'DOAccount', id: string, configurationRevisions: { __typename?: 'DOAccountConfigurationConnection', nodes: Array<{ __typename?: 'DOAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'GCPAccount', id: string, configurationRevisions: { __typename?: 'GCPAccountConfigurationConnection', nodes: Array<{ __typename?: 'GCPAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'LinodeAccount', id: string, configurationRevisions: { __typename?: 'LinodeAccountConfigurationConnection', nodes: Array<{ __typename?: 'LinodeAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | { __typename?: 'VultrAccount', id: string, configurationRevisions: { __typename?: 'VultrAccountConfigurationConnection', nodes: Array<{ __typename?: 'VultrAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | null } | null };

export type ClusterDetailV1Fragment = { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date };

export type ClusterDetailsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterDetailsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | null };

export type ClusterRevisionsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterRevisionsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, cluster?: { __typename?: 'Cluster', id: string, configurationRevisions: { __typename?: 'ClusterConfigurationConnection', nodes: Array<{ __typename?: 'ClusterConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } } | null } | null };

export type ClusterStatusQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterStatusQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, cluster?: { __typename?: 'Cluster', id: string, status?: ClusterStatus | null } | null } | null };

export type GroupsWithSubgroupsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type GroupsWithSubgroupsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, groups: { __typename?: 'GroupConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string, subGroups: Array<{ __typename?: 'SubGroup', id: string, name: string }> }> } } | null };

export type InsightsCloudsMetricQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type InsightsCloudsMetricQuery = { __typename?: 'Query', insights?: { __typename?: 'Insights', cloud?: { __typename?: 'CloudInsights', unhealthyClouds?: number | null } | null } | null };

export type InsightsClustersMetricQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type InsightsClustersMetricQuery = { __typename?: 'Query', insights?: { __typename?: 'Insights', cloud?: { __typename?: 'CloudInsights', unreachableClusters?: number | null } | null } | null };

export type JobListQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type JobListQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, jobs?: Array<{ __typename?: 'Job', id: string, definition: { __typename?: 'JobDefinition', jobName?: string | null }, runs: { __typename?: 'JobRunConnection', totalCount: number } }> | null } | null } | null };

export type JobRunListQueryVariables = Exact<{
  id: Scalars['UUID'];
  teamId: Scalars['UUID'];
  page: PageInput;
}>;


export type JobRunListQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, job?: { __typename?: 'Job', id: string, definition: { __typename?: 'JobDefinition', jobName?: string | null }, runs: { __typename?: 'JobRunConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'JobRun', id: string, sequence?: number | null, createdAt: Date, state: JobRunState }> } } | null } | null };

export type JobRunDetailQueryVariables = Exact<{
  id: Scalars['UUID'];
  teamId: Scalars['UUID'];
}>;


export type JobRunDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, jobRun?: { __typename?: 'JobRun', updatedAt: Date, command: string, exitCode?: number | null, errorMessage?: string | null, id: string, sequence?: number | null, createdAt: Date, state: JobRunState, definition: { __typename?: 'JobDefinition', jobName?: string | null } } | null } | null };

export type JobRunLogsQueryVariables = Exact<{
  id: Scalars['UUID'];
  teamId: Scalars['UUID'];
}>;


export type JobRunLogsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, jobRun?: { __typename?: 'JobRun', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | null } | null };

export type JobListItemFragment = { __typename?: 'Job', id: string, definition: { __typename?: 'JobDefinition', jobName?: string | null }, runs: { __typename?: 'JobRunConnection', totalCount: number } };

export type JobDetailItemFragment = { __typename?: 'Job', id: string, definition: { __typename?: 'JobDefinition', jobName?: string | null }, runs: { __typename?: 'JobRunConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'JobRun', id: string, sequence?: number | null, createdAt: Date, state: JobRunState }> } };

export type JobRunListItemFragment = { __typename?: 'JobRun', id: string, sequence?: number | null, createdAt: Date, state: JobRunState };

export type JobRunDetailFragment = { __typename?: 'JobRun', updatedAt: Date, command: string, exitCode?: number | null, errorMessage?: string | null, id: string, sequence?: number | null, createdAt: Date, state: JobRunState, definition: { __typename?: 'JobDefinition', jobName?: string | null } };

export type JobRunLogsFragment = { __typename?: 'JobRun', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null };

export type ObservabilityConfigQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ObservabilityConfigQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, observabilityConfig?: { __typename?: 'ObservabilityConfig', selector?: { __typename?: 'ObservabilityResourceSelector', type: ResourceType, namespace?: string | null, resourceName?: string | null, containerName?: string | null, labels?: Array<{ __typename?: 'ObservabilityResourceSelectorLabel', name: string, value: string }> | null } | null } | null } | null } | null };

export type CloudResourceFragment = { __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null };

export type MetricStreamV1Fragment = { __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null };

export type ResourcesWithMetricsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  clusterId: Scalars['UUID'];
  metricTypes: Array<MetricType> | MetricType;
  selector?: InputMaybe<ObservabilityResourceSelectorInput>;
}>;


export type ResourcesWithMetricsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null, metric?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null } | null } | null };

export type ResourcesWithLogsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  clusterId: Scalars['UUID'];
  selector?: InputMaybe<ObservabilityResourceSelectorInput>;
}>;


export type ResourcesWithLogsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, resources?: Array<{ __typename?: 'CloudResource', name: string, status: ResourceStatus, type: ResourceType, createdAt?: Date | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null, log?: Array<{ __typename?: 'Log', name: string, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null }> | null, owners?: Array<{ __typename?: 'ResourceOwner', name: string, type: ResourceType }> | null, events?: Array<{ __typename?: 'ResourceEvent', type: ResourceEventType, reason: string, message: string, action: string, occurredAt?: Date | null, firstOccurrenceAt?: Date | null, lastOccurrenceAt?: Date | null, count: number }> | null }> | null } | null } | null };

export type UserPersonalAccessTokensQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserPersonalAccessTokensQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, personalAccessTokens: Array<{ __typename?: 'PersonalAccessToken', id: string, name: string, token: string, createdAt: Date }> } };

export type ProjectsCountQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type ProjectsCountQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, projects?: { __typename?: 'ProjectConnection', totalCount: number } | null } | null };

export type ProjectsWithDeploymentTimesQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  input: ProjectsInput;
}>;


export type ProjectsWithDeploymentTimesQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, projects?: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, updatedAt: Date, deploymentTimestamps?: { __typename?: 'DeploymentTimestamps', lastUpdatedAt?: Date | null } | null }> } | null } | null };

export type ProjectsWithStatusQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  input: ProjectsInput;
}>;


export type ProjectsWithStatusQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, projects?: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, status: ProjectStatus }> } | null } | null };

export type ProjectWithStatusFragment = { __typename?: 'Project', id: string, status: ProjectStatus };

export type ProjectWithDeploymentTimeFragment = { __typename?: 'Project', id: string, updatedAt: Date, deploymentTimestamps?: { __typename?: 'DeploymentTimestamps', lastUpdatedAt?: Date | null } | null };

export type ProjectsWithBlueprintQueryVariables = Exact<{
  teamId: Scalars['UUID'];
}>;


export type ProjectsWithBlueprintQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, projects?: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType, configuration: { __typename?: 'BlueprintConfiguration', slug: string, logoUrl?: string | null } } | null }> } | null } | null };

export type ProjectWithBlueprintFragment = { __typename?: 'Project', id: string, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType, configuration: { __typename?: 'BlueprintConfiguration', slug: string, logoUrl?: string | null } } | null };

export type ProjectInfoQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectInfoQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, name: string, createdAt: Date, updatedAt: Date, status: ProjectStatus, build?: { __typename?: 'Build', id: string } | null, deploys: { __typename?: 'DeployConnection', totalCount: number }, workflow?: { __typename?: 'Workflow', id: string, runs: { __typename?: 'WorkflowRunConnection', nodes: Array<{ __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null }> } } | null, jobs?: Array<{ __typename?: 'Job', id: string }> | null, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType } | null } | null } | null };

export type ProjectStatusOnlyQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectStatusOnlyQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, status: ProjectStatus } | null } | null };

export type ProjectDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, name: string, createdAt: Date, updatedAt: Date, status: ProjectStatus, deploys: { __typename?: 'DeployConnection', totalCount: number, nodes: Array<{ __typename?: 'Deploy', id: string, name: string, branchName?: string | null, configuration?: { __typename?: 'DeploymentConfiguration', id: string, defaultWorkflowSteps: Array<BlueprintDriverWorkflowStepAction>, requirePlanApproval?: boolean | null, variables: Array<{ __typename?: 'DeployVariable', id: string, specId?: string | null, name: string, value: string, valueString?: string | null, valueBoolean?: boolean | null, valueInt?: number | null, valueFloat?: number | null, valueJson?: any | null }>, kubernetes?: { __typename?: 'DeploymentConfigurationKubernetes', blueprint?: { __typename?: 'BlueprintManifestConfiguration', useKustomize?: boolean | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'ManifestTargetConfiguration', clusterId: string, namespace?: string | null } | null, generator?: { __typename?: 'KubernetesGeneratorConfiguration', appId: string, branchName: string, productionBranchName: string, appGeneratorVersion: string, cpuRequest?: string | null, memoryRequest?: string | null, ephemeralStorage?: string | null, dedicated?: boolean | null, gpuRequest?: string | null, gpuType?: string | null, tpuType?: string | null, tpuTfVersion?: string | null, tpuCores?: number | null, replicas?: number | null, staticIp?: boolean | null, hostNetwork?: boolean | null, endpoint?: string | null, defaultIngressDomain?: string | null, deployStrategy?: DeployStrategy | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, logShipperType?: LogShipperType | null, betterstackToken?: string | null, datadogApmEnabled?: boolean | null, datadogHost?: string | null, datadogKey?: string | null, logDnaKey?: string | null, logzToken?: string | null, logzUrl?: string | null, syslogConfig?: string | null, dockerEntrypoint?: Array<string | null> | null, dockerCommand?: Array<string | null> | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, serviceAccountName?: string | null, annotations?: any | null, serviceAnnotations?: any | null, nodeSelector?: any | null, podSpecPatch?: string | null, containerRegistrySource?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null } | null> | null, autoscaling?: { __typename?: 'AutoscalingData', minReplicas: number, maxReplicas: number, coolDownPeriod: number, spec: string, kedaScaledObjectSpec?: any | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: string, spec: string } | null> | null } | null, ports?: Array<{ __typename?: 'PortData', port: string, https?: boolean | null, grpc?: boolean | null, public?: boolean | null, protocol?: string | null, loadBalancer?: boolean | null } | null> | null, volumes?: Array<{ __typename?: 'VolumeSpec', size: number, mountPath: string } | null> | null, secretMounts?: Array<{ __typename?: 'SecretMountData', secretName: string, mountPath: string, readOnly?: boolean | null } | null> | null, startupProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, livenessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, readinessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, legacyRepo?: { __typename?: 'LegacyRepo', id: string, name: string, appId: string } | null } | null } | null, helm?: { __typename?: 'DeploymentConfigurationKubernetesHelm', values?: any | null, blueprint?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'HelmTargetConfiguration', clusterId: string, namespace?: string | null, releaseName?: string | null } | null } | null, terraform?: { __typename?: 'DeploymentConfigurationTerraform', blueprint?: { __typename?: 'BlueprintTerraformConfiguration', terraformVersion?: string | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null, outputConfiguration?: { __typename?: 'TerraformOutputConfiguration', customization?: any | null, automatic?: { __typename?: 'TerraformAutomaticOutputConfiguration', disabled?: boolean | null, excluded?: Array<string> | null, sensitive?: boolean | null } | null } | null } | null, target?: { __typename?: 'TerraformTargetConfiguration', moduleName?: string | null, stateBackend?: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountId: string, region: string, bucketName: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountId: string, location: string, bucketName: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string, accessKey: string, secretAccessKey: string } | null } | null, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, doAccount?: { __typename?: 'DOAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null } | null, awsSam?: { __typename?: 'DeploymentConfigurationAwsSam', target?: { __typename?: 'AwsSamTargetConfiguration', awsAccountId?: string | null, awsRegion?: string | null, stackName?: string | null } | null, generator?: { __typename?: 'AwsSamGeneratorConfiguration', runCommand?: string | null, serverlessMemory?: number | null, serverlessArch?: string | null, customDomainHost?: string | null, customDomainCertificateArn?: string | null, httpPort?: string | null, buildImage?: string | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null, gcpCloudRun?: { __typename?: 'DeploymentConfigurationGcpCloudRun', target?: { __typename?: 'GcpCloudRunTargetConfiguration', gcpAccountId?: string | null, gcpRegion?: string | null } | null, generator?: { __typename?: 'GcpCloudRunGeneratorConfiguration', containerMemory?: number | null, name: string, httpPort?: string | null, runCommand?: string | null, containerCpu?: number | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null } | null }> }, build?: { __typename?: 'Build', id: string, definition: { __typename?: 'BuildDefinition', id: string } } | null, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType, configuration: { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null } } | null, group?: { __typename?: 'Group', id: string, name: string } | null, subGroup?: { __typename?: 'SubGroup', id: string, name: string } | null, workflow?: { __typename?: 'Workflow', id: string, runs: { __typename?: 'WorkflowRunConnection', nodes: Array<{ __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null }> } } | null, jobs?: Array<{ __typename?: 'Job', id: string }> | null } | null } | null };

export type ProjectInfoFragment = { __typename?: 'Project', id: string, name: string, createdAt: Date, updatedAt: Date, status: ProjectStatus, build?: { __typename?: 'Build', id: string } | null, deploys: { __typename?: 'DeployConnection', totalCount: number }, workflow?: { __typename?: 'Workflow', id: string, runs: { __typename?: 'WorkflowRunConnection', nodes: Array<{ __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null }> } } | null, jobs?: Array<{ __typename?: 'Job', id: string }> | null, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType } | null };

export type ProjectSourceDetailFragment = { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null };

export type ProjectDetailFragment = { __typename?: 'Project', id: string, name: string, createdAt: Date, updatedAt: Date, status: ProjectStatus, deploys: { __typename?: 'DeployConnection', totalCount: number, nodes: Array<{ __typename?: 'Deploy', id: string, name: string, branchName?: string | null, configuration?: { __typename?: 'DeploymentConfiguration', id: string, defaultWorkflowSteps: Array<BlueprintDriverWorkflowStepAction>, requirePlanApproval?: boolean | null, variables: Array<{ __typename?: 'DeployVariable', id: string, specId?: string | null, name: string, value: string, valueString?: string | null, valueBoolean?: boolean | null, valueInt?: number | null, valueFloat?: number | null, valueJson?: any | null }>, kubernetes?: { __typename?: 'DeploymentConfigurationKubernetes', blueprint?: { __typename?: 'BlueprintManifestConfiguration', useKustomize?: boolean | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'ManifestTargetConfiguration', clusterId: string, namespace?: string | null } | null, generator?: { __typename?: 'KubernetesGeneratorConfiguration', appId: string, branchName: string, productionBranchName: string, appGeneratorVersion: string, cpuRequest?: string | null, memoryRequest?: string | null, ephemeralStorage?: string | null, dedicated?: boolean | null, gpuRequest?: string | null, gpuType?: string | null, tpuType?: string | null, tpuTfVersion?: string | null, tpuCores?: number | null, replicas?: number | null, staticIp?: boolean | null, hostNetwork?: boolean | null, endpoint?: string | null, defaultIngressDomain?: string | null, deployStrategy?: DeployStrategy | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, logShipperType?: LogShipperType | null, betterstackToken?: string | null, datadogApmEnabled?: boolean | null, datadogHost?: string | null, datadogKey?: string | null, logDnaKey?: string | null, logzToken?: string | null, logzUrl?: string | null, syslogConfig?: string | null, dockerEntrypoint?: Array<string | null> | null, dockerCommand?: Array<string | null> | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, serviceAccountName?: string | null, annotations?: any | null, serviceAnnotations?: any | null, nodeSelector?: any | null, podSpecPatch?: string | null, containerRegistrySource?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null } | null> | null, autoscaling?: { __typename?: 'AutoscalingData', minReplicas: number, maxReplicas: number, coolDownPeriod: number, spec: string, kedaScaledObjectSpec?: any | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: string, spec: string } | null> | null } | null, ports?: Array<{ __typename?: 'PortData', port: string, https?: boolean | null, grpc?: boolean | null, public?: boolean | null, protocol?: string | null, loadBalancer?: boolean | null } | null> | null, volumes?: Array<{ __typename?: 'VolumeSpec', size: number, mountPath: string } | null> | null, secretMounts?: Array<{ __typename?: 'SecretMountData', secretName: string, mountPath: string, readOnly?: boolean | null } | null> | null, startupProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, livenessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, readinessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, legacyRepo?: { __typename?: 'LegacyRepo', id: string, name: string, appId: string } | null } | null } | null, helm?: { __typename?: 'DeploymentConfigurationKubernetesHelm', values?: any | null, blueprint?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'HelmTargetConfiguration', clusterId: string, namespace?: string | null, releaseName?: string | null } | null } | null, terraform?: { __typename?: 'DeploymentConfigurationTerraform', blueprint?: { __typename?: 'BlueprintTerraformConfiguration', terraformVersion?: string | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null, outputConfiguration?: { __typename?: 'TerraformOutputConfiguration', customization?: any | null, automatic?: { __typename?: 'TerraformAutomaticOutputConfiguration', disabled?: boolean | null, excluded?: Array<string> | null, sensitive?: boolean | null } | null } | null } | null, target?: { __typename?: 'TerraformTargetConfiguration', moduleName?: string | null, stateBackend?: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountId: string, region: string, bucketName: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountId: string, location: string, bucketName: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string, accessKey: string, secretAccessKey: string } | null } | null, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, doAccount?: { __typename?: 'DOAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null } | null, awsSam?: { __typename?: 'DeploymentConfigurationAwsSam', target?: { __typename?: 'AwsSamTargetConfiguration', awsAccountId?: string | null, awsRegion?: string | null, stackName?: string | null } | null, generator?: { __typename?: 'AwsSamGeneratorConfiguration', runCommand?: string | null, serverlessMemory?: number | null, serverlessArch?: string | null, customDomainHost?: string | null, customDomainCertificateArn?: string | null, httpPort?: string | null, buildImage?: string | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null, gcpCloudRun?: { __typename?: 'DeploymentConfigurationGcpCloudRun', target?: { __typename?: 'GcpCloudRunTargetConfiguration', gcpAccountId?: string | null, gcpRegion?: string | null } | null, generator?: { __typename?: 'GcpCloudRunGeneratorConfiguration', containerMemory?: number | null, name: string, httpPort?: string | null, runCommand?: string | null, containerCpu?: number | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null } | null }> }, build?: { __typename?: 'Build', id: string, definition: { __typename?: 'BuildDefinition', id: string } } | null, blueprint?: { __typename?: 'Blueprint', id: string, type: BlueprintType, configuration: { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null } } | null, group?: { __typename?: 'Group', id: string, name: string } | null, subGroup?: { __typename?: 'SubGroup', id: string, name: string } | null, workflow?: { __typename?: 'Workflow', id: string, runs: { __typename?: 'WorkflowRunConnection', nodes: Array<{ __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null }> } } | null, jobs?: Array<{ __typename?: 'Job', id: string }> | null };

export type ProjectBlueprintDetailFragment = { __typename?: 'Blueprint', id: string, type: BlueprintType, configuration: { __typename?: 'BlueprintConfiguration', slug: string, displayName: string, published: boolean, description?: string | null, tags: Array<string>, logoUrl?: string | null, richInputSchema?: any | null } };

export type DeployConfigurationDetailFragment = { __typename?: 'Deploy', id: string, name: string, branchName?: string | null, configuration?: { __typename?: 'DeploymentConfiguration', id: string, defaultWorkflowSteps: Array<BlueprintDriverWorkflowStepAction>, requirePlanApproval?: boolean | null, variables: Array<{ __typename?: 'DeployVariable', id: string, specId?: string | null, name: string, value: string, valueString?: string | null, valueBoolean?: boolean | null, valueInt?: number | null, valueFloat?: number | null, valueJson?: any | null }>, kubernetes?: { __typename?: 'DeploymentConfigurationKubernetes', blueprint?: { __typename?: 'BlueprintManifestConfiguration', useKustomize?: boolean | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'ManifestTargetConfiguration', clusterId: string, namespace?: string | null } | null, generator?: { __typename?: 'KubernetesGeneratorConfiguration', appId: string, branchName: string, productionBranchName: string, appGeneratorVersion: string, cpuRequest?: string | null, memoryRequest?: string | null, ephemeralStorage?: string | null, dedicated?: boolean | null, gpuRequest?: string | null, gpuType?: string | null, tpuType?: string | null, tpuTfVersion?: string | null, tpuCores?: number | null, replicas?: number | null, staticIp?: boolean | null, hostNetwork?: boolean | null, endpoint?: string | null, defaultIngressDomain?: string | null, deployStrategy?: DeployStrategy | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, logShipperType?: LogShipperType | null, betterstackToken?: string | null, datadogApmEnabled?: boolean | null, datadogHost?: string | null, datadogKey?: string | null, logDnaKey?: string | null, logzToken?: string | null, logzUrl?: string | null, syslogConfig?: string | null, dockerEntrypoint?: Array<string | null> | null, dockerCommand?: Array<string | null> | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, serviceAccountName?: string | null, annotations?: any | null, serviceAnnotations?: any | null, nodeSelector?: any | null, podSpecPatch?: string | null, containerRegistrySource?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null } | null> | null, autoscaling?: { __typename?: 'AutoscalingData', minReplicas: number, maxReplicas: number, coolDownPeriod: number, spec: string, kedaScaledObjectSpec?: any | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: string, spec: string } | null> | null } | null, ports?: Array<{ __typename?: 'PortData', port: string, https?: boolean | null, grpc?: boolean | null, public?: boolean | null, protocol?: string | null, loadBalancer?: boolean | null } | null> | null, volumes?: Array<{ __typename?: 'VolumeSpec', size: number, mountPath: string } | null> | null, secretMounts?: Array<{ __typename?: 'SecretMountData', secretName: string, mountPath: string, readOnly?: boolean | null } | null> | null, startupProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, livenessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, readinessProbe?: { __typename?: 'ProbeData', command?: string | null, initialDelaySeconds?: number | null, periodSeconds?: number | null, successThreshold?: number | null, failureThreshold?: number | null, timeoutSeconds?: number | null, http?: { __typename?: 'HTTPProbe', host: string, port: string, path: string } | null, tcp?: { __typename?: 'TCPProbe', host: string, port: string } | null } | null, legacyRepo?: { __typename?: 'LegacyRepo', id: string, name: string, appId: string } | null } | null } | null, helm?: { __typename?: 'DeploymentConfigurationKubernetesHelm', values?: any | null, blueprint?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null } | null, target?: { __typename?: 'HelmTargetConfiguration', clusterId: string, namespace?: string | null, releaseName?: string | null } | null } | null, terraform?: { __typename?: 'DeploymentConfigurationTerraform', blueprint?: { __typename?: 'BlueprintTerraformConfiguration', terraformVersion?: string | null, source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, ref?: string | null, path?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null, githubIntegrationId?: string | null, gitlabIntegrationId?: string | null } | null } | null, terraformModule?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationId?: number | null } | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', repositoryUrl: string, chart: string, version?: string | null } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryId?: string | null, registryUrl?: string | null, repository: string, tag?: string | null, digest?: string | null } | null } | null, outputConfiguration?: { __typename?: 'TerraformOutputConfiguration', customization?: any | null, automatic?: { __typename?: 'TerraformAutomaticOutputConfiguration', disabled?: boolean | null, excluded?: Array<string> | null, sensitive?: boolean | null } | null } | null } | null, target?: { __typename?: 'TerraformTargetConfiguration', moduleName?: string | null, stateBackend?: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountId: string, region: string, bucketName: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountId: string, location: string, bucketName: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string, accessKey: string, secretAccessKey: string } | null } | null, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, doAccount?: { __typename?: 'DOAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null } | null, awsSam?: { __typename?: 'DeploymentConfigurationAwsSam', target?: { __typename?: 'AwsSamTargetConfiguration', awsAccountId?: string | null, awsRegion?: string | null, stackName?: string | null } | null, generator?: { __typename?: 'AwsSamGeneratorConfiguration', runCommand?: string | null, serverlessMemory?: number | null, serverlessArch?: string | null, customDomainHost?: string | null, customDomainCertificateArn?: string | null, httpPort?: string | null, buildImage?: string | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null, gcpCloudRun?: { __typename?: 'DeploymentConfigurationGcpCloudRun', target?: { __typename?: 'GcpCloudRunTargetConfiguration', gcpAccountId?: string | null, gcpRegion?: string | null } | null, generator?: { __typename?: 'GcpCloudRunGeneratorConfiguration', containerMemory?: number | null, name: string, httpPort?: string | null, runCommand?: string | null, containerCpu?: number | null, envVars?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, createdAt: Date, updatedAt: Date, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null } | null } | null };

export type DeployVariableDetailFragment = { __typename?: 'DeployVariable', id: string, specId?: string | null, name: string, value: string, valueString?: string | null, valueBoolean?: boolean | null, valueInt?: number | null, valueFloat?: number | null, valueJson?: any | null };

export type ProjectOutputsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectOutputsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, status: ProjectStatus, connector?: { __typename?: 'ProjectConnector', type?: ProjectConnectorType | null, fields?: Array<{ __typename?: 'ProjectConnectorField', type?: VariableType | null, name?: string | null, displayName?: string | null, value?: string | null }> | null } | null, workflow?: { __typename?: 'Workflow', id: string } | null } | null } | null };

export type ProjectLinkDetailFragment = { __typename?: 'ProjectLink', id: string, linkType: ProjectLinkType, envPrefix?: string | null, project: { __typename?: 'Project', id: string, name: string }, provider: { __typename?: 'Project', id: string, name: string }, envs?: Array<{ __typename?: 'ProjectLinkEnvVar', name?: string | null, value?: string | null }> | null };

export type ProjectWithNameFragment = { __typename?: 'Project', id: string, name: string };

export type ProjectAvailableProvidersQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  linkType: ProjectLinkType;
}>;


export type ProjectAvailableProvidersQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, availableProviders: Array<{ __typename?: 'Project', id: string, name: string }> } | null } | null };

export type ProjectLinkedProjectsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  linkType: ProjectLinkType;
}>;


export type ProjectLinkedProjectsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, linkedProjects: { __typename?: 'ProjectLinkConnection', nodes: Array<{ __typename?: 'ProjectLink', id: string, linkType: ProjectLinkType, envPrefix?: string | null, project: { __typename?: 'Project', id: string, name: string }, provider: { __typename?: 'Project', id: string, name: string }, envs?: Array<{ __typename?: 'ProjectLinkEnvVar', name?: string | null, value?: string | null }> | null }> } } | null } | null };

export type ProjectWithClustersFragment = { __typename?: 'Project', id: string, clusters: Array<{ __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date }> };

export type ProjectClustersQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectClustersQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, clusters: Array<{ __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date }> } | null } | null };

export type ProjectOutputQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectOutputQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, output?: { __typename?: 'ProjectOutput', entries?: Array<{ __typename?: 'ProjectOutputEntry', displayName?: string | null, name?: string | null, type?: VariableType | null, value?: string | null }> | null } | null } | null } | null };

export type ProjectOutputFragment = { __typename?: 'Project', output?: { __typename?: 'ProjectOutput', entries?: Array<{ __typename?: 'ProjectOutputEntry', displayName?: string | null, name?: string | null, type?: VariableType | null, value?: string | null }> | null } | null };

export type OutputEntryDetailFragment = { __typename?: 'ProjectOutputEntry', displayName?: string | null, name?: string | null, type?: VariableType | null, value?: string | null };

export type ProjectDeploysQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type ProjectDeploysQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, deploys: { __typename?: 'DeployConnection', nodes: Array<{ __typename?: 'Deploy', id: string, name: string, runs?: { __typename?: 'DeployRunConnection', totalCount: number, nodes: Array<{ __typename?: 'DeployRun', id: string, sequence: number }> } | null }> } } | null } | null };

export type ProjectDeployDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  deployId: Scalars['UUID'];
}>;


export type ProjectDeployDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, deploy?: { __typename?: 'Deploy', id: string, name: string, runs?: { __typename?: 'DeployRunConnection', totalCount: number, nodes: Array<{ __typename?: 'DeployRun', id: string, sequence: number, result?: { __typename?: 'DeploymentResult', resources: { __typename?: 'ResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'CertificateResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null } | { __typename?: 'ContainerResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | { __typename?: 'EndpointResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null }> } } | null }> } | null } | null } | null };

export type ProjectDeployRevisionsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  page?: InputMaybe<PageInput>;
}>;


export type ProjectDeployRevisionsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, deploys: { __typename?: 'DeployConnection', totalCount: number, nodes: Array<{ __typename?: 'Deploy', id: string, name: string, configurationRevisions?: { __typename?: 'DeploymentConfigurationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'DeploymentConfiguration', id: string, revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } }> } | null }> } } | null } | null };

export type ProjectDeployRunDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  deployRunId: Scalars['UUID'];
}>;


export type ProjectDeployRunDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, deployRun: { __typename?: 'DeployRun', id: string, sequence: number, result?: { __typename?: 'DeploymentResult', resources: { __typename?: 'ResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'CertificateResource', displayName: string, externalId: string } | { __typename?: 'ContainerResource', displayName: string, externalId: string } | { __typename?: 'EndpointResource', displayName: string, externalId: string }> } } | null } } | null };

export type ResourceLogsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  resourceId: Scalars['UUID'];
}>;


export type ResourceLogsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, resource: { __typename?: 'CertificateResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null } | { __typename?: 'ContainerResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | { __typename?: 'EndpointResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null } } | null };

export type ProjectDeployListFragment = { __typename?: 'Deploy', id: string, name: string, runs?: { __typename?: 'DeployRunConnection', totalCount: number, nodes: Array<{ __typename?: 'DeployRun', id: string, sequence: number }> } | null };

export type ProjectDeployDetailFragment = { __typename?: 'Deploy', id: string, name: string, runs?: { __typename?: 'DeployRunConnection', totalCount: number, nodes: Array<{ __typename?: 'DeployRun', id: string, sequence: number, result?: { __typename?: 'DeploymentResult', resources: { __typename?: 'ResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'CertificateResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null } | { __typename?: 'ContainerResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | { __typename?: 'EndpointResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null }> } } | null }> } | null };

export type ProjectDeployRunListFragment = { __typename?: 'DeployRun', id: string, sequence: number, result?: { __typename?: 'DeploymentResult', resources: { __typename?: 'ResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'CertificateResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null } | { __typename?: 'ContainerResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | { __typename?: 'EndpointResource', displayName: string, externalId: string, externalLink?: string | null, externalType?: string | null }> } } | null };

export type ProjectDeployRunDetailFragment = { __typename?: 'DeployRun', id: string, sequence: number, result?: { __typename?: 'DeploymentResult', resources: { __typename?: 'ResourceConnection', totalCount: number, nodes: Array<{ __typename?: 'CertificateResource', displayName: string, externalId: string } | { __typename?: 'ContainerResource', displayName: string, externalId: string } | { __typename?: 'EndpointResource', displayName: string, externalId: string }> } } | null };

type ResourceLogs_CertificateResource_Fragment = { __typename?: 'CertificateResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null };

type ResourceLogs_ContainerResource_Fragment = { __typename?: 'ContainerResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null };

type ResourceLogs_EndpointResource_Fragment = { __typename?: 'EndpointResource', externalId: string, externalType?: string | null, externalLink?: string | null, displayName: string, status?: string | null };

export type ResourceLogsFragment = ResourceLogs_CertificateResource_Fragment | ResourceLogs_ContainerResource_Fragment | ResourceLogs_EndpointResource_Fragment;

type RevisionDetailV1_AwsAccountConfiguration_Fragment = { __typename?: 'AWSAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_AzureAccountConfiguration_Fragment = { __typename?: 'AzureAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_BlueprintConfiguration_Fragment = { __typename?: 'BlueprintConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_ClusterConfiguration_Fragment = { __typename?: 'ClusterConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_CoreWeaveAccountConfiguration_Fragment = { __typename?: 'CoreWeaveAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_DoAccountConfiguration_Fragment = { __typename?: 'DOAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_DeploymentConfiguration_Fragment = { __typename?: 'DeploymentConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_GcpAccountConfiguration_Fragment = { __typename?: 'GCPAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_LinodeAccountConfiguration_Fragment = { __typename?: 'LinodeAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

type RevisionDetailV1_VultrAccountConfiguration_Fragment = { __typename?: 'VultrAccountConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, sequenceId: number, description: string, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null }, authorInfo?: { __typename?: 'RevisionAuthorInfo', summary: string, creatorDeleted: boolean } | null } };

export type RevisionDetailV1Fragment = RevisionDetailV1_AwsAccountConfiguration_Fragment | RevisionDetailV1_AzureAccountConfiguration_Fragment | RevisionDetailV1_BlueprintConfiguration_Fragment | RevisionDetailV1_ClusterConfiguration_Fragment | RevisionDetailV1_CoreWeaveAccountConfiguration_Fragment | RevisionDetailV1_DoAccountConfiguration_Fragment | RevisionDetailV1_DeploymentConfiguration_Fragment | RevisionDetailV1_GcpAccountConfiguration_Fragment | RevisionDetailV1_LinodeAccountConfiguration_Fragment | RevisionDetailV1_VultrAccountConfiguration_Fragment;

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, name: string, login: any } };

export type WorkflowRunListItemFragment = { __typename?: 'WorkflowRun', id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null };

export type WorkflowRunDetailFragment = { __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null };

type WorkflowRunStepDetail_BuildRunStep_Fragment = { __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null };

type WorkflowRunStepDetail_ClusterPrecheckStep_Fragment = { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null };

type WorkflowRunStepDetail_DeployRunStep_Fragment = { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null };

type WorkflowRunStepDetail_DestroyRunStep_Fragment = { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null };

type WorkflowRunStepDetail_JobRunStep_Fragment = { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null };

export type WorkflowRunStepDetailFragment = WorkflowRunStepDetail_BuildRunStep_Fragment | WorkflowRunStepDetail_ClusterPrecheckStep_Fragment | WorkflowRunStepDetail_DeployRunStep_Fragment | WorkflowRunStepDetail_DestroyRunStep_Fragment | WorkflowRunStepDetail_JobRunStep_Fragment;

export type WorkflowRunsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  page: PageInput;
}>;


export type WorkflowRunsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, runs: { __typename?: 'WorkflowRunConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'WorkflowRun', id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null }> } } | null } | null } | null };

export type WorkflowRunDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  runId: Scalars['UUID'];
}>;


export type WorkflowRunDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, run: { __typename?: 'WorkflowRun', finishedAt?: Date | null, id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, outputs?: Array<{ __typename?: 'BuildArtifact', id: string, image: string } | null> | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null, cluster?: { __typename?: 'Cluster', id: string, displayName: string, state: ClusterState, connected?: boolean | null, cloudProvider?: CloudProvider | null, createdAt: Date, updatedAt: Date } | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } } | null } | null } | null };

export type WorkflowDetailFragment = { __typename?: 'Workflow', id: string, steps?: Array<{ __typename?: 'WorkflowStepDefinition', action: WorkflowStepActionType, sequenceNumber?: number | null, disabled?: boolean | null }> | null, triggers: { __typename?: 'TriggerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Trigger', id: string, action: TriggerActionType, events?: Array<TriggerEventType> | null, configuration?: { __typename?: 'TriggerConfiguration', event?: { __typename?: 'EventTriggerConfiguration', git?: { __typename?: 'GitEventTriggerConfiguration', repoId?: string | null, repoBranchName?: string | null, repoOwner?: string | null, repoName?: string | null, githubConnectionId?: number | null } | null } | null, action?: { __typename?: 'ActionTriggerConfiguration', workflowId?: string | null } | null } | null }> | null } };

export type WorkflowDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
}>;


export type WorkflowDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, steps?: Array<{ __typename?: 'WorkflowStepDefinition', action: WorkflowStepActionType, sequenceNumber?: number | null, disabled?: boolean | null }> | null, triggers: { __typename?: 'TriggerConnection', totalCount: number, nodes?: Array<{ __typename?: 'Trigger', id: string, action: TriggerActionType, events?: Array<TriggerEventType> | null, configuration?: { __typename?: 'TriggerConfiguration', event?: { __typename?: 'EventTriggerConfiguration', git?: { __typename?: 'GitEventTriggerConfiguration', repoId?: string | null, repoBranchName?: string | null, repoOwner?: string | null, repoName?: string | null, githubConnectionId?: number | null } | null } | null, action?: { __typename?: 'ActionTriggerConfiguration', workflowId?: string | null } | null } | null }> | null } } | null } | null } | null };

export type WorkflowRunDetailLogsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  runId: Scalars['UUID'];
  stepId: Scalars['UUID'];
}>;


export type WorkflowRunDetailLogsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, run: { __typename?: 'WorkflowRun', id: string, step: { __typename?: 'BuildRunStep', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } } } | null } | null } | null };

export type WorkflowRunStepNestedDetailQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  runId: Scalars['UUID'];
  stepId: Scalars['UUID'];
}>;


export type WorkflowRunStepNestedDetailQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, run: { __typename?: 'WorkflowRun', id: string, step: { __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null } | { __typename?: 'DestroyRunStep', id: string, workflowRun?: { __typename?: 'WorkflowRun', id: string, workflowId: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, steps?: Array<{ __typename?: 'BuildRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'ClusterPrecheckStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DeployRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'DestroyRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | { __typename?: 'JobRunStep', id: string, action: GenericWorkflowStepActionType, status: WorkflowRunStepStatus, sequenceNumber: number, createdAt: Date, updatedAt: Date, executionId?: string | null, executionType?: WorkflowExecutionType | null, executionError?: string | null, dependsOn?: Array<{ __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string }> | null } | null> | null } | null } | { __typename?: 'JobRunStep', id: string } } } | null } | null } | null };

export type WorkflowRunStepNestedDetailLogsQueryVariables = Exact<{
  teamId: Scalars['UUID'];
  projectId: Scalars['UUID'];
  runId: Scalars['UUID'];
  stepId: Scalars['UUID'];
  actionStepId: Scalars['UUID'];
}>;


export type WorkflowRunStepNestedDetailLogsQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, project?: { __typename?: 'Project', id: string, workflow?: { __typename?: 'Workflow', id: string, run: { __typename?: 'WorkflowRun', id: string, step: { __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string, workflowRun?: { __typename?: 'WorkflowRun', id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, step: { __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } } | null } | { __typename?: 'DestroyRunStep', id: string, workflowRun?: { __typename?: 'WorkflowRun', id: string, sequence: number, status: WorkflowRunStatus, createdAt: Date, step: { __typename?: 'BuildRunStep', id: string } | { __typename?: 'ClusterPrecheckStep', id: string } | { __typename?: 'DeployRunStep', id: string } | { __typename?: 'DestroyRunStep', id: string } | { __typename?: 'JobRunStep', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired?: boolean | null, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } } | null } | { __typename?: 'JobRunStep', id: string } } } | null } | null } | null };

export const RevisionDetailV1FragmentDoc = gql`
    fragment RevisionDetailV1 on RevisableEntity {
  revisionData
  revisionMetadata {
    id
    sequenceId
    description
    createdAt
    createdBy {
      id
      login
      name
      avatar
    }
    authorInfo {
      summary
      creatorDeleted
    }
  }
}
    `;
export const BlueprintConfigurationRevisionFragmentDoc = gql`
    fragment BlueprintConfigurationRevision on BlueprintConfiguration {
  ...RevisionDetailV1
}
    ${RevisionDetailV1FragmentDoc}`;
export const BlueprintConfigurationDetailFragmentDoc = gql`
    fragment BlueprintConfigurationDetail on BlueprintConfiguration {
  slug
  displayName
  published
  description
  tags
  logoUrl
  richInputSchema
}
    `;
export const BlueprintDetailFragmentDoc = gql`
    fragment BlueprintDetail on Blueprint {
  id
  type
  isOfficial
  enabled
  configuration {
    ...BlueprintConfigurationDetail
  }
}
    ${BlueprintConfigurationDetailFragmentDoc}`;
export const BuildRunListItemFragmentDoc = gql`
    fragment BuildRunListItem on BuildRun {
  id
  sequence
  jobRun {
    id
    createdAt
    state
  }
  triggeredBy {
    id
    sequence
  }
}
    `;
export const BuildRunDetailFragmentDoc = gql`
    fragment BuildRunDetail on BuildRun {
  id
  sequence
  jobRun {
    id
  }
  triggeredBy {
    id
    sequence
  }
  definition {
    id
  }
  artifacts {
    id
    image
    createdAt
  }
}
    `;
export const JobListItemFragmentDoc = gql`
    fragment JobListItem on Job {
  id
  definition {
    jobName
  }
  runs(input: {filter: {}, page: {first: 0}}) {
    totalCount
  }
}
    `;
export const JobRunListItemFragmentDoc = gql`
    fragment JobRunListItem on JobRun {
  id
  sequence
  createdAt
  state
}
    `;
export const JobDetailItemFragmentDoc = gql`
    fragment JobDetailItem on Job {
  id
  definition {
    jobName
  }
  runs(input: {filter: {}, page: $page}) {
    totalCount
    pageInfo {
      hasNextPage
    }
    nodes {
      ...JobRunListItem
    }
  }
}
    ${JobRunListItemFragmentDoc}`;
export const JobRunDetailFragmentDoc = gql`
    fragment JobRunDetail on JobRun {
  ...JobRunListItem
  updatedAt
  command
  exitCode
  errorMessage
  definition {
    jobName
  }
}
    ${JobRunListItemFragmentDoc}`;
export const JobRunLogsFragmentDoc = gql`
    fragment JobRunLogs on JobRun {
  id
  logs {
    id
    completed
    expired
    entries {
      timestamp
      text
    }
  }
}
    `;
export const CloudResourceFragmentDoc = gql`
    fragment CloudResource on CloudResource {
  name
  status
  type
  createdAt
  owners {
    name
    type
  }
  events {
    type
    reason
    message
    action
    occurredAt
    firstOccurrenceAt
    lastOccurrenceAt
    count
  }
}
    `;
export const MetricStreamV1FragmentDoc = gql`
    fragment MetricStreamV1 on MetricStream {
  type
  query
  annotations {
    type
    direction
    function
    label
    value
  }
  labels {
    label
    value
  }
  entries {
    value
    timestamp
  }
}
    `;
export const ProjectWithStatusFragmentDoc = gql`
    fragment ProjectWithStatus on Project {
  id
  status
}
    `;
export const ProjectWithDeploymentTimeFragmentDoc = gql`
    fragment ProjectWithDeploymentTime on Project {
  id
  deploymentTimestamps {
    lastUpdatedAt
  }
  updatedAt
}
    `;
export const ProjectWithBlueprintFragmentDoc = gql`
    fragment ProjectWithBlueprint on Project {
  id
  blueprint {
    id
    type
    configuration {
      slug
      logoUrl
    }
  }
}
    `;
export const WorkflowRunListItemFragmentDoc = gql`
    fragment WorkflowRunListItem on WorkflowRun {
  id
  sequence
  status
  createdAt
  steps {
    id
    action
    dependsOn {
      id
    }
    status
    sequenceNumber
    createdAt
    updatedAt
    executionId
    executionType
    ... on BuildRunStep {
      outputs {
        id
        image
      }
    }
    ... on DeployRunStep {
      workflowRun {
        id
        workflowId
        sequence
        status
        createdAt
        steps {
          id
          action
          dependsOn {
            id
          }
          status
          sequenceNumber
          createdAt
          updatedAt
          executionId
          executionType
        }
      }
    }
  }
}
    `;
export const ClusterDetailV1FragmentDoc = gql`
    fragment ClusterDetailV1 on Cluster {
  id
  displayName
  state
  connected
  cloudProvider
  createdAt
  updatedAt
}
    `;
export const WorkflowRunStepDetailFragmentDoc = gql`
    fragment WorkflowRunStepDetail on WorkflowRunStep {
  id
  action
  dependsOn {
    id
  }
  status
  sequenceNumber
  createdAt
  updatedAt
  executionId
  executionType
  executionError
  ... on BuildRunStep {
    outputs {
      id
      image
    }
  }
  ... on DeployRunStep {
    workflowRun {
      id
      workflowId
      sequence
      status
      createdAt
      steps {
        id
        action
        dependsOn {
          id
        }
        status
        sequenceNumber
        createdAt
        updatedAt
        executionId
        executionType
        executionError
      }
    }
  }
  ... on ClusterPrecheckStep {
    cluster {
      ...ClusterDetailV1
    }
  }
}
    ${ClusterDetailV1FragmentDoc}`;
export const WorkflowRunDetailFragmentDoc = gql`
    fragment WorkflowRunDetail on WorkflowRun {
  ...WorkflowRunListItem
  finishedAt
  steps {
    ...WorkflowRunStepDetail
  }
}
    ${WorkflowRunListItemFragmentDoc}
${WorkflowRunStepDetailFragmentDoc}`;
export const ProjectInfoFragmentDoc = gql`
    fragment ProjectInfo on Project {
  id
  name
  createdAt
  updatedAt
  status
  build {
    id
  }
  deploys {
    totalCount
  }
  workflow {
    id
    runs {
      nodes {
        ...WorkflowRunDetail
      }
    }
  }
  jobs {
    id
  }
  blueprint {
    id
    type
  }
}
    ${WorkflowRunDetailFragmentDoc}`;
export const DeployVariableDetailFragmentDoc = gql`
    fragment DeployVariableDetail on DeployVariable {
  id
  specId
  name
  value
  valueString
  valueBoolean
  valueInt
  valueFloat
  valueJson
}
    `;
export const ProjectSourceDetailFragmentDoc = gql`
    fragment ProjectSourceDetail on Source {
  git {
    repository
    ref
    path
    integration {
      githubInstallationId
      githubIntegrationId
      gitlabIntegrationId
    }
  }
  terraformModule {
    source
    version
    integration {
      git {
        githubInstallationId
      }
    }
  }
  helmRepository {
    repositoryUrl
    chart
    version
  }
  containerRegistry {
    registryId
    registryUrl
    repository
    tag
    digest
  }
}
    `;
export const DeployConfigurationDetailFragmentDoc = gql`
    fragment DeployConfigurationDetail on Deploy {
  id
  name
  branchName
  configuration {
    id
    defaultWorkflowSteps
    requirePlanApproval
    variables {
      ...DeployVariableDetail
    }
    kubernetes {
      blueprint {
        source {
          ...ProjectSourceDetail
        }
        useKustomize
      }
      target {
        clusterId
        namespace
      }
      generator {
        containerRegistrySource {
          registryId
          registryUrl
          repository
          tag
          digest
        }
        appId
        branchName
        productionBranchName
        envs {
          id
          name
          value
          visible
          sealed
          source {
            type
          }
          createdAt
          updatedAt
        }
        appGeneratorVersion
        cpuRequest
        memoryRequest
        ephemeralStorage
        dedicated
        gpuRequest
        gpuType
        tpuType
        tpuTfVersion
        tpuCores
        replicas
        autoscaling {
          minReplicas
          maxReplicas
          coolDownPeriod
          spec
          triggers {
            type
            spec
          }
          kedaScaledObjectSpec
        }
        ports {
          port
          https
          grpc
          public
          protocol
          loadBalancer
        }
        staticIp
        hostNetwork
        endpoint
        defaultIngressDomain
        volumes {
          size
          mountPath
        }
        secretMounts {
          secretName
          mountPath
          readOnly
        }
        deployStrategy
        preStopSleep
        terminationGracePeriodSeconds
        startupProbe {
          command
          http {
            host
            port
            path
          }
          tcp {
            host
            port
          }
          initialDelaySeconds
          periodSeconds
          successThreshold
          failureThreshold
          timeoutSeconds
        }
        livenessProbe {
          command
          http {
            host
            port
            path
          }
          tcp {
            host
            port
          }
          initialDelaySeconds
          periodSeconds
          successThreshold
          failureThreshold
          timeoutSeconds
        }
        readinessProbe {
          command
          http {
            host
            port
            path
          }
          tcp {
            host
            port
          }
          initialDelaySeconds
          periodSeconds
          successThreshold
          failureThreshold
          timeoutSeconds
        }
        logShipperType
        betterstackToken
        datadogApmEnabled
        datadogHost
        datadogKey
        logDnaKey
        logzToken
        logzUrl
        syslogConfig
        dockerEntrypoint
        dockerCommand
        awsIamRole
        gcpServiceAccount
        serviceAccountName
        annotations
        serviceAnnotations
        nodeSelector
        podSpecPatch
        legacyRepo {
          id
          name
          appId
        }
      }
    }
    helm {
      blueprint {
        source {
          ...ProjectSourceDetail
        }
      }
      target {
        clusterId
        namespace
        releaseName
      }
      values
    }
    terraform {
      blueprint {
        source {
          ...ProjectSourceDetail
        }
        outputConfiguration {
          automatic {
            disabled
            excluded
            sensitive
          }
          customization
        }
        terraformVersion
      }
      target {
        moduleName
        stateBackend {
          s3Bucket {
            awsAccountId
            region
            bucketName
            key
          }
          gcsBucket {
            gcpAccountId
            location
            bucketName
            prefix
          }
          linodeBucket {
            linodeAccountId
            bucketName
            region
            key
            accessKey
            secretAccessKey
          }
        }
        provider {
          awsAccount {
            id
          }
          gcpAccount {
            id
          }
          doAccount {
            id
          }
          linodeAccount {
            id
          }
          region
        }
      }
    }
    awsSam {
      target {
        awsAccountId
        awsRegion
        stackName
      }
      generator {
        envVars {
          id
          name
          value
          visible
          sealed
          source {
            type
          }
          createdAt
          updatedAt
        }
        runCommand
        serverlessMemory
        serverlessArch
        customDomainHost
        customDomainCertificateArn
        httpPort
        buildImage
      }
    }
    gcpCloudRun {
      target {
        gcpAccountId
        gcpRegion
      }
      generator {
        envVars {
          id
          name
          value
          visible
          sealed
          source {
            type
          }
          createdAt
          updatedAt
        }
        containerMemory
        name
        httpPort
        runCommand
        containerCpu
      }
    }
  }
}
    ${DeployVariableDetailFragmentDoc}
${ProjectSourceDetailFragmentDoc}`;
export const ProjectBlueprintDetailFragmentDoc = gql`
    fragment ProjectBlueprintDetail on Blueprint {
  id
  type
  configuration {
    ...BlueprintConfigurationDetail
  }
}
    ${BlueprintConfigurationDetailFragmentDoc}`;
export const ProjectDetailFragmentDoc = gql`
    fragment ProjectDetail on Project {
  ...ProjectInfo
  deploys {
    totalCount
    nodes {
      ...DeployConfigurationDetail
    }
  }
  build {
    id
    definition {
      id
    }
  }
  blueprint {
    ...ProjectBlueprintDetail
  }
  group {
    id
    name
  }
  subGroup {
    id
    name
  }
}
    ${ProjectInfoFragmentDoc}
${DeployConfigurationDetailFragmentDoc}
${ProjectBlueprintDetailFragmentDoc}`;
export const ProjectWithNameFragmentDoc = gql`
    fragment ProjectWithName on Project {
  id
  name
}
    `;
export const ProjectLinkDetailFragmentDoc = gql`
    fragment ProjectLinkDetail on ProjectLink {
  id
  project {
    ...ProjectWithName
  }
  provider {
    ...ProjectWithName
  }
  linkType
  envPrefix
  envs {
    name
    value
  }
}
    ${ProjectWithNameFragmentDoc}`;
export const ProjectWithClustersFragmentDoc = gql`
    fragment ProjectWithClusters on Project {
  id
  clusters {
    ...ClusterDetailV1
  }
}
    ${ClusterDetailV1FragmentDoc}`;
export const OutputEntryDetailFragmentDoc = gql`
    fragment OutputEntryDetail on ProjectOutputEntry {
  displayName
  name
  type
  value
}
    `;
export const ProjectOutputFragmentDoc = gql`
    fragment ProjectOutput on Project {
  output {
    entries {
      ...OutputEntryDetail
    }
  }
}
    ${OutputEntryDetailFragmentDoc}`;
export const ProjectDeployListFragmentDoc = gql`
    fragment ProjectDeployList on Deploy {
  id
  name
  runs(input: {first: 1}) {
    totalCount
    nodes {
      id
      sequence
    }
  }
}
    `;
export const ProjectDeployRunListFragmentDoc = gql`
    fragment ProjectDeployRunList on DeployRun {
  id
  sequence
  result {
    resources {
      totalCount
      nodes {
        displayName
        externalId
        externalLink
        externalType
        ... on ContainerResource {
          logs {
            id
            completed
            expired
            entries {
              text
              timestamp
            }
          }
        }
      }
    }
  }
}
    `;
export const ProjectDeployDetailFragmentDoc = gql`
    fragment ProjectDeployDetail on Deploy {
  id
  name
  runs {
    totalCount
    nodes {
      ...ProjectDeployRunList
    }
  }
}
    ${ProjectDeployRunListFragmentDoc}`;
export const ProjectDeployRunDetailFragmentDoc = gql`
    fragment ProjectDeployRunDetail on DeployRun {
  id
  sequence
  result {
    resources {
      totalCount
      nodes {
        displayName
        externalId
      }
    }
  }
}
    `;
export const ResourceLogsFragmentDoc = gql`
    fragment ResourceLogs on Resource {
  externalId
  externalType
  externalLink
  displayName
  status
  ... on ContainerResource {
    logs {
      id
      completed
      expired
      entries {
        text
        timestamp
      }
    }
  }
}
    `;
export const WorkflowDetailFragmentDoc = gql`
    fragment WorkflowDetail on Workflow {
  id
  steps {
    action
    sequenceNumber
    disabled
  }
  triggers {
    totalCount
    nodes {
      id
      action
      events
      configuration {
        event {
          git {
            repoId
            repoBranchName
            repoOwner
            repoName
            githubConnectionId
          }
        }
        action {
          workflowId
        }
      }
    }
  }
}
    `;
export const CreateBuildRunDocument = gql`
    mutation createBuildRun($buildId: UUID!) @api(name: v1) {
  createBuildRun(input: {buildId: $buildId}) {
    id
  }
}
    `;
export type CreateBuildRunMutationFn = Apollo.MutationFunction<CreateBuildRunMutation, CreateBuildRunMutationVariables>;

/**
 * __useCreateBuildRunMutation__
 *
 * To run a mutation, you first call `useCreateBuildRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildRunMutation, { data, loading, error }] = useCreateBuildRunMutation({
 *   variables: {
 *      buildId: // value for 'buildId'
 *   },
 * });
 */
export function useCreateBuildRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildRunMutation, CreateBuildRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildRunMutation, CreateBuildRunMutationVariables>(CreateBuildRunDocument, options);
      }
export type CreateBuildRunMutationHookResult = ReturnType<typeof useCreateBuildRunMutation>;
export type CreateBuildRunMutationResult = Apollo.MutationResult<CreateBuildRunMutation>;
export type CreateBuildRunMutationOptions = Apollo.BaseMutationOptions<CreateBuildRunMutation, CreateBuildRunMutationVariables>;
export const EjectClusterComponentDocument = gql`
    mutation ejectClusterComponent($clusterId: UUID!, $input: EjectClusterComponentInput!) @api(name: v1) {
  ejectClusterComponent(clusterId: $clusterId, input: $input) {
    name
    status
  }
}
    `;
export type EjectClusterComponentMutationFn = Apollo.MutationFunction<EjectClusterComponentMutation, EjectClusterComponentMutationVariables>;

/**
 * __useEjectClusterComponentMutation__
 *
 * To run a mutation, you first call `useEjectClusterComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEjectClusterComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ejectClusterComponentMutation, { data, loading, error }] = useEjectClusterComponentMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEjectClusterComponentMutation(baseOptions?: Apollo.MutationHookOptions<EjectClusterComponentMutation, EjectClusterComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EjectClusterComponentMutation, EjectClusterComponentMutationVariables>(EjectClusterComponentDocument, options);
      }
export type EjectClusterComponentMutationHookResult = ReturnType<typeof useEjectClusterComponentMutation>;
export type EjectClusterComponentMutationResult = Apollo.MutationResult<EjectClusterComponentMutation>;
export type EjectClusterComponentMutationOptions = Apollo.BaseMutationOptions<EjectClusterComponentMutation, EjectClusterComponentMutationVariables>;
export const UpdateDeployDocument = gql`
    mutation updateDeploy($id: UUID!, $input: UpdateDeployInput!) @api(name: v1) {
  updateDeploy(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateDeployMutationFn = Apollo.MutationFunction<UpdateDeployMutation, UpdateDeployMutationVariables>;

/**
 * __useUpdateDeployMutation__
 *
 * To run a mutation, you first call `useUpdateDeployMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeployMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeployMutation, { data, loading, error }] = useUpdateDeployMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeployMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeployMutation, UpdateDeployMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeployMutation, UpdateDeployMutationVariables>(UpdateDeployDocument, options);
      }
export type UpdateDeployMutationHookResult = ReturnType<typeof useUpdateDeployMutation>;
export type UpdateDeployMutationResult = Apollo.MutationResult<UpdateDeployMutation>;
export type UpdateDeployMutationOptions = Apollo.BaseMutationOptions<UpdateDeployMutation, UpdateDeployMutationVariables>;
export const CreateDeployRunDocument = gql`
    mutation createDeployRun($input: CreateDeployRunInput!) @api(name: v1) {
  createDeployRun(input: $input) {
    id
  }
}
    `;
export type CreateDeployRunMutationFn = Apollo.MutationFunction<CreateDeployRunMutation, CreateDeployRunMutationVariables>;

/**
 * __useCreateDeployRunMutation__
 *
 * To run a mutation, you first call `useCreateDeployRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeployRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeployRunMutation, { data, loading, error }] = useCreateDeployRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeployRunMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeployRunMutation, CreateDeployRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeployRunMutation, CreateDeployRunMutationVariables>(CreateDeployRunDocument, options);
      }
export type CreateDeployRunMutationHookResult = ReturnType<typeof useCreateDeployRunMutation>;
export type CreateDeployRunMutationResult = Apollo.MutationResult<CreateDeployRunMutation>;
export type CreateDeployRunMutationOptions = Apollo.BaseMutationOptions<CreateDeployRunMutation, CreateDeployRunMutationVariables>;
export const GenerateDownloadableLogLinkForWorkflowRunStepDocument = gql`
    mutation generateDownloadableLogLinkForWorkflowRunStep($actionStepId: UUID!) @api(name: v1) {
  generateDownloadableLogLinkForWorkflowRunStep(actionStepId: $actionStepId)
}
    `;
export type GenerateDownloadableLogLinkForWorkflowRunStepMutationFn = Apollo.MutationFunction<GenerateDownloadableLogLinkForWorkflowRunStepMutation, GenerateDownloadableLogLinkForWorkflowRunStepMutationVariables>;

/**
 * __useGenerateDownloadableLogLinkForWorkflowRunStepMutation__
 *
 * To run a mutation, you first call `useGenerateDownloadableLogLinkForWorkflowRunStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDownloadableLogLinkForWorkflowRunStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDownloadableLogLinkForWorkflowRunStepMutation, { data, loading, error }] = useGenerateDownloadableLogLinkForWorkflowRunStepMutation({
 *   variables: {
 *      actionStepId: // value for 'actionStepId'
 *   },
 * });
 */
export function useGenerateDownloadableLogLinkForWorkflowRunStepMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDownloadableLogLinkForWorkflowRunStepMutation, GenerateDownloadableLogLinkForWorkflowRunStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDownloadableLogLinkForWorkflowRunStepMutation, GenerateDownloadableLogLinkForWorkflowRunStepMutationVariables>(GenerateDownloadableLogLinkForWorkflowRunStepDocument, options);
      }
export type GenerateDownloadableLogLinkForWorkflowRunStepMutationHookResult = ReturnType<typeof useGenerateDownloadableLogLinkForWorkflowRunStepMutation>;
export type GenerateDownloadableLogLinkForWorkflowRunStepMutationResult = Apollo.MutationResult<GenerateDownloadableLogLinkForWorkflowRunStepMutation>;
export type GenerateDownloadableLogLinkForWorkflowRunStepMutationOptions = Apollo.BaseMutationOptions<GenerateDownloadableLogLinkForWorkflowRunStepMutation, GenerateDownloadableLogLinkForWorkflowRunStepMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: UUID!) @api(name: v1) {
  deleteGroup(id: $id)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const DeleteSubGroupDocument = gql`
    mutation deleteSubGroup($id: UUID!) @api(name: v1) {
  deleteSubGroup(id: $id)
}
    `;
export type DeleteSubGroupMutationFn = Apollo.MutationFunction<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>;

/**
 * __useDeleteSubGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSubGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubGroupMutation, { data, loading, error }] = useDeleteSubGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>(DeleteSubGroupDocument, options);
      }
export type DeleteSubGroupMutationHookResult = ReturnType<typeof useDeleteSubGroupMutation>;
export type DeleteSubGroupMutationResult = Apollo.MutationResult<DeleteSubGroupMutation>;
export type DeleteSubGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($input: CreateGroupInput!) @api(name: v1) {
  createGroup(input: $input) {
    id
    name
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateSubGroupDocument = gql`
    mutation createSubGroup($input: CreateSubGroupInput!) @api(name: v1) {
  createSubGroup(input: $input) {
    id
    name
  }
}
    `;
export type CreateSubGroupMutationFn = Apollo.MutationFunction<CreateSubGroupMutation, CreateSubGroupMutationVariables>;

/**
 * __useCreateSubGroupMutation__
 *
 * To run a mutation, you first call `useCreateSubGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubGroupMutation, { data, loading, error }] = useCreateSubGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubGroupMutation, CreateSubGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubGroupMutation, CreateSubGroupMutationVariables>(CreateSubGroupDocument, options);
      }
export type CreateSubGroupMutationHookResult = ReturnType<typeof useCreateSubGroupMutation>;
export type CreateSubGroupMutationResult = Apollo.MutationResult<CreateSubGroupMutation>;
export type CreateSubGroupMutationOptions = Apollo.BaseMutationOptions<CreateSubGroupMutation, CreateSubGroupMutationVariables>;
export const CreateUserPersonalAccessTokenDocument = gql`
    mutation createUserPersonalAccessToken($userId: UUID!, $name: String!) @api(name: v1) {
  createPersonalAccessTokenForUser(userId: $userId, input: {name: $name}) {
    id
    name
    token
    createdAt
  }
}
    `;
export type CreateUserPersonalAccessTokenMutationFn = Apollo.MutationFunction<CreateUserPersonalAccessTokenMutation, CreateUserPersonalAccessTokenMutationVariables>;

/**
 * __useCreateUserPersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateUserPersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPersonalAccessTokenMutation, { data, loading, error }] = useCreateUserPersonalAccessTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateUserPersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPersonalAccessTokenMutation, CreateUserPersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserPersonalAccessTokenMutation, CreateUserPersonalAccessTokenMutationVariables>(CreateUserPersonalAccessTokenDocument, options);
      }
export type CreateUserPersonalAccessTokenMutationHookResult = ReturnType<typeof useCreateUserPersonalAccessTokenMutation>;
export type CreateUserPersonalAccessTokenMutationResult = Apollo.MutationResult<CreateUserPersonalAccessTokenMutation>;
export type CreateUserPersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<CreateUserPersonalAccessTokenMutation, CreateUserPersonalAccessTokenMutationVariables>;
export const DeleteUserPersonalAccessTokenDocument = gql`
    mutation deleteUserPersonalAccessToken($id: UUID!) @api(name: v1) {
  deletePersonalAccessToken(id: $id)
}
    `;
export type DeleteUserPersonalAccessTokenMutationFn = Apollo.MutationFunction<DeleteUserPersonalAccessTokenMutation, DeleteUserPersonalAccessTokenMutationVariables>;

/**
 * __useDeleteUserPersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useDeleteUserPersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPersonalAccessTokenMutation, { data, loading, error }] = useDeleteUserPersonalAccessTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserPersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserPersonalAccessTokenMutation, DeleteUserPersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserPersonalAccessTokenMutation, DeleteUserPersonalAccessTokenMutationVariables>(DeleteUserPersonalAccessTokenDocument, options);
      }
export type DeleteUserPersonalAccessTokenMutationHookResult = ReturnType<typeof useDeleteUserPersonalAccessTokenMutation>;
export type DeleteUserPersonalAccessTokenMutationResult = Apollo.MutationResult<DeleteUserPersonalAccessTokenMutation>;
export type DeleteUserPersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<DeleteUserPersonalAccessTokenMutation, DeleteUserPersonalAccessTokenMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($input: CreateProjectInput!) @api(name: v1) {
  createProject(input: $input) {
    id
    name
    workflow {
      id
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: UUID!, $input: UpdateProjectInput!) @api(name: v1) {
  updateProject(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const DuplicateProjectDocument = gql`
    mutation duplicateProject($id: UUID!, $input: DuplicateProjectInput!) @api(name: v1) {
  duplicateProject(id: $id, input: $input) {
    id
    name
    group {
      id
      name
    }
    subGroup {
      id
      name
    }
  }
}
    `;
export type DuplicateProjectMutationFn = Apollo.MutationFunction<DuplicateProjectMutation, DuplicateProjectMutationVariables>;

/**
 * __useDuplicateProjectMutation__
 *
 * To run a mutation, you first call `useDuplicateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProjectMutation, { data, loading, error }] = useDuplicateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateProjectMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProjectMutation, DuplicateProjectMutationVariables>(DuplicateProjectDocument, options);
      }
export type DuplicateProjectMutationHookResult = ReturnType<typeof useDuplicateProjectMutation>;
export type DuplicateProjectMutationResult = Apollo.MutationResult<DuplicateProjectMutation>;
export type DuplicateProjectMutationOptions = Apollo.BaseMutationOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($id: UUID!, $force: Boolean) @api(name: v1) {
  deleteProject(id: $id, force: $force)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteProjectResourcesDocument = gql`
    mutation deleteProjectResources($id: UUID!) @api(name: v1) {
  deleteProjectResources(id: $id)
}
    `;
export type DeleteProjectResourcesMutationFn = Apollo.MutationFunction<DeleteProjectResourcesMutation, DeleteProjectResourcesMutationVariables>;

/**
 * __useDeleteProjectResourcesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectResourcesMutation, { data, loading, error }] = useDeleteProjectResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectResourcesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectResourcesMutation, DeleteProjectResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectResourcesMutation, DeleteProjectResourcesMutationVariables>(DeleteProjectResourcesDocument, options);
      }
export type DeleteProjectResourcesMutationHookResult = ReturnType<typeof useDeleteProjectResourcesMutation>;
export type DeleteProjectResourcesMutationResult = Apollo.MutationResult<DeleteProjectResourcesMutation>;
export type DeleteProjectResourcesMutationOptions = Apollo.BaseMutationOptions<DeleteProjectResourcesMutation, DeleteProjectResourcesMutationVariables>;
export const DeleteProjectAndResourcesDocument = gql`
    mutation deleteProjectAndResources($id: UUID!, $deleteOnFailure: Boolean) @api(name: v1) {
  deleteProjectAndResources(id: $id, deleteOnFailure: $deleteOnFailure)
}
    `;
export type DeleteProjectAndResourcesMutationFn = Apollo.MutationFunction<DeleteProjectAndResourcesMutation, DeleteProjectAndResourcesMutationVariables>;

/**
 * __useDeleteProjectAndResourcesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAndResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAndResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAndResourcesMutation, { data, loading, error }] = useDeleteProjectAndResourcesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteOnFailure: // value for 'deleteOnFailure'
 *   },
 * });
 */
export function useDeleteProjectAndResourcesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAndResourcesMutation, DeleteProjectAndResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAndResourcesMutation, DeleteProjectAndResourcesMutationVariables>(DeleteProjectAndResourcesDocument, options);
      }
export type DeleteProjectAndResourcesMutationHookResult = ReturnType<typeof useDeleteProjectAndResourcesMutation>;
export type DeleteProjectAndResourcesMutationResult = Apollo.MutationResult<DeleteProjectAndResourcesMutation>;
export type DeleteProjectAndResourcesMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAndResourcesMutation, DeleteProjectAndResourcesMutationVariables>;
export const LinkProjectDocument = gql`
    mutation linkProject($input: ProjectLinkInput!) @api(name: v1) {
  linkProject(input: $input) {
    id
  }
}
    `;
export type LinkProjectMutationFn = Apollo.MutationFunction<LinkProjectMutation, LinkProjectMutationVariables>;

/**
 * __useLinkProjectMutation__
 *
 * To run a mutation, you first call `useLinkProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkProjectMutation, { data, loading, error }] = useLinkProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkProjectMutation(baseOptions?: Apollo.MutationHookOptions<LinkProjectMutation, LinkProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkProjectMutation, LinkProjectMutationVariables>(LinkProjectDocument, options);
      }
export type LinkProjectMutationHookResult = ReturnType<typeof useLinkProjectMutation>;
export type LinkProjectMutationResult = Apollo.MutationResult<LinkProjectMutation>;
export type LinkProjectMutationOptions = Apollo.BaseMutationOptions<LinkProjectMutation, LinkProjectMutationVariables>;
export const UnlinkProjectDocument = gql`
    mutation unlinkProject($id: UUID!) @api(name: v1) {
  unlinkProject(id: $id)
}
    `;
export type UnlinkProjectMutationFn = Apollo.MutationFunction<UnlinkProjectMutation, UnlinkProjectMutationVariables>;

/**
 * __useUnlinkProjectMutation__
 *
 * To run a mutation, you first call `useUnlinkProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkProjectMutation, { data, loading, error }] = useUnlinkProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkProjectMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkProjectMutation, UnlinkProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkProjectMutation, UnlinkProjectMutationVariables>(UnlinkProjectDocument, options);
      }
export type UnlinkProjectMutationHookResult = ReturnType<typeof useUnlinkProjectMutation>;
export type UnlinkProjectMutationResult = Apollo.MutationResult<UnlinkProjectMutation>;
export type UnlinkProjectMutationOptions = Apollo.BaseMutationOptions<UnlinkProjectMutation, UnlinkProjectMutationVariables>;
export const AbortWorkflowRunDocument = gql`
    mutation abortWorkflowRun($id: UUID!) @api(name: v1) {
  abortWorkflowRun(id: $id)
}
    `;
export type AbortWorkflowRunMutationFn = Apollo.MutationFunction<AbortWorkflowRunMutation, AbortWorkflowRunMutationVariables>;

/**
 * __useAbortWorkflowRunMutation__
 *
 * To run a mutation, you first call `useAbortWorkflowRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortWorkflowRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortWorkflowRunMutation, { data, loading, error }] = useAbortWorkflowRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAbortWorkflowRunMutation(baseOptions?: Apollo.MutationHookOptions<AbortWorkflowRunMutation, AbortWorkflowRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortWorkflowRunMutation, AbortWorkflowRunMutationVariables>(AbortWorkflowRunDocument, options);
      }
export type AbortWorkflowRunMutationHookResult = ReturnType<typeof useAbortWorkflowRunMutation>;
export type AbortWorkflowRunMutationResult = Apollo.MutationResult<AbortWorkflowRunMutation>;
export type AbortWorkflowRunMutationOptions = Apollo.BaseMutationOptions<AbortWorkflowRunMutation, AbortWorkflowRunMutationVariables>;
export const SubmitWorkflowRunDocument = gql`
    mutation submitWorkflowRun($workflowId: UUID!, $definition: WorkflowRunDefinitionInput) @api(name: v1) {
  submitWorkflow(input: {workflowId: $workflowId, definition: $definition}) {
    id
  }
}
    `;
export type SubmitWorkflowRunMutationFn = Apollo.MutationFunction<SubmitWorkflowRunMutation, SubmitWorkflowRunMutationVariables>;

/**
 * __useSubmitWorkflowRunMutation__
 *
 * To run a mutation, you first call `useSubmitWorkflowRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWorkflowRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWorkflowRunMutation, { data, loading, error }] = useSubmitWorkflowRunMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      definition: // value for 'definition'
 *   },
 * });
 */
export function useSubmitWorkflowRunMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWorkflowRunMutation, SubmitWorkflowRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWorkflowRunMutation, SubmitWorkflowRunMutationVariables>(SubmitWorkflowRunDocument, options);
      }
export type SubmitWorkflowRunMutationHookResult = ReturnType<typeof useSubmitWorkflowRunMutation>;
export type SubmitWorkflowRunMutationResult = Apollo.MutationResult<SubmitWorkflowRunMutation>;
export type SubmitWorkflowRunMutationOptions = Apollo.BaseMutationOptions<SubmitWorkflowRunMutation, SubmitWorkflowRunMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation updateWorkflow($id: UUID!, $input: UpdateWorkflowInput!) @api(name: v1) {
  updateWorkflow(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateWorkflowMutationFn = Apollo.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutation, { data, loading, error }] = useUpdateWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutationHookResult = ReturnType<typeof useUpdateWorkflowMutation>;
export type UpdateWorkflowMutationResult = Apollo.MutationResult<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const CreateWorkflowTriggerDocument = gql`
    mutation createWorkflowTrigger($input: CreateTriggerInput!) @api(name: v1) {
  createTrigger(input: $input) {
    id
  }
}
    `;
export type CreateWorkflowTriggerMutationFn = Apollo.MutationFunction<CreateWorkflowTriggerMutation, CreateWorkflowTriggerMutationVariables>;

/**
 * __useCreateWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowTriggerMutation, { data, loading, error }] = useCreateWorkflowTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowTriggerMutation, CreateWorkflowTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowTriggerMutation, CreateWorkflowTriggerMutationVariables>(CreateWorkflowTriggerDocument, options);
      }
export type CreateWorkflowTriggerMutationHookResult = ReturnType<typeof useCreateWorkflowTriggerMutation>;
export type CreateWorkflowTriggerMutationResult = Apollo.MutationResult<CreateWorkflowTriggerMutation>;
export type CreateWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowTriggerMutation, CreateWorkflowTriggerMutationVariables>;
export const UpdateWorkflowTriggerDocument = gql`
    mutation updateWorkflowTrigger($id: UUID!, $input: UpdateTriggerInput!) @api(name: v1) {
  updateTrigger(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateWorkflowTriggerMutationFn = Apollo.MutationFunction<UpdateWorkflowTriggerMutation, UpdateWorkflowTriggerMutationVariables>;

/**
 * __useUpdateWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowTriggerMutation, { data, loading, error }] = useUpdateWorkflowTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowTriggerMutation, UpdateWorkflowTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowTriggerMutation, UpdateWorkflowTriggerMutationVariables>(UpdateWorkflowTriggerDocument, options);
      }
export type UpdateWorkflowTriggerMutationHookResult = ReturnType<typeof useUpdateWorkflowTriggerMutation>;
export type UpdateWorkflowTriggerMutationResult = Apollo.MutationResult<UpdateWorkflowTriggerMutation>;
export type UpdateWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowTriggerMutation, UpdateWorkflowTriggerMutationVariables>;
export const DeleteWorkflowTriggerDocument = gql`
    mutation deleteWorkflowTrigger($id: UUID!) @api(name: v1) {
  deleteTrigger(id: $id)
}
    `;
export type DeleteWorkflowTriggerMutationFn = Apollo.MutationFunction<DeleteWorkflowTriggerMutation, DeleteWorkflowTriggerMutationVariables>;

/**
 * __useDeleteWorkflowTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowTriggerMutation, { data, loading, error }] = useDeleteWorkflowTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkflowTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowTriggerMutation, DeleteWorkflowTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowTriggerMutation, DeleteWorkflowTriggerMutationVariables>(DeleteWorkflowTriggerDocument, options);
      }
export type DeleteWorkflowTriggerMutationHookResult = ReturnType<typeof useDeleteWorkflowTriggerMutation>;
export type DeleteWorkflowTriggerMutationResult = Apollo.MutationResult<DeleteWorkflowTriggerMutation>;
export type DeleteWorkflowTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowTriggerMutation, DeleteWorkflowTriggerMutationVariables>;
export const ApproveWorkflowRunStepDocument = gql`
    mutation approveWorkflowRunStep($stepId: UUID!, $projectId: UUID!) @api(name: v1) {
  approveWorkflowRunStep(stepId: $stepId, projectId: $projectId)
}
    `;
export type ApproveWorkflowRunStepMutationFn = Apollo.MutationFunction<ApproveWorkflowRunStepMutation, ApproveWorkflowRunStepMutationVariables>;

/**
 * __useApproveWorkflowRunStepMutation__
 *
 * To run a mutation, you first call `useApproveWorkflowRunStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWorkflowRunStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWorkflowRunStepMutation, { data, loading, error }] = useApproveWorkflowRunStepMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApproveWorkflowRunStepMutation(baseOptions?: Apollo.MutationHookOptions<ApproveWorkflowRunStepMutation, ApproveWorkflowRunStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveWorkflowRunStepMutation, ApproveWorkflowRunStepMutationVariables>(ApproveWorkflowRunStepDocument, options);
      }
export type ApproveWorkflowRunStepMutationHookResult = ReturnType<typeof useApproveWorkflowRunStepMutation>;
export type ApproveWorkflowRunStepMutationResult = Apollo.MutationResult<ApproveWorkflowRunStepMutation>;
export type ApproveWorkflowRunStepMutationOptions = Apollo.BaseMutationOptions<ApproveWorkflowRunStepMutation, ApproveWorkflowRunStepMutationVariables>;
export const BlueprintDocument = gql`
    query blueprint($teamId: UUID!, $blueprintId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    blueprint(id: $blueprintId) {
      ...BlueprintDetail
    }
  }
}
    ${BlueprintDetailFragmentDoc}`;

/**
 * __useBlueprintQuery__
 *
 * To run a query within a React component, call `useBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      blueprintId: // value for 'blueprintId'
 *   },
 * });
 */
export function useBlueprintQuery(baseOptions: Apollo.QueryHookOptions<BlueprintQuery, BlueprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintQuery, BlueprintQueryVariables>(BlueprintDocument, options);
      }
export function useBlueprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintQuery, BlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintQuery, BlueprintQueryVariables>(BlueprintDocument, options);
        }
export type BlueprintQueryHookResult = ReturnType<typeof useBlueprintQuery>;
export type BlueprintLazyQueryHookResult = ReturnType<typeof useBlueprintLazyQuery>;
export type BlueprintQueryResult = Apollo.QueryResult<BlueprintQuery, BlueprintQueryVariables>;
export function refetchBlueprintQuery(variables: BlueprintQueryVariables) {
      return { query: BlueprintDocument, variables: variables }
    }
export const BlueprintRevisionsDocument = gql`
    query blueprintRevisions($teamId: UUID!, $blueprintId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    blueprint(id: $blueprintId) {
      id
      configurationRevisions {
        nodes {
          ...BlueprintConfigurationDetail
          ...BlueprintConfigurationRevision
        }
      }
    }
  }
}
    ${BlueprintConfigurationDetailFragmentDoc}
${BlueprintConfigurationRevisionFragmentDoc}`;

/**
 * __useBlueprintRevisionsQuery__
 *
 * To run a query within a React component, call `useBlueprintRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintRevisionsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      blueprintId: // value for 'blueprintId'
 *   },
 * });
 */
export function useBlueprintRevisionsQuery(baseOptions: Apollo.QueryHookOptions<BlueprintRevisionsQuery, BlueprintRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintRevisionsQuery, BlueprintRevisionsQueryVariables>(BlueprintRevisionsDocument, options);
      }
export function useBlueprintRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintRevisionsQuery, BlueprintRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintRevisionsQuery, BlueprintRevisionsQueryVariables>(BlueprintRevisionsDocument, options);
        }
export type BlueprintRevisionsQueryHookResult = ReturnType<typeof useBlueprintRevisionsQuery>;
export type BlueprintRevisionsLazyQueryHookResult = ReturnType<typeof useBlueprintRevisionsLazyQuery>;
export type BlueprintRevisionsQueryResult = Apollo.QueryResult<BlueprintRevisionsQuery, BlueprintRevisionsQueryVariables>;
export function refetchBlueprintRevisionsQuery(variables: BlueprintRevisionsQueryVariables) {
      return { query: BlueprintRevisionsDocument, variables: variables }
    }
export const BuildArtifactsDocument = gql`
    query buildArtifacts($teamId: UUID!, $projectId: UUID!, $page: PageInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      build {
        id
        runs(input: {filter: {}, page: $page}) {
          totalCount
          pageInfo {
            hasNextPage
          }
          nodes {
            id
            sequence
            artifacts {
              id
              image
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBuildArtifactsQuery__
 *
 * To run a query within a React component, call `useBuildArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildArtifactsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBuildArtifactsQuery(baseOptions: Apollo.QueryHookOptions<BuildArtifactsQuery, BuildArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildArtifactsQuery, BuildArtifactsQueryVariables>(BuildArtifactsDocument, options);
      }
export function useBuildArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildArtifactsQuery, BuildArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildArtifactsQuery, BuildArtifactsQueryVariables>(BuildArtifactsDocument, options);
        }
export type BuildArtifactsQueryHookResult = ReturnType<typeof useBuildArtifactsQuery>;
export type BuildArtifactsLazyQueryHookResult = ReturnType<typeof useBuildArtifactsLazyQuery>;
export type BuildArtifactsQueryResult = Apollo.QueryResult<BuildArtifactsQuery, BuildArtifactsQueryVariables>;
export function refetchBuildArtifactsQuery(variables: BuildArtifactsQueryVariables) {
      return { query: BuildArtifactsDocument, variables: variables }
    }
export const BuildRunsDocument = gql`
    query buildRuns($teamId: UUID!, $projectId: UUID!, $page: PageInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      build {
        id
        runs(input: {page: $page, filter: {}}) {
          totalCount
          pageInfo {
            hasNextPage
          }
          nodes {
            ...BuildRunListItem
          }
        }
      }
    }
  }
}
    ${BuildRunListItemFragmentDoc}`;

/**
 * __useBuildRunsQuery__
 *
 * To run a query within a React component, call `useBuildRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildRunsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBuildRunsQuery(baseOptions: Apollo.QueryHookOptions<BuildRunsQuery, BuildRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildRunsQuery, BuildRunsQueryVariables>(BuildRunsDocument, options);
      }
export function useBuildRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildRunsQuery, BuildRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildRunsQuery, BuildRunsQueryVariables>(BuildRunsDocument, options);
        }
export type BuildRunsQueryHookResult = ReturnType<typeof useBuildRunsQuery>;
export type BuildRunsLazyQueryHookResult = ReturnType<typeof useBuildRunsLazyQuery>;
export type BuildRunsQueryResult = Apollo.QueryResult<BuildRunsQuery, BuildRunsQueryVariables>;
export function refetchBuildRunsQuery(variables: BuildRunsQueryVariables) {
      return { query: BuildRunsDocument, variables: variables }
    }
export const BuildRunDetailDocument = gql`
    query buildRunDetail($teamId: UUID!, $projectId: UUID!, $runId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      build {
        id
        run(id: $runId) {
          ...BuildRunDetail
        }
      }
    }
  }
}
    ${BuildRunDetailFragmentDoc}`;

/**
 * __useBuildRunDetailQuery__
 *
 * To run a query within a React component, call `useBuildRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildRunDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useBuildRunDetailQuery(baseOptions: Apollo.QueryHookOptions<BuildRunDetailQuery, BuildRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildRunDetailQuery, BuildRunDetailQueryVariables>(BuildRunDetailDocument, options);
      }
export function useBuildRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildRunDetailQuery, BuildRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildRunDetailQuery, BuildRunDetailQueryVariables>(BuildRunDetailDocument, options);
        }
export type BuildRunDetailQueryHookResult = ReturnType<typeof useBuildRunDetailQuery>;
export type BuildRunDetailLazyQueryHookResult = ReturnType<typeof useBuildRunDetailLazyQuery>;
export type BuildRunDetailQueryResult = Apollo.QueryResult<BuildRunDetailQuery, BuildRunDetailQueryVariables>;
export function refetchBuildRunDetailQuery(variables: BuildRunDetailQueryVariables) {
      return { query: BuildRunDetailDocument, variables: variables }
    }
export const CloudRevisionsDocument = gql`
    query cloudRevisions($teamId: UUID!, $cloudId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    cloudAccount(id: $cloudId) {
      ... on AWSAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on AzureAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on GCPAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on DOAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on LinodeAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on VultrAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
      ... on CoreWeaveAccount {
        id
        configurationRevisions {
          nodes {
            ...RevisionDetailV1
          }
        }
      }
    }
  }
}
    ${RevisionDetailV1FragmentDoc}`;

/**
 * __useCloudRevisionsQuery__
 *
 * To run a query within a React component, call `useCloudRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudRevisionsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      cloudId: // value for 'cloudId'
 *   },
 * });
 */
export function useCloudRevisionsQuery(baseOptions: Apollo.QueryHookOptions<CloudRevisionsQuery, CloudRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudRevisionsQuery, CloudRevisionsQueryVariables>(CloudRevisionsDocument, options);
      }
export function useCloudRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudRevisionsQuery, CloudRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudRevisionsQuery, CloudRevisionsQueryVariables>(CloudRevisionsDocument, options);
        }
export type CloudRevisionsQueryHookResult = ReturnType<typeof useCloudRevisionsQuery>;
export type CloudRevisionsLazyQueryHookResult = ReturnType<typeof useCloudRevisionsLazyQuery>;
export type CloudRevisionsQueryResult = Apollo.QueryResult<CloudRevisionsQuery, CloudRevisionsQueryVariables>;
export function refetchCloudRevisionsQuery(variables: CloudRevisionsQueryVariables) {
      return { query: CloudRevisionsDocument, variables: variables }
    }
export const ClusterDetailsDocument = gql`
    query clusterDetails($teamId: UUID!, $clusterId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    cluster(id: $clusterId) {
      id
      ...ClusterDetailV1
    }
  }
}
    ${ClusterDetailV1FragmentDoc}`;

/**
 * __useClusterDetailsQuery__
 *
 * To run a query within a React component, call `useClusterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterDetailsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterDetailsQuery(baseOptions: Apollo.QueryHookOptions<ClusterDetailsQuery, ClusterDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterDetailsQuery, ClusterDetailsQueryVariables>(ClusterDetailsDocument, options);
      }
export function useClusterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterDetailsQuery, ClusterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterDetailsQuery, ClusterDetailsQueryVariables>(ClusterDetailsDocument, options);
        }
export type ClusterDetailsQueryHookResult = ReturnType<typeof useClusterDetailsQuery>;
export type ClusterDetailsLazyQueryHookResult = ReturnType<typeof useClusterDetailsLazyQuery>;
export type ClusterDetailsQueryResult = Apollo.QueryResult<ClusterDetailsQuery, ClusterDetailsQueryVariables>;
export function refetchClusterDetailsQuery(variables: ClusterDetailsQueryVariables) {
      return { query: ClusterDetailsDocument, variables: variables }
    }
export const ClusterRevisionsDocument = gql`
    query clusterRevisions($teamId: UUID!, $clusterId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    cluster(id: $clusterId) {
      id
      configurationRevisions {
        nodes {
          ...RevisionDetailV1
        }
      }
    }
  }
}
    ${RevisionDetailV1FragmentDoc}`;

/**
 * __useClusterRevisionsQuery__
 *
 * To run a query within a React component, call `useClusterRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterRevisionsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterRevisionsQuery(baseOptions: Apollo.QueryHookOptions<ClusterRevisionsQuery, ClusterRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterRevisionsQuery, ClusterRevisionsQueryVariables>(ClusterRevisionsDocument, options);
      }
export function useClusterRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterRevisionsQuery, ClusterRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterRevisionsQuery, ClusterRevisionsQueryVariables>(ClusterRevisionsDocument, options);
        }
export type ClusterRevisionsQueryHookResult = ReturnType<typeof useClusterRevisionsQuery>;
export type ClusterRevisionsLazyQueryHookResult = ReturnType<typeof useClusterRevisionsLazyQuery>;
export type ClusterRevisionsQueryResult = Apollo.QueryResult<ClusterRevisionsQuery, ClusterRevisionsQueryVariables>;
export function refetchClusterRevisionsQuery(variables: ClusterRevisionsQueryVariables) {
      return { query: ClusterRevisionsDocument, variables: variables }
    }
export const ClusterStatusDocument = gql`
    query clusterStatus($teamId: UUID!, $clusterId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    cluster(id: $clusterId) {
      id
      status
    }
  }
}
    `;

/**
 * __useClusterStatusQuery__
 *
 * To run a query within a React component, call `useClusterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterStatusQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterStatusQuery(baseOptions: Apollo.QueryHookOptions<ClusterStatusQuery, ClusterStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterStatusQuery, ClusterStatusQueryVariables>(ClusterStatusDocument, options);
      }
export function useClusterStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterStatusQuery, ClusterStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterStatusQuery, ClusterStatusQueryVariables>(ClusterStatusDocument, options);
        }
export type ClusterStatusQueryHookResult = ReturnType<typeof useClusterStatusQuery>;
export type ClusterStatusLazyQueryHookResult = ReturnType<typeof useClusterStatusLazyQuery>;
export type ClusterStatusQueryResult = Apollo.QueryResult<ClusterStatusQuery, ClusterStatusQueryVariables>;
export function refetchClusterStatusQuery(variables: ClusterStatusQueryVariables) {
      return { query: ClusterStatusDocument, variables: variables }
    }
export const GroupsWithSubgroupsDocument = gql`
    query groupsWithSubgroups($teamId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    groups {
      nodes {
        id
        name
        subGroups {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGroupsWithSubgroupsQuery__
 *
 * To run a query within a React component, call `useGroupsWithSubgroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsWithSubgroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsWithSubgroupsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGroupsWithSubgroupsQuery(baseOptions: Apollo.QueryHookOptions<GroupsWithSubgroupsQuery, GroupsWithSubgroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsWithSubgroupsQuery, GroupsWithSubgroupsQueryVariables>(GroupsWithSubgroupsDocument, options);
      }
export function useGroupsWithSubgroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsWithSubgroupsQuery, GroupsWithSubgroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsWithSubgroupsQuery, GroupsWithSubgroupsQueryVariables>(GroupsWithSubgroupsDocument, options);
        }
export type GroupsWithSubgroupsQueryHookResult = ReturnType<typeof useGroupsWithSubgroupsQuery>;
export type GroupsWithSubgroupsLazyQueryHookResult = ReturnType<typeof useGroupsWithSubgroupsLazyQuery>;
export type GroupsWithSubgroupsQueryResult = Apollo.QueryResult<GroupsWithSubgroupsQuery, GroupsWithSubgroupsQueryVariables>;
export function refetchGroupsWithSubgroupsQuery(variables: GroupsWithSubgroupsQueryVariables) {
      return { query: GroupsWithSubgroupsDocument, variables: variables }
    }
export const InsightsCloudsMetricDocument = gql`
    query insightsCloudsMetric($teamId: UUID!) @api(name: v1) {
  insights {
    cloud {
      unhealthyClouds(userId: $teamId)
    }
  }
}
    `;

/**
 * __useInsightsCloudsMetricQuery__
 *
 * To run a query within a React component, call `useInsightsCloudsMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsCloudsMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsCloudsMetricQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useInsightsCloudsMetricQuery(baseOptions: Apollo.QueryHookOptions<InsightsCloudsMetricQuery, InsightsCloudsMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsCloudsMetricQuery, InsightsCloudsMetricQueryVariables>(InsightsCloudsMetricDocument, options);
      }
export function useInsightsCloudsMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsCloudsMetricQuery, InsightsCloudsMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsCloudsMetricQuery, InsightsCloudsMetricQueryVariables>(InsightsCloudsMetricDocument, options);
        }
export type InsightsCloudsMetricQueryHookResult = ReturnType<typeof useInsightsCloudsMetricQuery>;
export type InsightsCloudsMetricLazyQueryHookResult = ReturnType<typeof useInsightsCloudsMetricLazyQuery>;
export type InsightsCloudsMetricQueryResult = Apollo.QueryResult<InsightsCloudsMetricQuery, InsightsCloudsMetricQueryVariables>;
export function refetchInsightsCloudsMetricQuery(variables: InsightsCloudsMetricQueryVariables) {
      return { query: InsightsCloudsMetricDocument, variables: variables }
    }
export const InsightsClustersMetricDocument = gql`
    query insightsClustersMetric($teamId: UUID!) @api(name: v1) {
  insights {
    cloud {
      unreachableClusters(userId: $teamId)
    }
  }
}
    `;

/**
 * __useInsightsClustersMetricQuery__
 *
 * To run a query within a React component, call `useInsightsClustersMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsClustersMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsClustersMetricQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useInsightsClustersMetricQuery(baseOptions: Apollo.QueryHookOptions<InsightsClustersMetricQuery, InsightsClustersMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsClustersMetricQuery, InsightsClustersMetricQueryVariables>(InsightsClustersMetricDocument, options);
      }
export function useInsightsClustersMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsClustersMetricQuery, InsightsClustersMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsClustersMetricQuery, InsightsClustersMetricQueryVariables>(InsightsClustersMetricDocument, options);
        }
export type InsightsClustersMetricQueryHookResult = ReturnType<typeof useInsightsClustersMetricQuery>;
export type InsightsClustersMetricLazyQueryHookResult = ReturnType<typeof useInsightsClustersMetricLazyQuery>;
export type InsightsClustersMetricQueryResult = Apollo.QueryResult<InsightsClustersMetricQuery, InsightsClustersMetricQueryVariables>;
export function refetchInsightsClustersMetricQuery(variables: InsightsClustersMetricQueryVariables) {
      return { query: InsightsClustersMetricDocument, variables: variables }
    }
export const JobListDocument = gql`
    query jobList($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      jobs {
        ...JobListItem
      }
    }
  }
}
    ${JobListItemFragmentDoc}`;

/**
 * __useJobListQuery__
 *
 * To run a query within a React component, call `useJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobListQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useJobListQuery(baseOptions: Apollo.QueryHookOptions<JobListQuery, JobListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
      }
export function useJobListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobListQuery, JobListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
        }
export type JobListQueryHookResult = ReturnType<typeof useJobListQuery>;
export type JobListLazyQueryHookResult = ReturnType<typeof useJobListLazyQuery>;
export type JobListQueryResult = Apollo.QueryResult<JobListQuery, JobListQueryVariables>;
export function refetchJobListQuery(variables: JobListQueryVariables) {
      return { query: JobListDocument, variables: variables }
    }
export const JobRunListDocument = gql`
    query jobRunList($id: UUID!, $teamId: UUID!, $page: PageInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    job(id: $id) {
      ...JobDetailItem
    }
  }
}
    ${JobDetailItemFragmentDoc}`;

/**
 * __useJobRunListQuery__
 *
 * To run a query within a React component, call `useJobRunListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRunListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRunListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useJobRunListQuery(baseOptions: Apollo.QueryHookOptions<JobRunListQuery, JobRunListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRunListQuery, JobRunListQueryVariables>(JobRunListDocument, options);
      }
export function useJobRunListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRunListQuery, JobRunListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRunListQuery, JobRunListQueryVariables>(JobRunListDocument, options);
        }
export type JobRunListQueryHookResult = ReturnType<typeof useJobRunListQuery>;
export type JobRunListLazyQueryHookResult = ReturnType<typeof useJobRunListLazyQuery>;
export type JobRunListQueryResult = Apollo.QueryResult<JobRunListQuery, JobRunListQueryVariables>;
export function refetchJobRunListQuery(variables: JobRunListQueryVariables) {
      return { query: JobRunListDocument, variables: variables }
    }
export const JobRunDetailDocument = gql`
    query jobRunDetail($id: UUID!, $teamId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    jobRun(id: $id) {
      ...JobRunDetail
    }
  }
}
    ${JobRunDetailFragmentDoc}`;

/**
 * __useJobRunDetailQuery__
 *
 * To run a query within a React component, call `useJobRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRunDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useJobRunDetailQuery(baseOptions: Apollo.QueryHookOptions<JobRunDetailQuery, JobRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRunDetailQuery, JobRunDetailQueryVariables>(JobRunDetailDocument, options);
      }
export function useJobRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRunDetailQuery, JobRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRunDetailQuery, JobRunDetailQueryVariables>(JobRunDetailDocument, options);
        }
export type JobRunDetailQueryHookResult = ReturnType<typeof useJobRunDetailQuery>;
export type JobRunDetailLazyQueryHookResult = ReturnType<typeof useJobRunDetailLazyQuery>;
export type JobRunDetailQueryResult = Apollo.QueryResult<JobRunDetailQuery, JobRunDetailQueryVariables>;
export function refetchJobRunDetailQuery(variables: JobRunDetailQueryVariables) {
      return { query: JobRunDetailDocument, variables: variables }
    }
export const JobRunLogsDocument = gql`
    query jobRunLogs($id: UUID!, $teamId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    jobRun(id: $id) {
      ...JobRunLogs
    }
  }
}
    ${JobRunLogsFragmentDoc}`;

/**
 * __useJobRunLogsQuery__
 *
 * To run a query within a React component, call `useJobRunLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRunLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRunLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useJobRunLogsQuery(baseOptions: Apollo.QueryHookOptions<JobRunLogsQuery, JobRunLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRunLogsQuery, JobRunLogsQueryVariables>(JobRunLogsDocument, options);
      }
export function useJobRunLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRunLogsQuery, JobRunLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRunLogsQuery, JobRunLogsQueryVariables>(JobRunLogsDocument, options);
        }
export type JobRunLogsQueryHookResult = ReturnType<typeof useJobRunLogsQuery>;
export type JobRunLogsLazyQueryHookResult = ReturnType<typeof useJobRunLogsLazyQuery>;
export type JobRunLogsQueryResult = Apollo.QueryResult<JobRunLogsQuery, JobRunLogsQueryVariables>;
export function refetchJobRunLogsQuery(variables: JobRunLogsQueryVariables) {
      return { query: JobRunLogsDocument, variables: variables }
    }
export const ObservabilityConfigDocument = gql`
    query observabilityConfig($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      observabilityConfig {
        selector {
          type
          namespace
          resourceName
          containerName
          labels {
            name
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useObservabilityConfigQuery__
 *
 * To run a query within a React component, call `useObservabilityConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useObservabilityConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObservabilityConfigQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useObservabilityConfigQuery(baseOptions: Apollo.QueryHookOptions<ObservabilityConfigQuery, ObservabilityConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObservabilityConfigQuery, ObservabilityConfigQueryVariables>(ObservabilityConfigDocument, options);
      }
export function useObservabilityConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObservabilityConfigQuery, ObservabilityConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObservabilityConfigQuery, ObservabilityConfigQueryVariables>(ObservabilityConfigDocument, options);
        }
export type ObservabilityConfigQueryHookResult = ReturnType<typeof useObservabilityConfigQuery>;
export type ObservabilityConfigLazyQueryHookResult = ReturnType<typeof useObservabilityConfigLazyQuery>;
export type ObservabilityConfigQueryResult = Apollo.QueryResult<ObservabilityConfigQuery, ObservabilityConfigQueryVariables>;
export function refetchObservabilityConfigQuery(variables: ObservabilityConfigQueryVariables) {
      return { query: ObservabilityConfigDocument, variables: variables }
    }
export const ResourcesWithMetricsDocument = gql`
    query resourcesWithMetrics($teamId: UUID!, $projectId: UUID!, $clusterId: UUID!, $metricTypes: [MetricType!]!, $selector: ObservabilityResourceSelectorInput) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      resources(clusterId: $clusterId, selector: $selector) {
        ...CloudResource
        resources {
          ...CloudResource
          resources {
            ...CloudResource
          }
        }
        metric(clusterId: $clusterId, projectId: $projectId, types: $metricTypes) {
          ...MetricStreamV1
        }
      }
    }
  }
}
    ${CloudResourceFragmentDoc}
${MetricStreamV1FragmentDoc}`;

/**
 * __useResourcesWithMetricsQuery__
 *
 * To run a query within a React component, call `useResourcesWithMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesWithMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesWithMetricsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      clusterId: // value for 'clusterId'
 *      metricTypes: // value for 'metricTypes'
 *      selector: // value for 'selector'
 *   },
 * });
 */
export function useResourcesWithMetricsQuery(baseOptions: Apollo.QueryHookOptions<ResourcesWithMetricsQuery, ResourcesWithMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesWithMetricsQuery, ResourcesWithMetricsQueryVariables>(ResourcesWithMetricsDocument, options);
      }
export function useResourcesWithMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesWithMetricsQuery, ResourcesWithMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesWithMetricsQuery, ResourcesWithMetricsQueryVariables>(ResourcesWithMetricsDocument, options);
        }
export type ResourcesWithMetricsQueryHookResult = ReturnType<typeof useResourcesWithMetricsQuery>;
export type ResourcesWithMetricsLazyQueryHookResult = ReturnType<typeof useResourcesWithMetricsLazyQuery>;
export type ResourcesWithMetricsQueryResult = Apollo.QueryResult<ResourcesWithMetricsQuery, ResourcesWithMetricsQueryVariables>;
export function refetchResourcesWithMetricsQuery(variables: ResourcesWithMetricsQueryVariables) {
      return { query: ResourcesWithMetricsDocument, variables: variables }
    }
export const ResourcesWithLogsDocument = gql`
    query resourcesWithLogs($teamId: UUID!, $projectId: UUID!, $clusterId: UUID!, $selector: ObservabilityResourceSelectorInput) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      resources(clusterId: $clusterId, selector: $selector) {
        ...CloudResource
        resources {
          ...CloudResource
          resources {
            ...CloudResource
          }
        }
        log(clusterId: $clusterId, projectId: $projectId) {
          name
          entries {
            text
            timestamp
          }
        }
      }
    }
  }
}
    ${CloudResourceFragmentDoc}`;

/**
 * __useResourcesWithLogsQuery__
 *
 * To run a query within a React component, call `useResourcesWithLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesWithLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesWithLogsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      clusterId: // value for 'clusterId'
 *      selector: // value for 'selector'
 *   },
 * });
 */
export function useResourcesWithLogsQuery(baseOptions: Apollo.QueryHookOptions<ResourcesWithLogsQuery, ResourcesWithLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesWithLogsQuery, ResourcesWithLogsQueryVariables>(ResourcesWithLogsDocument, options);
      }
export function useResourcesWithLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesWithLogsQuery, ResourcesWithLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesWithLogsQuery, ResourcesWithLogsQueryVariables>(ResourcesWithLogsDocument, options);
        }
export type ResourcesWithLogsQueryHookResult = ReturnType<typeof useResourcesWithLogsQuery>;
export type ResourcesWithLogsLazyQueryHookResult = ReturnType<typeof useResourcesWithLogsLazyQuery>;
export type ResourcesWithLogsQueryResult = Apollo.QueryResult<ResourcesWithLogsQuery, ResourcesWithLogsQueryVariables>;
export function refetchResourcesWithLogsQuery(variables: ResourcesWithLogsQueryVariables) {
      return { query: ResourcesWithLogsDocument, variables: variables }
    }
export const UserPersonalAccessTokensDocument = gql`
    query userPersonalAccessTokens($id: UUID!) @api(name: v1) {
  user(id: $id) {
    id
    personalAccessTokens {
      id
      name
      token
      createdAt
    }
  }
}
    `;

/**
 * __useUserPersonalAccessTokensQuery__
 *
 * To run a query within a React component, call `useUserPersonalAccessTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPersonalAccessTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPersonalAccessTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPersonalAccessTokensQuery(baseOptions: Apollo.QueryHookOptions<UserPersonalAccessTokensQuery, UserPersonalAccessTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPersonalAccessTokensQuery, UserPersonalAccessTokensQueryVariables>(UserPersonalAccessTokensDocument, options);
      }
export function useUserPersonalAccessTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPersonalAccessTokensQuery, UserPersonalAccessTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPersonalAccessTokensQuery, UserPersonalAccessTokensQueryVariables>(UserPersonalAccessTokensDocument, options);
        }
export type UserPersonalAccessTokensQueryHookResult = ReturnType<typeof useUserPersonalAccessTokensQuery>;
export type UserPersonalAccessTokensLazyQueryHookResult = ReturnType<typeof useUserPersonalAccessTokensLazyQuery>;
export type UserPersonalAccessTokensQueryResult = Apollo.QueryResult<UserPersonalAccessTokensQuery, UserPersonalAccessTokensQueryVariables>;
export function refetchUserPersonalAccessTokensQuery(variables: UserPersonalAccessTokensQueryVariables) {
      return { query: UserPersonalAccessTokensDocument, variables: variables }
    }
export const ProjectsCountDocument = gql`
    query projectsCount($teamId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    projects {
      totalCount
    }
  }
}
    `;

/**
 * __useProjectsCountQuery__
 *
 * To run a query within a React component, call `useProjectsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsCountQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useProjectsCountQuery(baseOptions: Apollo.QueryHookOptions<ProjectsCountQuery, ProjectsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsCountQuery, ProjectsCountQueryVariables>(ProjectsCountDocument, options);
      }
export function useProjectsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsCountQuery, ProjectsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsCountQuery, ProjectsCountQueryVariables>(ProjectsCountDocument, options);
        }
export type ProjectsCountQueryHookResult = ReturnType<typeof useProjectsCountQuery>;
export type ProjectsCountLazyQueryHookResult = ReturnType<typeof useProjectsCountLazyQuery>;
export type ProjectsCountQueryResult = Apollo.QueryResult<ProjectsCountQuery, ProjectsCountQueryVariables>;
export function refetchProjectsCountQuery(variables: ProjectsCountQueryVariables) {
      return { query: ProjectsCountDocument, variables: variables }
    }
export const ProjectsWithDeploymentTimesDocument = gql`
    query projectsWithDeploymentTimes($teamId: UUID!, $input: ProjectsInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    projects(input: $input) {
      nodes {
        ...ProjectWithDeploymentTime
      }
    }
  }
}
    ${ProjectWithDeploymentTimeFragmentDoc}`;

/**
 * __useProjectsWithDeploymentTimesQuery__
 *
 * To run a query within a React component, call `useProjectsWithDeploymentTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWithDeploymentTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWithDeploymentTimesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectsWithDeploymentTimesQuery(baseOptions: Apollo.QueryHookOptions<ProjectsWithDeploymentTimesQuery, ProjectsWithDeploymentTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWithDeploymentTimesQuery, ProjectsWithDeploymentTimesQueryVariables>(ProjectsWithDeploymentTimesDocument, options);
      }
export function useProjectsWithDeploymentTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWithDeploymentTimesQuery, ProjectsWithDeploymentTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWithDeploymentTimesQuery, ProjectsWithDeploymentTimesQueryVariables>(ProjectsWithDeploymentTimesDocument, options);
        }
export type ProjectsWithDeploymentTimesQueryHookResult = ReturnType<typeof useProjectsWithDeploymentTimesQuery>;
export type ProjectsWithDeploymentTimesLazyQueryHookResult = ReturnType<typeof useProjectsWithDeploymentTimesLazyQuery>;
export type ProjectsWithDeploymentTimesQueryResult = Apollo.QueryResult<ProjectsWithDeploymentTimesQuery, ProjectsWithDeploymentTimesQueryVariables>;
export function refetchProjectsWithDeploymentTimesQuery(variables: ProjectsWithDeploymentTimesQueryVariables) {
      return { query: ProjectsWithDeploymentTimesDocument, variables: variables }
    }
export const ProjectsWithStatusDocument = gql`
    query projectsWithStatus($teamId: UUID!, $input: ProjectsInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    projects(input: $input) {
      nodes {
        ...ProjectWithStatus
      }
    }
  }
}
    ${ProjectWithStatusFragmentDoc}`;

/**
 * __useProjectsWithStatusQuery__
 *
 * To run a query within a React component, call `useProjectsWithStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWithStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWithStatusQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectsWithStatusQuery(baseOptions: Apollo.QueryHookOptions<ProjectsWithStatusQuery, ProjectsWithStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWithStatusQuery, ProjectsWithStatusQueryVariables>(ProjectsWithStatusDocument, options);
      }
export function useProjectsWithStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWithStatusQuery, ProjectsWithStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWithStatusQuery, ProjectsWithStatusQueryVariables>(ProjectsWithStatusDocument, options);
        }
export type ProjectsWithStatusQueryHookResult = ReturnType<typeof useProjectsWithStatusQuery>;
export type ProjectsWithStatusLazyQueryHookResult = ReturnType<typeof useProjectsWithStatusLazyQuery>;
export type ProjectsWithStatusQueryResult = Apollo.QueryResult<ProjectsWithStatusQuery, ProjectsWithStatusQueryVariables>;
export function refetchProjectsWithStatusQuery(variables: ProjectsWithStatusQueryVariables) {
      return { query: ProjectsWithStatusDocument, variables: variables }
    }
export const ProjectsWithBlueprintDocument = gql`
    query projectsWithBlueprint($teamId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    projects {
      nodes {
        ...ProjectWithBlueprint
      }
    }
  }
}
    ${ProjectWithBlueprintFragmentDoc}`;

/**
 * __useProjectsWithBlueprintQuery__
 *
 * To run a query within a React component, call `useProjectsWithBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWithBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWithBlueprintQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useProjectsWithBlueprintQuery(baseOptions: Apollo.QueryHookOptions<ProjectsWithBlueprintQuery, ProjectsWithBlueprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWithBlueprintQuery, ProjectsWithBlueprintQueryVariables>(ProjectsWithBlueprintDocument, options);
      }
export function useProjectsWithBlueprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWithBlueprintQuery, ProjectsWithBlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWithBlueprintQuery, ProjectsWithBlueprintQueryVariables>(ProjectsWithBlueprintDocument, options);
        }
export type ProjectsWithBlueprintQueryHookResult = ReturnType<typeof useProjectsWithBlueprintQuery>;
export type ProjectsWithBlueprintLazyQueryHookResult = ReturnType<typeof useProjectsWithBlueprintLazyQuery>;
export type ProjectsWithBlueprintQueryResult = Apollo.QueryResult<ProjectsWithBlueprintQuery, ProjectsWithBlueprintQueryVariables>;
export function refetchProjectsWithBlueprintQuery(variables: ProjectsWithBlueprintQueryVariables) {
      return { query: ProjectsWithBlueprintDocument, variables: variables }
    }
export const ProjectInfoDocument = gql`
    query projectInfo($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      ...ProjectInfo
    }
  }
}
    ${ProjectInfoFragmentDoc}`;

/**
 * __useProjectInfoQuery__
 *
 * To run a query within a React component, call `useProjectInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectInfoQuery(baseOptions: Apollo.QueryHookOptions<ProjectInfoQuery, ProjectInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(ProjectInfoDocument, options);
      }
export function useProjectInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectInfoQuery, ProjectInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(ProjectInfoDocument, options);
        }
export type ProjectInfoQueryHookResult = ReturnType<typeof useProjectInfoQuery>;
export type ProjectInfoLazyQueryHookResult = ReturnType<typeof useProjectInfoLazyQuery>;
export type ProjectInfoQueryResult = Apollo.QueryResult<ProjectInfoQuery, ProjectInfoQueryVariables>;
export function refetchProjectInfoQuery(variables: ProjectInfoQueryVariables) {
      return { query: ProjectInfoDocument, variables: variables }
    }
export const ProjectStatusOnlyDocument = gql`
    query projectStatusOnly($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      status
    }
  }
}
    `;

/**
 * __useProjectStatusOnlyQuery__
 *
 * To run a query within a React component, call `useProjectStatusOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectStatusOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectStatusOnlyQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectStatusOnlyQuery(baseOptions: Apollo.QueryHookOptions<ProjectStatusOnlyQuery, ProjectStatusOnlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectStatusOnlyQuery, ProjectStatusOnlyQueryVariables>(ProjectStatusOnlyDocument, options);
      }
export function useProjectStatusOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectStatusOnlyQuery, ProjectStatusOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectStatusOnlyQuery, ProjectStatusOnlyQueryVariables>(ProjectStatusOnlyDocument, options);
        }
export type ProjectStatusOnlyQueryHookResult = ReturnType<typeof useProjectStatusOnlyQuery>;
export type ProjectStatusOnlyLazyQueryHookResult = ReturnType<typeof useProjectStatusOnlyLazyQuery>;
export type ProjectStatusOnlyQueryResult = Apollo.QueryResult<ProjectStatusOnlyQuery, ProjectStatusOnlyQueryVariables>;
export function refetchProjectStatusOnlyQuery(variables: ProjectStatusOnlyQueryVariables) {
      return { query: ProjectStatusOnlyDocument, variables: variables }
    }
export const ProjectDetailDocument = gql`
    query projectDetail($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      ...ProjectDetail
    }
  }
}
    ${ProjectDetailFragmentDoc}`;

/**
 * __useProjectDetailQuery__
 *
 * To run a query within a React component, call `useProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDetailQuery(baseOptions: Apollo.QueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
      }
export function useProjectDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDetailQuery, ProjectDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDetailQuery, ProjectDetailQueryVariables>(ProjectDetailDocument, options);
        }
export type ProjectDetailQueryHookResult = ReturnType<typeof useProjectDetailQuery>;
export type ProjectDetailLazyQueryHookResult = ReturnType<typeof useProjectDetailLazyQuery>;
export type ProjectDetailQueryResult = Apollo.QueryResult<ProjectDetailQuery, ProjectDetailQueryVariables>;
export function refetchProjectDetailQuery(variables: ProjectDetailQueryVariables) {
      return { query: ProjectDetailDocument, variables: variables }
    }
export const ProjectOutputsDocument = gql`
    query projectOutputs($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      status
      connector(type: DATABASE_CONNECTION) {
        type
        fields {
          type
          name
          displayName
          value
        }
      }
      workflow {
        id
      }
    }
  }
}
    `;

/**
 * __useProjectOutputsQuery__
 *
 * To run a query within a React component, call `useProjectOutputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOutputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOutputsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectOutputsQuery(baseOptions: Apollo.QueryHookOptions<ProjectOutputsQuery, ProjectOutputsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOutputsQuery, ProjectOutputsQueryVariables>(ProjectOutputsDocument, options);
      }
export function useProjectOutputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOutputsQuery, ProjectOutputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOutputsQuery, ProjectOutputsQueryVariables>(ProjectOutputsDocument, options);
        }
export type ProjectOutputsQueryHookResult = ReturnType<typeof useProjectOutputsQuery>;
export type ProjectOutputsLazyQueryHookResult = ReturnType<typeof useProjectOutputsLazyQuery>;
export type ProjectOutputsQueryResult = Apollo.QueryResult<ProjectOutputsQuery, ProjectOutputsQueryVariables>;
export function refetchProjectOutputsQuery(variables: ProjectOutputsQueryVariables) {
      return { query: ProjectOutputsDocument, variables: variables }
    }
export const ProjectAvailableProvidersDocument = gql`
    query projectAvailableProviders($teamId: UUID!, $projectId: UUID!, $linkType: ProjectLinkType!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      availableProviders(type: $linkType) {
        ...ProjectWithName
      }
    }
  }
}
    ${ProjectWithNameFragmentDoc}`;

/**
 * __useProjectAvailableProvidersQuery__
 *
 * To run a query within a React component, call `useProjectAvailableProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAvailableProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAvailableProvidersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      linkType: // value for 'linkType'
 *   },
 * });
 */
export function useProjectAvailableProvidersQuery(baseOptions: Apollo.QueryHookOptions<ProjectAvailableProvidersQuery, ProjectAvailableProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAvailableProvidersQuery, ProjectAvailableProvidersQueryVariables>(ProjectAvailableProvidersDocument, options);
      }
export function useProjectAvailableProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAvailableProvidersQuery, ProjectAvailableProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAvailableProvidersQuery, ProjectAvailableProvidersQueryVariables>(ProjectAvailableProvidersDocument, options);
        }
export type ProjectAvailableProvidersQueryHookResult = ReturnType<typeof useProjectAvailableProvidersQuery>;
export type ProjectAvailableProvidersLazyQueryHookResult = ReturnType<typeof useProjectAvailableProvidersLazyQuery>;
export type ProjectAvailableProvidersQueryResult = Apollo.QueryResult<ProjectAvailableProvidersQuery, ProjectAvailableProvidersQueryVariables>;
export function refetchProjectAvailableProvidersQuery(variables: ProjectAvailableProvidersQueryVariables) {
      return { query: ProjectAvailableProvidersDocument, variables: variables }
    }
export const ProjectLinkedProjectsDocument = gql`
    query projectLinkedProjects($teamId: UUID!, $projectId: UUID!, $linkType: ProjectLinkType!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      linkedProjects(type: $linkType) {
        nodes {
          ...ProjectLinkDetail
        }
      }
    }
  }
}
    ${ProjectLinkDetailFragmentDoc}`;

/**
 * __useProjectLinkedProjectsQuery__
 *
 * To run a query within a React component, call `useProjectLinkedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLinkedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLinkedProjectsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      linkType: // value for 'linkType'
 *   },
 * });
 */
export function useProjectLinkedProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectLinkedProjectsQuery, ProjectLinkedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectLinkedProjectsQuery, ProjectLinkedProjectsQueryVariables>(ProjectLinkedProjectsDocument, options);
      }
export function useProjectLinkedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectLinkedProjectsQuery, ProjectLinkedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectLinkedProjectsQuery, ProjectLinkedProjectsQueryVariables>(ProjectLinkedProjectsDocument, options);
        }
export type ProjectLinkedProjectsQueryHookResult = ReturnType<typeof useProjectLinkedProjectsQuery>;
export type ProjectLinkedProjectsLazyQueryHookResult = ReturnType<typeof useProjectLinkedProjectsLazyQuery>;
export type ProjectLinkedProjectsQueryResult = Apollo.QueryResult<ProjectLinkedProjectsQuery, ProjectLinkedProjectsQueryVariables>;
export function refetchProjectLinkedProjectsQuery(variables: ProjectLinkedProjectsQueryVariables) {
      return { query: ProjectLinkedProjectsDocument, variables: variables }
    }
export const ProjectClustersDocument = gql`
    query projectClusters($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      ...ProjectWithClusters
    }
  }
}
    ${ProjectWithClustersFragmentDoc}`;

/**
 * __useProjectClustersQuery__
 *
 * To run a query within a React component, call `useProjectClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectClustersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectClustersQuery(baseOptions: Apollo.QueryHookOptions<ProjectClustersQuery, ProjectClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectClustersQuery, ProjectClustersQueryVariables>(ProjectClustersDocument, options);
      }
export function useProjectClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectClustersQuery, ProjectClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectClustersQuery, ProjectClustersQueryVariables>(ProjectClustersDocument, options);
        }
export type ProjectClustersQueryHookResult = ReturnType<typeof useProjectClustersQuery>;
export type ProjectClustersLazyQueryHookResult = ReturnType<typeof useProjectClustersLazyQuery>;
export type ProjectClustersQueryResult = Apollo.QueryResult<ProjectClustersQuery, ProjectClustersQueryVariables>;
export function refetchProjectClustersQuery(variables: ProjectClustersQueryVariables) {
      return { query: ProjectClustersDocument, variables: variables }
    }
export const ProjectOutputDocument = gql`
    query projectOutput($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      ...ProjectOutput
    }
  }
}
    ${ProjectOutputFragmentDoc}`;

/**
 * __useProjectOutputQuery__
 *
 * To run a query within a React component, call `useProjectOutputQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOutputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOutputQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectOutputQuery(baseOptions: Apollo.QueryHookOptions<ProjectOutputQuery, ProjectOutputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectOutputQuery, ProjectOutputQueryVariables>(ProjectOutputDocument, options);
      }
export function useProjectOutputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectOutputQuery, ProjectOutputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectOutputQuery, ProjectOutputQueryVariables>(ProjectOutputDocument, options);
        }
export type ProjectOutputQueryHookResult = ReturnType<typeof useProjectOutputQuery>;
export type ProjectOutputLazyQueryHookResult = ReturnType<typeof useProjectOutputLazyQuery>;
export type ProjectOutputQueryResult = Apollo.QueryResult<ProjectOutputQuery, ProjectOutputQueryVariables>;
export function refetchProjectOutputQuery(variables: ProjectOutputQueryVariables) {
      return { query: ProjectOutputDocument, variables: variables }
    }
export const ProjectDeploysDocument = gql`
    query projectDeploys($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      deploys {
        nodes {
          ...ProjectDeployList
        }
      }
    }
  }
}
    ${ProjectDeployListFragmentDoc}`;

/**
 * __useProjectDeploysQuery__
 *
 * To run a query within a React component, call `useProjectDeploysQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDeploysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDeploysQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeploysQuery(baseOptions: Apollo.QueryHookOptions<ProjectDeploysQuery, ProjectDeploysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDeploysQuery, ProjectDeploysQueryVariables>(ProjectDeploysDocument, options);
      }
export function useProjectDeploysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDeploysQuery, ProjectDeploysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDeploysQuery, ProjectDeploysQueryVariables>(ProjectDeploysDocument, options);
        }
export type ProjectDeploysQueryHookResult = ReturnType<typeof useProjectDeploysQuery>;
export type ProjectDeploysLazyQueryHookResult = ReturnType<typeof useProjectDeploysLazyQuery>;
export type ProjectDeploysQueryResult = Apollo.QueryResult<ProjectDeploysQuery, ProjectDeploysQueryVariables>;
export function refetchProjectDeploysQuery(variables: ProjectDeploysQueryVariables) {
      return { query: ProjectDeploysDocument, variables: variables }
    }
export const ProjectDeployDetailDocument = gql`
    query projectDeployDetail($teamId: UUID!, $deployId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    deploy(id: $deployId) {
      ...ProjectDeployDetail
    }
  }
}
    ${ProjectDeployDetailFragmentDoc}`;

/**
 * __useProjectDeployDetailQuery__
 *
 * To run a query within a React component, call `useProjectDeployDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDeployDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDeployDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      deployId: // value for 'deployId'
 *   },
 * });
 */
export function useProjectDeployDetailQuery(baseOptions: Apollo.QueryHookOptions<ProjectDeployDetailQuery, ProjectDeployDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDeployDetailQuery, ProjectDeployDetailQueryVariables>(ProjectDeployDetailDocument, options);
      }
export function useProjectDeployDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDeployDetailQuery, ProjectDeployDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDeployDetailQuery, ProjectDeployDetailQueryVariables>(ProjectDeployDetailDocument, options);
        }
export type ProjectDeployDetailQueryHookResult = ReturnType<typeof useProjectDeployDetailQuery>;
export type ProjectDeployDetailLazyQueryHookResult = ReturnType<typeof useProjectDeployDetailLazyQuery>;
export type ProjectDeployDetailQueryResult = Apollo.QueryResult<ProjectDeployDetailQuery, ProjectDeployDetailQueryVariables>;
export function refetchProjectDeployDetailQuery(variables: ProjectDeployDetailQueryVariables) {
      return { query: ProjectDeployDetailDocument, variables: variables }
    }
export const ProjectDeployRevisionsDocument = gql`
    query projectDeployRevisions($teamId: UUID!, $projectId: UUID!, $page: PageInput) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      deploys {
        totalCount
        nodes {
          id
          name
          configurationRevisions(page: $page) {
            totalCount
            pageInfo {
              hasNextPage
            }
            nodes {
              id
              ...RevisionDetailV1
            }
          }
        }
      }
    }
  }
}
    ${RevisionDetailV1FragmentDoc}`;

/**
 * __useProjectDeployRevisionsQuery__
 *
 * To run a query within a React component, call `useProjectDeployRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDeployRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDeployRevisionsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectDeployRevisionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectDeployRevisionsQuery, ProjectDeployRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDeployRevisionsQuery, ProjectDeployRevisionsQueryVariables>(ProjectDeployRevisionsDocument, options);
      }
export function useProjectDeployRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDeployRevisionsQuery, ProjectDeployRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDeployRevisionsQuery, ProjectDeployRevisionsQueryVariables>(ProjectDeployRevisionsDocument, options);
        }
export type ProjectDeployRevisionsQueryHookResult = ReturnType<typeof useProjectDeployRevisionsQuery>;
export type ProjectDeployRevisionsLazyQueryHookResult = ReturnType<typeof useProjectDeployRevisionsLazyQuery>;
export type ProjectDeployRevisionsQueryResult = Apollo.QueryResult<ProjectDeployRevisionsQuery, ProjectDeployRevisionsQueryVariables>;
export function refetchProjectDeployRevisionsQuery(variables: ProjectDeployRevisionsQueryVariables) {
      return { query: ProjectDeployRevisionsDocument, variables: variables }
    }
export const ProjectDeployRunDetailDocument = gql`
    query projectDeployRunDetail($teamId: UUID!, $deployRunId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    deployRun(id: $deployRunId) {
      ...ProjectDeployRunDetail
    }
  }
}
    ${ProjectDeployRunDetailFragmentDoc}`;

/**
 * __useProjectDeployRunDetailQuery__
 *
 * To run a query within a React component, call `useProjectDeployRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDeployRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDeployRunDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      deployRunId: // value for 'deployRunId'
 *   },
 * });
 */
export function useProjectDeployRunDetailQuery(baseOptions: Apollo.QueryHookOptions<ProjectDeployRunDetailQuery, ProjectDeployRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDeployRunDetailQuery, ProjectDeployRunDetailQueryVariables>(ProjectDeployRunDetailDocument, options);
      }
export function useProjectDeployRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDeployRunDetailQuery, ProjectDeployRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDeployRunDetailQuery, ProjectDeployRunDetailQueryVariables>(ProjectDeployRunDetailDocument, options);
        }
export type ProjectDeployRunDetailQueryHookResult = ReturnType<typeof useProjectDeployRunDetailQuery>;
export type ProjectDeployRunDetailLazyQueryHookResult = ReturnType<typeof useProjectDeployRunDetailLazyQuery>;
export type ProjectDeployRunDetailQueryResult = Apollo.QueryResult<ProjectDeployRunDetailQuery, ProjectDeployRunDetailQueryVariables>;
export function refetchProjectDeployRunDetailQuery(variables: ProjectDeployRunDetailQueryVariables) {
      return { query: ProjectDeployRunDetailDocument, variables: variables }
    }
export const ResourceLogsDocument = gql`
    query resourceLogs($teamId: UUID!, $resourceId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    resource(id: $resourceId) {
      ...ResourceLogs
    }
  }
}
    ${ResourceLogsFragmentDoc}`;

/**
 * __useResourceLogsQuery__
 *
 * To run a query within a React component, call `useResourceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceLogsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useResourceLogsQuery(baseOptions: Apollo.QueryHookOptions<ResourceLogsQuery, ResourceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceLogsQuery, ResourceLogsQueryVariables>(ResourceLogsDocument, options);
      }
export function useResourceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceLogsQuery, ResourceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceLogsQuery, ResourceLogsQueryVariables>(ResourceLogsDocument, options);
        }
export type ResourceLogsQueryHookResult = ReturnType<typeof useResourceLogsQuery>;
export type ResourceLogsLazyQueryHookResult = ReturnType<typeof useResourceLogsLazyQuery>;
export type ResourceLogsQueryResult = Apollo.QueryResult<ResourceLogsQuery, ResourceLogsQueryVariables>;
export function refetchResourceLogsQuery(variables: ResourceLogsQueryVariables) {
      return { query: ResourceLogsDocument, variables: variables }
    }
export const CurrentUserDocument = gql`
    query currentUser @api(name: v1) {
  currentUser {
    id
    name
    login
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }
export const WorkflowRunsDocument = gql`
    query workflowRuns($teamId: UUID!, $projectId: UUID!, $page: PageInput!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        id
        runs(input: {page: $page, filter: {}}) {
          totalCount
          pageInfo {
            hasNextPage
          }
          nodes {
            ...WorkflowRunListItem
          }
        }
      }
    }
  }
}
    ${WorkflowRunListItemFragmentDoc}`;

/**
 * __useWorkflowRunsQuery__
 *
 * To run a query within a React component, call `useWorkflowRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useWorkflowRunsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowRunsQuery, WorkflowRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunsQuery, WorkflowRunsQueryVariables>(WorkflowRunsDocument, options);
      }
export function useWorkflowRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunsQuery, WorkflowRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunsQuery, WorkflowRunsQueryVariables>(WorkflowRunsDocument, options);
        }
export type WorkflowRunsQueryHookResult = ReturnType<typeof useWorkflowRunsQuery>;
export type WorkflowRunsLazyQueryHookResult = ReturnType<typeof useWorkflowRunsLazyQuery>;
export type WorkflowRunsQueryResult = Apollo.QueryResult<WorkflowRunsQuery, WorkflowRunsQueryVariables>;
export function refetchWorkflowRunsQuery(variables: WorkflowRunsQueryVariables) {
      return { query: WorkflowRunsDocument, variables: variables }
    }
export const WorkflowRunDetailDocument = gql`
    query workflowRunDetail($teamId: UUID!, $projectId: UUID!, $runId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        id
        run(id: $runId) {
          ...WorkflowRunDetail
        }
      }
    }
  }
}
    ${WorkflowRunDetailFragmentDoc}`;

/**
 * __useWorkflowRunDetailQuery__
 *
 * To run a query within a React component, call `useWorkflowRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useWorkflowRunDetailQuery(baseOptions: Apollo.QueryHookOptions<WorkflowRunDetailQuery, WorkflowRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunDetailQuery, WorkflowRunDetailQueryVariables>(WorkflowRunDetailDocument, options);
      }
export function useWorkflowRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunDetailQuery, WorkflowRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunDetailQuery, WorkflowRunDetailQueryVariables>(WorkflowRunDetailDocument, options);
        }
export type WorkflowRunDetailQueryHookResult = ReturnType<typeof useWorkflowRunDetailQuery>;
export type WorkflowRunDetailLazyQueryHookResult = ReturnType<typeof useWorkflowRunDetailLazyQuery>;
export type WorkflowRunDetailQueryResult = Apollo.QueryResult<WorkflowRunDetailQuery, WorkflowRunDetailQueryVariables>;
export function refetchWorkflowRunDetailQuery(variables: WorkflowRunDetailQueryVariables) {
      return { query: WorkflowRunDetailDocument, variables: variables }
    }
export const WorkflowDetailDocument = gql`
    query workflowDetail($teamId: UUID!, $projectId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        ...WorkflowDetail
      }
    }
  }
}
    ${WorkflowDetailFragmentDoc}`;

/**
 * __useWorkflowDetailQuery__
 *
 * To run a query within a React component, call `useWorkflowDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useWorkflowDetailQuery(baseOptions: Apollo.QueryHookOptions<WorkflowDetailQuery, WorkflowDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowDetailQuery, WorkflowDetailQueryVariables>(WorkflowDetailDocument, options);
      }
export function useWorkflowDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowDetailQuery, WorkflowDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowDetailQuery, WorkflowDetailQueryVariables>(WorkflowDetailDocument, options);
        }
export type WorkflowDetailQueryHookResult = ReturnType<typeof useWorkflowDetailQuery>;
export type WorkflowDetailLazyQueryHookResult = ReturnType<typeof useWorkflowDetailLazyQuery>;
export type WorkflowDetailQueryResult = Apollo.QueryResult<WorkflowDetailQuery, WorkflowDetailQueryVariables>;
export function refetchWorkflowDetailQuery(variables: WorkflowDetailQueryVariables) {
      return { query: WorkflowDetailDocument, variables: variables }
    }
export const WorkflowRunDetailLogsDocument = gql`
    query workflowRunDetailLogs($teamId: UUID!, $projectId: UUID!, $runId: UUID!, $stepId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        id
        run(id: $runId) {
          id
          step(id: $stepId) {
            id
            ... on JobRunStep {
              logs {
                id
                completed
                expired
                entries {
                  timestamp
                  text
                }
              }
            }
            ... on BuildRunStep {
              logs {
                id
                completed
                expired
                entries {
                  timestamp
                  text
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWorkflowRunDetailLogsQuery__
 *
 * To run a query within a React component, call `useWorkflowRunDetailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunDetailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunDetailLogsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      runId: // value for 'runId'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useWorkflowRunDetailLogsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowRunDetailLogsQuery, WorkflowRunDetailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunDetailLogsQuery, WorkflowRunDetailLogsQueryVariables>(WorkflowRunDetailLogsDocument, options);
      }
export function useWorkflowRunDetailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunDetailLogsQuery, WorkflowRunDetailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunDetailLogsQuery, WorkflowRunDetailLogsQueryVariables>(WorkflowRunDetailLogsDocument, options);
        }
export type WorkflowRunDetailLogsQueryHookResult = ReturnType<typeof useWorkflowRunDetailLogsQuery>;
export type WorkflowRunDetailLogsLazyQueryHookResult = ReturnType<typeof useWorkflowRunDetailLogsLazyQuery>;
export type WorkflowRunDetailLogsQueryResult = Apollo.QueryResult<WorkflowRunDetailLogsQuery, WorkflowRunDetailLogsQueryVariables>;
export function refetchWorkflowRunDetailLogsQuery(variables: WorkflowRunDetailLogsQueryVariables) {
      return { query: WorkflowRunDetailLogsDocument, variables: variables }
    }
export const WorkflowRunStepNestedDetailDocument = gql`
    query workflowRunStepNestedDetail($teamId: UUID!, $projectId: UUID!, $runId: UUID!, $stepId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        id
        run(id: $runId) {
          id
          step(id: $stepId) {
            id
            ... on DeployRunStep {
              workflowRun {
                id
                workflowId
                sequence
                status
                createdAt
                steps {
                  id
                  action
                  dependsOn {
                    id
                  }
                  status
                  sequenceNumber
                  createdAt
                  updatedAt
                  executionId
                  executionType
                  executionError
                }
              }
            }
            ... on DestroyRunStep {
              workflowRun {
                id
                workflowId
                sequence
                status
                createdAt
                steps {
                  id
                  action
                  dependsOn {
                    id
                  }
                  status
                  sequenceNumber
                  createdAt
                  updatedAt
                  executionId
                  executionType
                  executionError
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWorkflowRunStepNestedDetailQuery__
 *
 * To run a query within a React component, call `useWorkflowRunStepNestedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunStepNestedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunStepNestedDetailQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      runId: // value for 'runId'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useWorkflowRunStepNestedDetailQuery(baseOptions: Apollo.QueryHookOptions<WorkflowRunStepNestedDetailQuery, WorkflowRunStepNestedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunStepNestedDetailQuery, WorkflowRunStepNestedDetailQueryVariables>(WorkflowRunStepNestedDetailDocument, options);
      }
export function useWorkflowRunStepNestedDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunStepNestedDetailQuery, WorkflowRunStepNestedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunStepNestedDetailQuery, WorkflowRunStepNestedDetailQueryVariables>(WorkflowRunStepNestedDetailDocument, options);
        }
export type WorkflowRunStepNestedDetailQueryHookResult = ReturnType<typeof useWorkflowRunStepNestedDetailQuery>;
export type WorkflowRunStepNestedDetailLazyQueryHookResult = ReturnType<typeof useWorkflowRunStepNestedDetailLazyQuery>;
export type WorkflowRunStepNestedDetailQueryResult = Apollo.QueryResult<WorkflowRunStepNestedDetailQuery, WorkflowRunStepNestedDetailQueryVariables>;
export function refetchWorkflowRunStepNestedDetailQuery(variables: WorkflowRunStepNestedDetailQueryVariables) {
      return { query: WorkflowRunStepNestedDetailDocument, variables: variables }
    }
export const WorkflowRunStepNestedDetailLogsDocument = gql`
    query workflowRunStepNestedDetailLogs($teamId: UUID!, $projectId: UUID!, $runId: UUID!, $stepId: UUID!, $actionStepId: UUID!) @api(name: v1) {
  team(id: $teamId) {
    id
    project(id: $projectId) {
      id
      workflow {
        id
        run(id: $runId) {
          id
          step(id: $stepId) {
            id
            ... on DeployRunStep {
              workflowRun {
                id
                sequence
                status
                createdAt
                step(id: $actionStepId) {
                  id
                  ... on JobRunStep {
                    logs {
                      id
                      completed
                      expired
                      entries {
                        timestamp
                        text
                      }
                    }
                  }
                }
              }
            }
            ... on DestroyRunStep {
              workflowRun {
                id
                sequence
                status
                createdAt
                step(id: $actionStepId) {
                  id
                  ... on JobRunStep {
                    logs {
                      id
                      completed
                      expired
                      entries {
                        timestamp
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useWorkflowRunStepNestedDetailLogsQuery__
 *
 * To run a query within a React component, call `useWorkflowRunStepNestedDetailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunStepNestedDetailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunStepNestedDetailLogsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      runId: // value for 'runId'
 *      stepId: // value for 'stepId'
 *      actionStepId: // value for 'actionStepId'
 *   },
 * });
 */
export function useWorkflowRunStepNestedDetailLogsQuery(baseOptions: Apollo.QueryHookOptions<WorkflowRunStepNestedDetailLogsQuery, WorkflowRunStepNestedDetailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunStepNestedDetailLogsQuery, WorkflowRunStepNestedDetailLogsQueryVariables>(WorkflowRunStepNestedDetailLogsDocument, options);
      }
export function useWorkflowRunStepNestedDetailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunStepNestedDetailLogsQuery, WorkflowRunStepNestedDetailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunStepNestedDetailLogsQuery, WorkflowRunStepNestedDetailLogsQueryVariables>(WorkflowRunStepNestedDetailLogsDocument, options);
        }
export type WorkflowRunStepNestedDetailLogsQueryHookResult = ReturnType<typeof useWorkflowRunStepNestedDetailLogsQuery>;
export type WorkflowRunStepNestedDetailLogsLazyQueryHookResult = ReturnType<typeof useWorkflowRunStepNestedDetailLogsLazyQuery>;
export type WorkflowRunStepNestedDetailLogsQueryResult = Apollo.QueryResult<WorkflowRunStepNestedDetailLogsQuery, WorkflowRunStepNestedDetailLogsQueryVariables>;
export function refetchWorkflowRunStepNestedDetailLogsQuery(variables: WorkflowRunStepNestedDetailLogsQueryVariables) {
      return { query: WorkflowRunStepNestedDetailLogsDocument, variables: variables }
    }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BlueprintDriverConfiguration": [
      "BlueprintHelmConfiguration",
      "BlueprintManifestConfiguration",
      "BlueprintTerraformConfiguration"
    ],
    "CISource": [
      "DockerRepository",
      "GitHubRepository",
      "GitlabRepository"
    ],
    "CloudAccount": [
      "AWSAccount",
      "AzureAccount",
      "CoreWeaveAccount",
      "DOAccount",
      "GCPAccount",
      "LinodeAccount",
      "VultrAccount"
    ],
    "GitRepository": [
      "GitHubRepository",
      "GitlabRepository"
    ],
    "GroupOwner": [
      "Team"
    ],
    "Integration": [
      "DatadogIntegration",
      "DiscordIntegration",
      "DiscordWebhookIntegration",
      "GitlabIntegration",
      "SlackIntegration",
      "SlackWebhookIntegration"
    ],
    "ProfileOwner": [
      "BlueprintOwner",
      "User"
    ],
    "Resource": [
      "CertificateResource",
      "ContainerResource",
      "EndpointResource"
    ],
    "RevisableEntity": [
      "AWSAccountConfiguration",
      "AzureAccountConfiguration",
      "BlueprintConfiguration",
      "ClusterConfiguration",
      "CoreWeaveAccountConfiguration",
      "DOAccountConfiguration",
      "DeploymentConfiguration",
      "GCPAccountConfiguration",
      "LinodeAccountConfiguration",
      "VultrAccountConfiguration"
    ],
    "WorkflowRunStep": [
      "BuildRunStep",
      "ClusterPrecheckStep",
      "DeployRunStep",
      "DestroyRunStep",
      "JobRunStep"
    ]
  }
};
      export default result;
    